/* SLYDR — copy all of this into Assets/custom.js
   In layout/theme.liquid before </body>:
   <script src="{{ 'custom.js' | asset_url }}" defer></script>
*/

(function () {
  function start() {
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', start);
      return;
    }

    function slydrDeLocale() {
      var locale = '';
      if (window.Shopify && Shopify.locale) locale = String(Shopify.locale);
      if (!locale) {
        var htmlLang = document.documentElement.getAttribute('lang');
        if (htmlLang) locale = htmlLang;
      }
      if (!locale) {
        var path = window.location.pathname || '';
        if (/^\/de(\/|$)/i.test(path)) locale = 'de';
      }
      return locale.toLowerCase().slice(0, 2) === 'de';
    }

    /*
     * Cart wording: the theme carries Shopify's formal German ("Ihr
     * Warenkorb"). The language editor only reaches it per key, and the drawer
     * is re-rendered by the Section Rendering API after every add or remove,
     * so the informal wording is patched into the text nodes of every inserted
     * subtree instead. Phrases are matched in full, so an "Ihr" anywhere else
     * on the page stays untouched.
     */
    var slydrDuTexts = [
      [/Ihr Warenkorb ist leer/g, 'Dein Warenkorb ist leer'],
      [/Ihr Einkaufswagen ist leer/g, 'Dein Einkaufswagen ist leer'],
      [/Ihr Warenkorb/g, 'Dein Warenkorb'],
      [/Ihren Warenkorb/g, 'Deinen Warenkorb'],
      [/Ihrem Warenkorb/g, 'Deinem Warenkorb'],
      [/Ihres Warenkorbs/g, 'Deines Warenkorbs'],
      [/Ihr Einkaufswagen/g, 'Dein Einkaufswagen'],
      [/Ihren Einkaufswagen/g, 'Deinen Einkaufswagen'],
      [/Ihrem Einkaufswagen/g, 'Deinem Einkaufswagen']
    ];

    function slydrPatchDuText(node) {
      var text = node.nodeValue;
      if (!text || text.indexOf('Ihr') === -1) return;
      var next = text;
      for (var i = 0; i < slydrDuTexts.length; i++) {
        next = next.replace(slydrDuTexts[i][0], slydrDuTexts[i][1]);
      }
      if (next !== text) node.nodeValue = next;
    }

    function slydrPatchDuTree(root) {
      if (!root) return;
      if (root.nodeType === 3) {
        slydrPatchDuText(root);
        return;
      }
      if (root.nodeType !== 1 && root.nodeType !== 11) return;
      /* Skip known heavy subtrees that never hold cart copy. */
      if (
        root.nodeType === 1 &&
        (root.matches(
          'script, style, noscript, svg, canvas, [data-slydr-hero], .slydr-hero, [data-slydr-studio], .slydr-studio'
        ) ||
          root.closest(
            'script, style, noscript, svg, [data-slydr-hero], .slydr-hero, [data-slydr-studio], .slydr-studio'
          ))
      ) {
        return;
      }
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var node = walker.nextNode();
      while (node) {
        slydrPatchDuText(node);
        node = walker.nextNode();
      }
    }

    function slydrWatchDuTexts() {
      if (!slydrDeLocale()) return;
      slydrPatchDuTree(document.body);
      if (!window.MutationObserver) return;
      var pending = [];
      var raf = 0;
      function flush() {
        raf = 0;
        var list = pending;
        pending = [];
        for (var i = 0; i < list.length; i++) slydrPatchDuTree(list[i]);
      }
      var obs = new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) pending.push(added[j]);
        }
        if (!raf) raf = requestAnimationFrame(flush);
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }

    slydrWatchDuTexts();

    var slydrI18nEn = {
      comingSoon: 'Coming Soon',
      setupTitle: 'Setup preview',
      setupLead: 'Switch the pad color, drop your keyboard and mouse on it, then drag them into place.',
      desk: 'Desk',
      keyboard: 'Keyboard',
      mouse: 'Mouse',
      pad: 'Pad',
      light: 'Light',
      texture: 'Texture',
      wristRest: 'Wrist rest',
      cable: 'Cable',
      legend: 'Legend',
      left: 'Left',
      screen: 'Screen',
      width: 'Width',
      depth: 'Depth',
      rgbStatic: 'Static',
      rgbRainbow: 'Rainbow',
      rgbWave: 'Wave',
      rgbPulse: 'Pulse',
      customColor: 'Custom color',
      deskColor: 'Desk color',
      rgbColor: 'RGB color',
      mouseRgbColor: 'Mouse RGB color',
      roomRgbColor: 'Room RGB color',
      clickApply: 'Click to apply · Double-click to pick',
      dragKbCable: 'Drag keyboard cable',
      kbCableEnd: 'Keyboard cable end',
      dragMouseCable: 'Drag mouse cable',
      mouseCableEnd: 'Mouse cable end',
      leftHanded: 'Left-handed mouse',
      keyTypes: 'Key types',
      monitorGlow: 'Monitor glow from above',
      roomRgbLighting: 'Room RGB lighting',
      lightsOff: 'Lights: off',
      lightsMid: 'Lights: medium',
      lightsBright: 'Lights: bright',
      grid: 'Grid',
      gridTitle: '5 cm grid on the 900 × 400 mm pad',
      deskBlack: 'Black',
      deskWalnut: 'Walnut',
      deskOak: 'Oak',
      deskWhite: 'White',
      colorWhite: 'White',
      colorRed: 'Red',
      colorGreen: 'Green',
      colorPurple: 'Purple',
      colorOrange: 'Orange',
      padTest: 'Test',
      padTestTitle: 'Load a local print — stays in this browser, not uploaded',
      padTestAria: 'Load unpublished pad design',
      padTestDrop: 'Drop print here'
    };

    var slydrI18nDe = {
      comingSoon: 'Demnächst',
      setupTitle: 'Setup-Vorschau',
      setupLead: 'Wechsle die Padfarbe, setze Tastatur und Maus drauf und ziehe sie an ihren Platz.',
      desk: 'Tisch',
      keyboard: 'Tastatur',
      mouse: 'Maus',
      pad: 'Pad',
      light: 'Licht',
      texture: 'Textur',
      wristRest: 'Handballenauflage',
      cable: 'Kabel',
      legend: 'Legende',
      left: 'Links',
      screen: 'Bildschirm',
      width: 'Breite',
      depth: 'Tiefe',
      rgbStatic: 'Statisch',
      rgbRainbow: 'Regenbogen',
      rgbWave: 'Welle',
      rgbPulse: 'Puls',
      customColor: 'Eigene Farbe',
      deskColor: 'Tischfarbe',
      rgbColor: 'RGB-Farbe',
      mouseRgbColor: 'Maus-RGB',
      roomRgbColor: 'Raum-RGB',
      clickApply: 'Klick zum Übernehmen · Doppelklick zum Auswählen',
      dragKbCable: 'Tastaturkabel ziehen',
      kbCableEnd: 'Tastaturkabel',
      dragMouseCable: 'Mauskabel ziehen',
      mouseCableEnd: 'Mauskabel',
      leftHanded: 'Linkshänder-Maus',
      keyTypes: 'Tastentypen',
      monitorGlow: 'Monitorlicht von oben',
      roomRgbLighting: 'RGB-Raumlicht',
      lightsOff: 'Licht: aus',
      lightsMid: 'Licht: mittel',
      lightsBright: 'Licht: hell',
      grid: 'Raster',
      gridTitle: '5-cm-Raster auf dem 900 × 400 mm Pad',
      deskBlack: 'Schwarz',
      deskWalnut: 'Walnuss',
      deskOak: 'Eiche',
      deskWhite: 'Weiß',
      colorWhite: 'Weiß',
      colorRed: 'Rot',
      colorGreen: 'Grün',
      colorPurple: 'Lila',
      colorOrange: 'Orange',
      padTest: 'Test',
      padTestTitle: 'Lokales Druckbild laden — bleibt in diesem Browser, wird nicht hochgeladen',
      padTestAria: 'Unveröffentlichtes Pad-Design laden',
      padTestDrop: 'Druckbild hierher ziehen'
    };

    function slydrT(key) {
      var pack = slydrDeLocale() ? slydrI18nDe : slydrI18nEn;
      return pack[key] || slydrI18nEn[key] || key;
    }

    function slydrSwatchTitle(title) {
      var keys = {
        White: 'colorWhite',
        Red: 'colorRed',
        Green: 'colorGreen',
        Purple: 'colorPurple',
        Orange: 'colorOrange'
      };
      return keys[title] ? slydrT(keys[title]) : title;
    }

    function slydrApplyI18n(root) {
      root = root || document;
      root.querySelectorAll('[data-slydr-i18n]').forEach(function (el) {
        var key = el.getAttribute('data-slydr-i18n');
        if (key) el.textContent = slydrT(key);
      });
      root.querySelectorAll('[data-slydr-i18n-aria]').forEach(function (el) {
        var key = el.getAttribute('data-slydr-i18n-aria');
        if (key) el.setAttribute('aria-label', slydrT(key));
      });
      root.querySelectorAll('[data-slydr-i18n-title]').forEach(function (el) {
        var key = el.getAttribute('data-slydr-i18n-title');
        if (key) el.setAttribute('title', slydrT(key));
      });
    }

    slydrApplyI18n();

    if (
      document.body.classList.contains('template-collection') &&
      !document.querySelector('.slydr-stripes')
    ) {
      var stripes = document.createElement('div');
      stripes.className = 'slydr-stripes';
      document.body.appendChild(stripes);
    }

    function prepPreviewBar(bar) {
      if (!bar || bar.dataset.slydrPreview === '1') return;
      bar.dataset.slydrPreview = '1';
      bar.style.setProperty('z-index', '2147483646', 'important');
      bar.style.setProperty('overflow', 'visible', 'important');
      bar.style.setProperty('max-height', 'none', 'important');
      var closedH = bar.getBoundingClientRect().height || 56;
      bar.style.setProperty('height', closedH + 'px', 'important');
      bar.addEventListener('mouseenter', function () {
        bar.style.setProperty('height', '320px', 'important');
      });
      bar.addEventListener('mouseleave', function () {
        bar.style.setProperty('height', closedH + 'px', 'important');
      });
    }

    function scanPreviewBar() {
      prepPreviewBar(document.getElementById('preview-bar-iframe'));
      document
        .querySelectorAll('iframe[id*="preview-bar"], iframe[src*="preview_bar"], .shopify-preview-bar')
        .forEach(prepPreviewBar);
    }

    if (window.Shopify && Shopify.designMode) {
      scanPreviewBar();
      setTimeout(scanPreviewBar, 600);
      setTimeout(scanPreviewBar, 1800);
    }

    function comingSoonRelabel(root) {
      root = root || document;
      var exact = /^\s*(sold[\s-]*out|ausverkauft|unavailable|nicht\s+verf(?:ü|ue)gbar|out of stock)\s*$/i;
      var phrase = /\b(sold[\s-]*out|ausverkauft|unavailable|nicht\s+verf(?:ü|ue)gbar|out of stock)\b/gi;
      var label = slydrT('comingSoon');
      var selectors =
        '.badge, [class*="badge"], .button, button, [class*="soldout"], [class*="sold-out"], .product-form__submit, [aria-disabled="true"]';
      root.querySelectorAll(selectors).forEach(function (el) {
        if (el.closest('script, style, noscript')) return;
        var raw = (el.textContent || '').replace(/\s+/g, ' ').trim();
        phrase.lastIndex = 0;
        var attrHit = false;
        ['aria-label', 'title'].forEach(function (attr) {
          var value = el.getAttribute(attr);
          if (!value) return;
          phrase.lastIndex = 0;
          if (!phrase.test(value)) return;
          phrase.lastIndex = 0;
          el.setAttribute(attr, value.replace(phrase, label));
          attrHit = true;
        });
        if (!raw && !attrHit) return;
        phrase.lastIndex = 0;
        if (raw && !phrase.test(raw) && !attrHit) return;
        phrase.lastIndex = 0;
        el.classList.add('slydr-coming-soon');
        var card = el.closest(
          '.product-card-wrapper, .card-wrapper, .card-product, .product-card, product-card, .product-item'
        );
        if (card) card.classList.add('slydr-coming-soon-card');
        if (!raw) return;
        if (el.childElementCount === 0) {
          el.textContent = exact.test(raw) ? label : raw.replace(phrase, label);
          return;
        }
        var texts = [];
        var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
        while (walker.nextNode()) texts.push(walker.currentNode);
        texts.forEach(function (tn) {
          if (!tn.nodeValue) return;
          phrase.lastIndex = 0;
          if (!phrase.test(tn.nodeValue)) return;
          phrase.lastIndex = 0;
          tn.nodeValue = tn.nodeValue.replace(phrase, label);
        });
      });
    }

    /*
     * Theme badges can land late; one deferred pass covers most apps without
     * sweeping every button on the page three times at boot.
     */
    comingSoonRelabel(document.getElementById('MainContent') || document);
    setTimeout(function () {
      comingSoonRelabel(document.getElementById('MainContent') || document);
    }, 900);

    (function productReadProgress() {
      if (!document.body.classList.contains('template-product')) return;

      var hosts = [];
      var seen = {};
      [
        document.getElementById('header-component'),
        document.querySelector('#header-group .header'),
        document.querySelector('.header-mobile')
      ].forEach(function (el) {
        if (!el || seen[el]) return;
        seen[el] = true;
        hosts.push(el);
      });
      if (!hosts.length) return;

      var fills = [];
      hosts.forEach(function (el) {
        var bar = el.querySelector(':scope > .slydr-read-progress');
        if (!bar) {
          bar = document.createElement('div');
          bar.className = 'slydr-read-progress';
          bar.setAttribute('aria-hidden', 'true');
          bar.appendChild(document.createElement('span'));
          el.appendChild(bar);
        }
        var fill = bar.querySelector(':scope > span');
        if (fill) fills.push(fill);
      });

      var ticking = false;
      var lastRead = -1;
      /*
       * Written straight onto the bars: a custom property on <html> would
       * invalidate the computed style of every element on the page per frame.
       */
      function update() {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        var p = max > 0 ? window.scrollY / max : 0;
        if (p < 0) p = 0;
        if (p > 1) p = 1;
        p = Math.round(p * 500) / 500;
        if (p === lastRead) return;
        lastRead = p;
        var t = 'scaleX(' + p + ')';
        for (var i = 0; i < fills.length; i++) fills[i].style.transform = t;
      }
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          update();
        });
      }
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    })();

    var cards = document.querySelectorAll('.product-card-wrapper, .card-wrapper');

    function findGrid(cardList) {
      if (!cardList.length) return null;
      var el = cardList[0].parentElement;
      while (el && el !== document.body) {
        var n = 0;
        for (var i = 0; i < cardList.length; i++) {
          if (el.contains(cardList[i])) n += 1;
        }
        if (n === cardList.length && el.id !== 'MainContent' && el.tagName !== 'MAIN') {
          return el;
        }
        el = el.parentElement;
      }
      return null;
    }

    var grid = document.querySelector('.product-grid, [class*="product-grid"]') || findGrid(cards);
    var isHome = document.body.classList.contains('template-index');

    if (grid && !grid.closest('.slydr-neon-frame')) {
      if (isHome) {
        var wrap = document.createElement('div');
        wrap.className = 'slydr-neon-frame slydr-neon-frame--home';
        grid.parentNode.insertBefore(wrap, grid);
        wrap.appendChild(grid);
      } else {
        grid.classList.add('slydr-neon-frame');
      }
    }

    if (isHome) {
      document.querySelectorAll('.slydr-neon-frame').forEach(function (frame) {
        if (frame.querySelector('.slydr-stripes--local')) return;
        var local = document.createElement('div');
        local.className = 'slydr-stripes slydr-stripes--local';
        frame.appendChild(local);
      });
    }

    var logoRColors = [
      { test: /shock|\bblue\b|blau/, color: '#3BA7FF' },
      { test: /nova|\bpink\b/, color: '#EF0E8A' },
      { test: /arctic|\bwhite\b|weiss|weiß/, color: '#b7b7b7' },
      { test: /storm|\bblack\b|schwarz/, color: '#676767' }
    ];
    var logoRDefault = '#EF0E8A';

    function colorFromText(text) {
      text = (text || '').toLowerCase();
      for (var i = 0; i < logoRColors.length; i += 1) {
        if (logoRColors[i].test.test(text)) return logoRColors[i].color;
      }
      return logoRDefault;
    }

    function padSwatchHex(text) {
      var lower = (text || '').toLowerCase();
      if (/arctic|\bwhite\b|weiss|weiß/.test(lower)) return '#d6d6d6';
      if (/storm|\bblack\b|schwarz/.test(lower)) return '#111111';
      return colorFromText(text);
    }

    var faviconLink = null;
    var faviconImg = new Image();
    var faviconBox = { w: 268, h: 174 };
    var lastFaviconColor = '';
    faviconImg.onload = function () {
      var size = 128;
      var pad = 4;
      var canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, size, size);
      var avail = size - pad * 2;
      var scale = Math.min(avail / faviconBox.w, avail / faviconBox.h);
      var dw = faviconBox.w * scale;
      var dh = faviconBox.h * scale;
      ctx.drawImage(faviconImg, (size - dw) / 2, (size - dh) / 2, dw, dh);
      var href = canvas.toDataURL('image/png');
      if (!faviconLink) {
        faviconLink = document.querySelector('link[rel="icon"]');
        if (!faviconLink) {
          faviconLink = document.createElement('link');
          faviconLink.rel = 'icon';
          document.head.appendChild(faviconLink);
        }
      }
      faviconLink.type = 'image/png';
      faviconLink.href = href;
    };

    function setFavicon(color) {
      if (color === lastFaviconColor) return;
      lastFaviconColor = color;
      var svg =
        '<svg xmlns="http://www.w3.org/2000/svg" width="' +
        faviconBox.w +
        '" height="' +
        faviconBox.h +
        '" viewBox="714 -6 268 174" preserveAspectRatio="xMidYMid meet">' +
        '<polygon fill="' +
        color +
        '" points="768.25 77.67 719.77 161.63 779.36 161.63 816.98 96.47 882.15 161.63 941.73 161.63 857.77 77.67 768.25 77.67"/>' +
        '<path fill="' +
        color +
        '" d="M819.76,45.85L774.02,0h148.95c42.26,0,54.64,24.3,30.24,66.56l-9.7,16.8h-59.59l7.63-13.21c10.37-17.96,3.46-24.3-14.5-24.3h-57.29Z"/>' +
        '</svg>';
      faviconImg.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
    }

    function accentGlow(color) {
      var hex = String(color || '#EF0E8A').replace('#', '');
      if (hex.length === 3) {
        hex = hex.charAt(0) + hex.charAt(0) + hex.charAt(1) + hex.charAt(1) + hex.charAt(2) + hex.charAt(2);
      }
      var n = parseInt(hex, 16);
      if (isNaN(n)) return 'rgba(239, 14, 138, 0.7)';
      return (
        'rgba(' +
        ((n >> 16) & 255) +
        ', ' +
        ((n >> 8) & 255) +
        ', ' +
        (n & 255) +
        ', 0.7)'
      );
    }

    var lastLogoRColor = '';
    var accentGlobalsHandle = 0;
    var pendingAccentColor = '';

    function applyLogoRFill(color) {
      document.querySelectorAll('[data-slydr-r]').forEach(function (el) {
        el.setAttribute('fill', color);
        el.style.fill = color;
      });
    }

    /*
     * Custom properties on <html> invalidate the computed style of the whole
     * document, and the favicon needs a canvas re-encode. Both are far too
     * heavy to run inside an animation, so they wait for an idle slot.
     */
    function scheduleAccentGlobals(color) {
      pendingAccentColor = color;
      if (accentGlobalsHandle) return;
      var run = function () {
        accentGlobalsHandle = 0;
        var next = pendingAccentColor;
        document.documentElement.style.setProperty('--slydr-accent', next);
        document.documentElement.style.setProperty(
          '--slydr-accent-glow',
          accentGlow(next)
        );
        setFavicon(next);
      };
      if ('requestIdleCallback' in window) {
        accentGlobalsHandle = requestIdleCallback(run, { timeout: 900 });
      } else {
        accentGlobalsHandle = window.setTimeout(run, 240);
      }
    }

    function setLogoR(color) {
      var next = String(color || '').trim();
      if (!next) return;
      if (next === lastLogoRColor) return;
      lastLogoRColor = next;
      applyLogoRFill(next);
      scheduleAccentGlobals(next);
    }

    function markLogoR(svg) {
      if (!svg) return;
      svg.querySelectorAll('[data-slydr-r]').forEach(function (el) {
        el.removeAttribute('data-slydr-r');
      });
      svg.querySelectorAll('polygon[fill], path[fill]').forEach(function (el) {
        var fill = (el.getAttribute('fill') || '').toLowerCase();
        if (fill === '#ef0e8a' || fill === '#ef0f8a') {
          el.setAttribute('data-slydr-r', '1');
        }
      });
    }

    var logoWhite =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 942 161.63" preserveAspectRatio="xMinYMid meet"><g><polygon fill="#ef0e8a" points="768.25 77.67 719.77 161.63 779.36 161.63 816.98 96.47 882.15 161.63 941.73 161.63 857.77 77.67 768.25 77.67"/><path fill="#ef0e8a" d="M819.76,45.85L774.02,0h148.95c42.26,0,54.64,24.3,30.24,66.56l-9.7,16.8h-59.59l7.63-13.21c10.37-17.96,3.46-24.3-14.5-24.3h-57.29Z"/></g><polygon fill="#fff" points="470.03 51.95 439.03 103.9 379.04 0 438.7 0 470.03 51.95"/><polygon fill="#fff" points="259.93 161.63 200.27 161.63 293.58 0 353.24 0 259.93 161.63"/><polygon fill="#fff" points="404.77 161.63 279.95 161.63 306.3 115.99 431.12 115.99 404.77 161.63"/><polygon fill="#fff" points="484.05 161.63 424.29 161.63 517.61 0 577.36 0 484.05 161.63"/><path fill="#fff" d="M724.23,0h-126.72l-26.5,45.91h107.26c17.98,0,24.9,6.35,14.51,24.33l-12.21,21.16c-10.38,17.98-24.62,24.33-42.61,24.33h-47.6l18.85-32.65h-59.66l-45.36,78.56h126.72c42.31,0,81.82-22.64,106.25-64.95l17.34-30.04C778.93,24.33,766.54,0,724.23,0Z"/><path fill="#fff" d="M162.53,161.63H9.94c-9.51,0-12.77-7.71-7.28-17.22l23.04-39.9h59.66l-9.53,16.5h67.7l3.91-6.77-95.87-35.12c-7.21-2.54-6.82-7.62-1.93-16.08l26.46-45.83C81.59,7.71,93.75,0,103.26,0h126.76C253.79,0,261.93,19.27,248.21,43.04l-5.93,10.27h-59.66,0c4.05-7.01,1.65-12.69-5.36-12.69h-55s-3.79,6.56-3.79,6.56l95.9,34.69c7.21,2.54,6.78,8.04,1.9,16.5l-26.58,46.04c-5.49,9.51-17.65,17.22-27.15,17.22Z"/></svg>';
    var logoBlack =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 942 161.63" preserveAspectRatio="xMinYMid meet"><g><polygon fill="#ef0e8a" points="768.25 77.67 719.77 161.63 779.36 161.63 816.98 96.47 882.15 161.63 941.73 161.63 857.77 77.67 768.25 77.67"/><path fill="#ef0e8a" d="M819.76,45.85L774.02,0h148.95c42.26,0,54.64,24.3,30.24,66.56l-9.7,16.8h-59.59l7.63-13.21c10.37-17.96,3.46-24.3-14.5-24.3h-57.29Z"/></g><polygon fill="#000" points="470.03 51.95 439.03 103.9 379.04 0 438.7 0 470.03 51.95"/><polygon fill="#000" points="259.93 161.63 200.27 161.63 293.58 0 353.24 0 259.93 161.63"/><polygon fill="#000" points="404.77 161.63 279.95 161.63 306.3 115.99 431.12 115.99 404.77 161.63"/><polygon fill="#000" points="484.05 161.63 424.29 161.63 517.61 0 577.36 0 484.05 161.63"/><path fill="#000" d="M724.23,0h-126.72l-26.5,45.91h107.26c17.98,0,24.9,6.35,14.51,24.33l-12.21,21.16c-10.38,17.98-24.62,24.33-42.61,24.33h-47.6l18.85-32.65h-59.66l-45.36,78.56h126.72c42.31,0,81.82-22.64,106.25-64.95l17.34-30.04C778.93,24.33,766.54,0,724.23,0Z"/><path fill="#000" d="M162.53,161.63H9.94c-9.51,0-12.77-7.71-7.28-17.22l23.04-39.9h59.66l-9.53,16.5h67.7l3.91-6.77-95.87-35.12c-7.21-2.54-6.82-7.62-1.93-16.08l26.46-45.83C81.59,7.71,93.75,0,103.26,0h126.76C253.79,0,261.93,19.27,248.21,43.04l-5.93,10.27h-59.66,0c4.05-7.01,1.65-12.69-5.36-12.69h-55s-3.79,6.56-3.79,6.56l95.9,34.69c7.21,2.54,6.78,8.04,1.9,16.5l-26.58,46.04c-5.49,9.51-17.65,17.22-27.15,17.22Z"/></svg>';

    function padLogoViewBox(svg) {
      var vb = (svg.getAttribute('viewBox') || '0 0 942 161.63')
        .trim()
        .split(/[\s,]+/)
        .map(Number);
      if (vb.length !== 4 || vb.some(function (n) { return isNaN(n); })) return;
      if (svg.dataset.slydrPad === '1') return;
      svg.dataset.slydrPad = '1';
      svg.setAttribute(
        'viewBox',
        vb[0] + ' ' + vb[1] + ' ' + (vb[2] + Math.max(vb[2] * 0.04, 28)) + ' ' + vb[3]
      );
      svg.setAttribute('preserveAspectRatio', 'xMinYMid meet');
    }

    function svgFromMarkup(markup) {
      var parsed = new DOMParser().parseFromString(markup, 'image/svg+xml');
      var node = parsed.documentElement;
      if (!node || node.tagName.toLowerCase() !== 'svg') return null;
      var svg = document.importNode(node, true);
      svg.removeAttribute('id');
      svg.classList.add('slydr-logo-svg');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      padLogoViewBox(svg);
      markLogoR(svg);
      return svg;
    }

    function mountLogoSvg(img, svg) {
      var box = img.closest('.header-logo__image-container') || img.parentElement;
      if (!box || !svg || box.querySelector(':scope > .slydr-logo-svg')) return;
      box.classList.add('slydr-logo-live');
      box.appendChild(svg);
      /* Fresh [data-slydr-r] nodes — paint with the last known accent. */
      if (lastLogoRColor) applyLogoRFill(lastLogoRColor);
    }

    function fallbackLogoMarkup(img) {
      var src = (img.currentSrc || img.src || '').toLowerCase();
      if (
        img.closest('.header-logo__image-container--inverse') ||
        /black/.test(src)
      ) {
        return logoBlack;
      }
      return logoWhite;
    }

    function inlineHeaderLogos() {
      document
        .querySelectorAll(
          '#header-group .header-logo__image-container svg, #header-group .header__heading-link > svg'
        )
        .forEach(function (svg) {
          svg.classList.add('slydr-logo-svg');
          padLogoViewBox(svg);
          markLogoR(svg);
        });

      document
        .querySelectorAll('#header-group img.header-logo__image')
        .forEach(function (img) {
          if (img.dataset.slydrLogo === '1') return;
          img.dataset.slydrLogo = '1';
          var src = img.currentSrc || img.src;
          var looksSvg = /\.svg(\?|$)/i.test(src || '');
          if (looksSvg) {
            fetch(src, { mode: 'cors', credentials: 'omit' })
              .then(function (res) {
                return res.ok ? res.text() : Promise.reject();
              })
              .then(function (text) {
                if (text.indexOf('<svg') === -1) throw new Error('not svg');
                var svg = svgFromMarkup(text);
                if (!svg) throw new Error('parse');
                mountLogoSvg(img, svg);
                setLogoR(colorFromText(pageText));
              })
              .catch(function () {
                mountLogoSvg(img, svgFromMarkup(fallbackLogoMarkup(img)));
                setLogoR(colorFromText(pageText));
              });
            return;
          }
          mountLogoSvg(img, svgFromMarkup(fallbackLogoMarkup(img)));
        });
    }

    var pageText = location.pathname + ' ' + document.title;
    var heading = document.querySelector('h1');
    if (heading) pageText += ' ' + heading.textContent;
    inlineHeaderLogos();
    setLogoR(colorFromText(pageText));

    function shopRoot() {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) {
        return String(Shopify.routes.root).replace(/\/$/, '');
      }
      var match = location.pathname.match(/^(.*)\/products\//);
      return match ? match[1] : '';
    }

    function isCurrent(handle) {
      var path = decodeURIComponent(location.pathname);
      return path.indexOf('/products/' + handle) !== -1;
    }

    var slydrPads = [
      { handle: 'pad-liquidcolor-novapink', title: 'Nova Pink' },
      { handle: 'pad-liquidcolor-shockblue', title: 'Shock Blue' },
      { handle: 'pad-liquidcolor-arcticwhite', title: 'Arctic White' },
      { handle: 'pad-liquidcolor-stormblack', title: 'Storm Black' }
    ];

    var colorwayItems = null;
    var colorwayBusy = false;
    var colorwayHtml = {};

    function prefetchColorway(url) {
      if (!url || colorwayHtml[url]) return;
      colorwayHtml[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error();
          return res.text();
        })
        .catch(function () {
          delete colorwayHtml[url];
        });
    }

    function productHref(handle) {
      return shopRoot() + '/products/' + encodeURIComponent(handle);
    }

    function colorwayName(text) {
      text = (text || '').toLowerCase();
      if (/shock|\bblue\b|blau/.test(text)) return 'Shock Blue';
      if (/nova|\bpink\b/.test(text)) return 'Nova Pink';
      if (/arctic|\bwhite\b|weiss|weiß/.test(text)) return 'Arctic White';
      if (/storm|\bblack\b|schwarz/.test(text)) return 'Storm Black';
      return text;
    }

    function colorwaySortIndex(item) {
      var text = (item.title + ' ' + item.handle).toLowerCase();
      if (/nova|\bpink\b/.test(text)) return 0;
      if (/shock|\bblue\b|blau/.test(text)) return 1;
      if (/arctic|\bwhite\b|weiss|weiß/.test(text)) return 2;
      if (/storm|\bblack\b|schwarz/.test(text)) return 3;
      return 9;
    }

    function refreshPageAccent() {
      pageText = location.pathname + ' ' + document.title;
      var heading = document.querySelector('h1');
      if (heading) pageText += ' ' + heading.textContent;
      setLogoR(colorFromText(pageText));
    }

    function sameProductPath(url) {
      try {
        var dest = new URL(url, location.origin);
        return decodeURIComponent(dest.pathname) === decodeURIComponent(location.pathname);
      } catch (err) {
        return false;
      }
    }

    var slydrJdgmSeq = 0;

    function refreshJudgeMeCaches() {
      if (!window.jdgm || !jdgm.$) return;
      jdgm.caches = jdgm.caches || {};
      jdgm.caches.$prevBadges = jdgm.$('.jdgm-preview-badge');
      jdgm.caches.$revWidgets = jdgm.$('.jdgm-review-widget, [data-widget="review"]');
      jdgm.caches.$widgetWithReviews = jdgm.$(
        '.jdgm-review-widget, .jdgm-revs-tab, .jdgm-all-reviews-widget'
      );
    }

    function remountJudgeMeBadges() {
      if (!window.jdgm || !jdgm.$ || typeof jdgm.customizeBadges !== 'function') return;
      var doneClass = jdgm.DONE_SETUP_CLASS || 'jdgm--done-setup';
      var $badges = jdgm.$('.jdgm-preview-badge').removeClass(doneClass);
      if (!$badges.length) return;
      jdgm.customizeBadges($badges);
    }

    function slydrJudgeMeManagerUrl() {
      try {
        var entries = performance.getEntriesByType('resource');
        for (var i = 0; i < entries.length; i++) {
          if (/\/ReviewWidgetManager-[^/?#]+\.js/.test(entries[i].name)) {
            return entries[i].name.split('?')[0];
          }
        }
      } catch (err) {}
      return '';
    }

    function remountJudgeMeReviewWidgets() {
      var seq = ++slydrJdgmSeq;
      var nodes = Array.prototype.slice
        .call(document.querySelectorAll('.jdgm-review-widget[data-entry-point]'))
        .filter(function (el) {
          return !el.getAttribute('data-slydr-jdgm');
        });

      function legacyInit() {
        if (window.jdgm && typeof jdgm.initializeWidgets === 'function') {
          jdgm.initializeWidgets(document.body);
        }
      }

      if (!nodes.length) {
        legacyInit();
        return;
      }

      var base = window.jdgm && jdgm.CDN_BASE_URL;
      if (!base) {
        legacyInit();
        return;
      }

      function mount(Manager) {
        if (seq !== slydrJdgmSeq || !Manager) return;
        nodes.forEach(function (el) {
          if (!el.isConnected || el.getAttribute('data-slydr-jdgm')) return;
          el.setAttribute('data-slydr-jdgm', '1');
          try {
            var mgr = new Manager(el);
            Promise.resolve(mgr.initialize()).catch(function () {});
          } catch (err) {}
        });
      }

      function loadManager(url) {
        return import(url).then(function (mod) {
          mount(mod && (mod.ReviewWidgetManager || mod.default));
        });
      }

      var cached = slydrJudgeMeManagerUrl();
      var boot = cached
        ? loadManager(cached)
        : fetch(base + 'review_widget.js', { credentials: 'omit' })
            .then(function (res) {
              if (!res.ok) throw new Error('review_widget');
              return res.text();
            })
            .then(function (code) {
              var match = code.match(/from\s*["'](\.\/ReviewWidgetManager-[^"']+)["']/);
              if (!match) throw new Error('manager');
              return loadManager(base + match[1].replace(/^\.\//, ''));
            });

      boot.catch(function () {
        if (seq !== slydrJdgmSeq) return;
        legacyInit();
      });
    }

    function reloadJudgeMe(attempt) {
      attempt = attempt || 0;
      if (!window.jdgm || !jdgm.$) {
        if (attempt < 12) {
          window.setTimeout(function () {
            reloadJudgeMe(attempt + 1);
          }, 120);
        }
        return;
      }
      refreshJudgeMeCaches();
      remountJudgeMeBadges();
      remountJudgeMeReviewWidgets();
    }

    function initProductPage() {
      slydrApplyI18n();
      initColorwayBar();
      initPadStudio();
      initProductMediaGlow();
      initTrophyTomPulse();
      comingSoonRelabel(document.getElementById('MainContent') || document);
      reloadJudgeMe();
    }

    function applyColorwayDoc(doc, url, historyMode) {
      var nextMain = doc.querySelector('#MainContent');
      var curMain = document.querySelector('#MainContent');
      if (!nextMain || !curMain) throw new Error('no main');

      function apply() {
        document.adoptNode(nextMain);
        curMain.replaceWith(nextMain);
        document.title = doc.title;
        var nextCanon = doc.querySelector('link[rel="canonical"]');
        var curCanon = document.querySelector('link[rel="canonical"]');
        if (nextCanon && curCanon) {
          curCanon.setAttribute('href', nextCanon.getAttribute('href'));
        }
        if (historyMode === 'push') {
          if (!history.state || !history.state.slydrColorway) {
            history.replaceState({ slydrColorway: 1 }, '', location.href);
          }
          history.pushState({ slydrColorway: 1 }, '', url);
        }
        refreshPageAccent();
        initProductPage();
        nextMain.querySelectorAll('.shopify-section').forEach(function (section) {
          document.dispatchEvent(
            new CustomEvent('shopify:section:load', {
              bubbles: true,
              detail: { sectionId: String(section.id || '').replace(/^shopify-section-/, '') }
            })
          );
        });
      }

      if (
        document.startViewTransition &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        try {
          return document.startViewTransition(apply).finished.catch(function () {});
        } catch (err) {
          apply();
          return Promise.resolve();
        }
      }

      curMain.classList.add('slydr-colorway-fade');
      curMain.style.opacity = '0';
      return new Promise(function (resolve) {
        window.setTimeout(function () {
          apply();
          var main = document.querySelector('#MainContent');
          if (main) {
            main.classList.add('slydr-colorway-fade');
            main.style.opacity = '0';
            void main.offsetHeight;
            main.style.opacity = '1';
            window.setTimeout(function () {
              main.classList.remove('slydr-colorway-fade');
              main.style.opacity = '';
            }, 340);
          }
          resolve();
        }, 200);
      });
    }

    function swapColorway(url, historyMode) {
      if (colorwayBusy) return Promise.resolve();
      var dest;
      try {
        dest = new URL(url, location.origin);
      } catch (err) {
        location.href = url;
        return Promise.resolve();
      }
      if (historyMode !== 'none' && sameProductPath(dest.href)) {
        return Promise.resolve();
      }
      colorwayBusy = true;
      document.documentElement.classList.add('slydr-colorway-busy');
      var load = colorwayHtml[dest.href] || fetch(dest.href, { credentials: 'same-origin' }).then(function (res) {
        if (!res.ok) throw new Error();
        return res.text();
      });
      return Promise.resolve(load)
        .then(function (html) {
          if (!html) throw new Error();
          colorwayHtml[dest.href] = Promise.resolve(html);
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return applyColorwayDoc(doc, dest.pathname + dest.search + dest.hash, historyMode || 'push');
        })
        .catch(function () {
          location.href = dest.href;
        })
        .then(function () {
          colorwayBusy = false;
          document.documentElement.classList.remove('slydr-colorway-busy');
        });
    }

    function bindColorwayPopstate() {
      if (window.__slydrColorwayPop) return;
      window.__slydrColorwayPop = true;
      window.addEventListener('popstate', function () {
        if (!document.body.classList.contains('template-product')) return;
        if (!/\/products\//.test(location.pathname)) {
          location.reload();
          return;
        }
        swapColorway(location.href, 'none');
      });
    }

    function mountColorway(items) {
      if (!items || items.length < 2) return;
      if (document.querySelector('.slydr-loadout')) return;
      var title = document.querySelector(
        '#MainContent .product__title, #MainContent .product-title, #MainContent .product-info h1, #MainContent product-info h1, #MainContent h1, main .product__title, main h1'
      );
      if (!title) return;

      var bar = document.createElement('div');
      bar.className = 'slydr-loadout';

      items
        .slice()
        .sort(function (a, b) {
          return colorwaySortIndex(a) - colorwaySortIndex(b);
        })
        .forEach(function (item) {
          var text = item.title + ' ' + item.handle;
          var accent = colorFromText(text);
          var swatch = padSwatchHex(text);
          var current = isCurrent(item.handle);
          var node = document.createElement('a');
          node.className = 'slydr-loadout__swatch' + (current ? ' is-on' : '');
          node.style.setProperty('--slydr-swatch', swatch);
          if (swatch === '#d6d6d6') {
            node.classList.add('slydr-loadout__swatch--light');
          }
          if (swatch === '#111111') {
            node.classList.add('slydr-loadout__swatch--dark');
          }
          node.setAttribute('title', colorwayName(item.title));
          node.setAttribute('aria-label', colorwayName(item.title));
          node.href = productHref(item.handle);
          if (current) {
            node.setAttribute('aria-current', 'page');
          }
          node.addEventListener('mouseenter', function () {
            setLogoR(accent);
            if (!current) prefetchColorway(node.href);
          });
          node.addEventListener('mouseleave', function () {
            setLogoR(colorFromText(pageText));
          });
          node.addEventListener('click', function (event) {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) {
              return;
            }
            event.preventDefault();
            if (current) return;
            swapColorway(node.href);
          });
          bar.appendChild(node);
        });

      var host = title;
      if (title.parentElement && title.parentElement.children.length === 1) {
        host = title.parentElement;
      }
      host.parentNode.insertBefore(bar, host.nextSibling);
    }

    function initColorwayBar() {
      if (!document.body.classList.contains('template-product')) return;
      bindColorwayPopstate();
      if (document.querySelector('.slydr-loadout')) return;
      colorwayItems = colorwayItems || slydrPads;
      mountColorway(colorwayItems);
    }

    initColorwayBar();

    function initPadStudio() {
      var root = document.querySelector('[data-slydr-studio]');
      if (!root) return;

      if (window.matchMedia('(max-width: 749px)').matches) {
        root.querySelectorAll('[data-studio-collapse="mobile"]').forEach(function (el) {
          el.removeAttribute('open');
        });
      }

      var stage = root.querySelector('[data-studio-stage]');
      var padSlot = root.querySelector('[data-studio-pad-slot]') || stage;
      var padImg = root.querySelector('[data-studio-pad]');
      var kbEl = root.querySelector('[data-studio-kb]');
      var mouseEl = root.querySelector('[data-studio-mouse]');
      var cablesSvg = root.querySelector('[data-studio-cables]');
      var kbAnchorEl = root.querySelector('[data-cable-anchor="kb"]');
      var mouseAnchorEl = root.querySelector('[data-cable-anchor="mouse"]');
      var padHost = root.querySelector('[data-studio-pads]');
      var deskEl = root.querySelector('[data-studio-desk]');
      var deskHost = root.querySelector('[data-studio-desks]');
      var screenEl = root.querySelector('[data-studio-screen]');
      var roomEl = root.querySelector('[data-studio-room]');
      var kbWInput = root.querySelector('[data-kb-w]');
      var kbDInput = root.querySelector('[data-kb-d]');
      if (!stage || !padImg || !kbEl || !mouseEl || !padHost) return;

      var testBtn = null;
      var testPadUrl = '';

      function studioPadTestOn() {
        try {
          var q = new URLSearchParams(location.search);
          var flag = q.get('slydr-pad-test') || q.get('padtest');
          if (flag === '0') {
            localStorage.removeItem('slydrPadTest');
            return false;
          }
          if (flag === '1') {
            localStorage.setItem('slydrPadTest', '1');
            return true;
          }
        } catch (err) {}
        if (window.Shopify && Shopify.designMode) return true;
        try {
          return localStorage.getItem('slydrPadTest') === '1';
        } catch (err2) {
          return false;
        }
      }

      var padTestOn = studioPadTestOn();
      if (padTestOn) root.classList.add('slydr-studio--pad-test');

      function absUrl(url) {
        if (!url) return '';
        if (url.indexOf('//') === 0) return 'https:' + url;
        return url;
      }

      function pickPlain(product) {
        var images = product.images || [];
        var i;
        for (i = 0; i < images.length; i += 1) {
          var url = typeof images[i] === 'string' ? images[i] : images[i].src || '';
          if (/plain/i.test(url)) return absUrl(url);
        }
        return absUrl(product.featured_image || images[0] || '');
      }

      var opaquePadCache = {};
      var padShowSeq = 0;

      function cropOpaquePad(image) {
        var w = image.naturalWidth || image.width;
        var h = image.naturalHeight || image.height;
        if (!w || !h) return null;
        var src = document.createElement('canvas');
        src.width = w;
        src.height = h;
        var ctx = src.getContext('2d', { willReadFrequently: true });
        if (!ctx) return null;
        ctx.drawImage(image, 0, 0);
        var data;
        try {
          data = ctx.getImageData(0, 0, w, h).data;
        } catch (err) {
          return null;
        }
        /* Skip drop-shadow (low alpha). Solid pad pixels only. */
        var minA = 128;
        var minX = w;
        var minY = h;
        var maxX = 0;
        var maxY = 0;
        var x;
        var y;
        var i;
        for (y = 0; y < h; y += 2) {
          for (x = 0; x < w; x += 2) {
            i = (y * w + x) * 4;
            if (data[i + 3] < minA) continue;
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
          }
        }
        if (maxX <= minX || maxY <= minY) return null;
        var bw = maxX - minX + 1;
        var bh = maxY - minY + 1;
        if (bw * bh > w * h * 0.92) return null;
        var out = document.createElement('canvas');
        out.width = bw;
        out.height = bh;
        var octx = out.getContext('2d');
        if (!octx) return null;
        octx.drawImage(src, minX, minY, bw, bh, 0, 0, bw, bh);
        return out;
      }

      function fitOpaquePad(src) {
        if (!src) return Promise.resolve(src);
        if (opaquePadCache[src]) return opaquePadCache[src];
        opaquePadCache[src] = new Promise(function (resolve) {
          var image = new Image();
          if (/^https?:/i.test(src)) image.crossOrigin = 'anonymous';
          image.onload = function () {
            try {
              var cropped = cropOpaquePad(image);
              if (!cropped) {
                resolve(src);
                return;
              }
              cropped.toBlob(function (blob) {
                resolve(blob ? URL.createObjectURL(blob) : src);
              }, 'image/png');
            } catch (err) {
              resolve(src);
            }
          };
          image.onerror = function () {
            resolve(src);
          };
          image.src = src;
        });
        return opaquePadCache[src];
      }

      function showPadSrc(src, title, isPrint) {
        var seq = ++padShowSeq;
        padImg.classList.toggle('slydr-studio__pad--print', !!isPrint);
        if (title) padImg.alt = title;
        fitOpaquePad(src).then(function (url) {
          if (seq !== padShowSeq) return;
          if (url) padImg.src = url;
        });
      }

      var padCache = {};
      function loadPad(handle) {
        if (padCache[handle]) return padCache[handle];
        padCache[handle] = fetch(
          shopRoot() + '/products/' + encodeURIComponent(handle) + '.js',
          { credentials: 'same-origin' }
        )
          .then(function (res) {
            if (!res.ok) throw new Error('pad ' + handle + ' ' + res.status);
            return res.json();
          })
          .then(function (product) {
            return {
              src: pickPlain(product),
              title: product.title || handle
            };
          })
          .catch(function (err) {
            delete padCache[handle];
            return Promise.reject(err);
          });
        return padCache[handle];
      }

      function setPad(handle) {
        if (testPadUrl) {
          URL.revokeObjectURL(testPadUrl);
          testPadUrl = '';
        }
        padImg.classList.remove('slydr-studio__pad--print');
        if (testBtn) {
          testBtn.classList.remove('is-on');
          testBtn.setAttribute('aria-pressed', 'false');
        }
        loadPad(handle)
          .then(function (data) {
            if (!data.src) return;
            showPadSrc(data.src, data.title, false);
          })
          .catch(function () {});
        padHost.querySelectorAll('[data-pad]').forEach(function (btn) {
          var on = btn.getAttribute('data-pad') === handle;
          btn.classList.toggle('is-on', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      function k(type, w, h, oy) {
        var hasW = w != null && w !== 1;
        var hasH = h != null && h !== 1;
        var hasOy = oy != null && oy !== 0;
        if (!hasW && !hasH && !hasOy) return type;
        var o = { t: type };
        if (hasW) o.w = w;
        if (hasH) o.h = h;
        if (hasOy) o.oy = oy;
        return o;
      }

      function fillRow(type, count, w, h, oy) {
        var out = [];
        var i;
        var cell = k(type, w, h, oy);
        for (i = 0; i < count; i += 1) out.push(cell);
        return out;
      }

      function joinRow() {
        var out = [];
        var i;
        var part;
        var j;
        for (i = 0; i < arguments.length; i += 1) {
          part = arguments[i];
          if (Array.isArray(part)) {
            for (j = 0; j < part.length; j += 1) out.push(part[j]);
          } else {
            out.push(part);
          }
        }
        return out;
      }

      function keyRows(size) {
        if (size === '40') {
          return [
            fillRow('a', 12),
            joinRow(k('a', 1.5), fillRow('a', 9), k('a', 1.5)),
            joinRow(k('a', 1.75), fillRow('a', 9), k('a', 1.25)),
            joinRow(fillRow('a', 5), 's', fillRow('a', 5))
          ];
        }
        if (size === '60') {
          return [
            fillRow('a', 15),
            joinRow(k('a', 1.5), fillRow('a', 12), k('e', 1.5, 2)),
            joinRow(k('a', 1.75), fillRow('a', 11), 'a'),
            joinRow(k('a', 1.5), 'a', fillRow('a', 10), k('a', 2.5)),
            joinRow(fillRow('a', 3, 1.25), k('s', 6.25), fillRow('a', 4, 1.25))
          ];
        }
        if (size === '65') {
          return [
            fillRow('a', 16),
            joinRow(k('a', 1.5), fillRow('a', 12), k('e', 1.5, 2), 'a'),
            joinRow(k('a', 1.75), fillRow('a', 11), 'a', -1.25, 'a'),
            joinRow(k('a', 1.5), 'a', fillRow('a', 10), k('a', 1.5), 'c', 'a'),
            joinRow(fillRow('a', 3, 1.25), k('s', 6.25), fillRow('a', 3), 'c', 'c', 'c')
          ];
        }
        if (size === '75') {
          return [
            joinRow('f', -0.25, fillRow('f', 4), -0.25, fillRow('f', 4), -0.25, fillRow('f', 4), -0.25, 'f', 'f'),
            joinRow(fillRow('a', 13), k('a', 2), 'a'),
            joinRow(k('a', 1.5), fillRow('a', 12), k('e', 1.5, 2), 'a'),
            joinRow(k('a', 1.75), fillRow('a', 11), 'a', -1.25, 'a'),
            joinRow(k('a', 1.5), 'a', fillRow('a', 10), k('a', 1.5), 'c', -1),
            joinRow(fillRow('a', 3, 1.25), k('s', 6.25), fillRow('a', 3), 'c', 'c', 'c')
          ];
        }
        if (size === 'tkl') {
          return [
            joinRow('f', -1, fillRow('f', 4), -0.5, fillRow('f', 4), -0.5, fillRow('f', 4), -0.25, 'h', 'h', 'h'),
            joinRow(fillRow('a', 13), k('a', 2), -0.25, 'h', 'h', 'h'),
            joinRow(k('a', 1.5), fillRow('a', 12), k('e', 1.5, 2), -0.25, 'h', 'h', 'h'),
            joinRow(k('a', 1.75), fillRow('a', 11), 'a'),
            joinRow(k('a', 1.5), 'a', fillRow('a', 10), k('a', 2.5), -0.25, -1, 'c', -1),
            joinRow(fillRow('a', 3, 1.25), k('s', 6.25), fillRow('a', 4, 1.25), -0.25, 'c', 'c', 'c')
          ];
        }
        if (size === '1800') {
          return [
            joinRow('f', -0.25, fillRow('f', 4), -0.25, fillRow('f', 4), -0.25, fillRow('f', 4), -0.25, 'f', -0.5, fillRow('h', 4)),
            joinRow(fillRow('a', 13), k('a', 2), -0.5, fillRow('n', 4)),
            joinRow(k('a', 1.5), fillRow('a', 12), k('e', 1.5, 2), -0.5, fillRow('n', 3), k('n', 1, 2)),
            joinRow(k('a', 1.75), fillRow('a', 11), 'a', -1.25, -0.5, fillRow('n', 3)),
            joinRow(k('a', 1.5), 'a', fillRow('a', 10), k('a', 1.5), -0.25, 'c', -0.25, fillRow('n', 3), k('n', 1, 2)),
            joinRow(fillRow('a', 3, 1.25), k('s', 6.25), fillRow('a', 3), -0.25, 'c', 'c', 'c', -0.25, k('n', 2), 'n')
          ];
        }
        var full = [
          joinRow('f', -1, fillRow('f', 4), -0.5, fillRow('f', 4), -0.5, fillRow('f', 4), -0.25, 'h', 'h', 'h', -0.25, fillRow('x', 4, 1, 0.5, 0.25)),
          joinRow(fillRow('a', 13), k('a', 2), -0.25, 'h', 'h', 'h', -0.25, 'n', 'n', 'n', 'n'),
          joinRow(k('a', 1.5), fillRow('a', 12), k('e', 1.5, 2), -0.25, 'h', 'h', 'h', -0.25, 'n', 'n', 'n', k('n', 1, 2)),
          joinRow(k('a', 1.75), fillRow('a', 11), 'a', -1.25, -0.25, -3, -0.25, 'n', 'n', 'n'),
          joinRow(k('a', 1.5), 'a', fillRow('a', 10), k('a', 2.5), -0.25, -1, 'c', -1, -0.25, 'n', 'n', 'n', k('n', 1, 2)),
          joinRow(fillRow('a', 3, 1.25), k('s', 6.25), fillRow('a', 4, 1.25), -0.25, 'c', 'c', 'c', -0.25, k('n', 2), 'n')
        ];
        if (size === '110') {
          var out = [
            joinRow(
              fillRow('x', 4, 0.5, 0.5),
              -1.5,
              fillRow('f', 4),
              -0.5,
              k('d', 8.5, 0.7, 0.15),
              -0.25,
              k('x', 1, 0.5),
              -0.5,
              k('x', 1, 0.5),
              -0.75,
              fillRow('x', 4, 1, 0.5, 0.5)
            )
          ];
          var i;
          for (i = 0; i < full.length; i += 1) {
            out.push(joinRow('x', -0.5, full[i]));
          }
          return out;
        }
        return full;
      }

      function hexToRgb(hex) {
        hex = String(hex || '').replace('#', '');
        if (hex.length === 3) {
          hex = hex.charAt(0) + hex.charAt(0) + hex.charAt(1) + hex.charAt(1) + hex.charAt(2) + hex.charAt(2);
        }
        var n = parseInt(hex, 16);
        if (isNaN(n)) return { r: 28, g: 30, b: 32 };
        return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
      }

      function rgbToHex(r, g, b) {
        return (
          '#' +
          [r, g, b]
            .map(function (v) {
              v = Math.max(0, Math.min(255, Math.round(v)));
              return ('0' + v.toString(16)).slice(-2);
            })
            .join('')
        );
      }

      function mixHex(hex, toward, t) {
        var a = hexToRgb(hex);
        var b = hexToRgb(toward);
        return rgbToHex(a.r + (b.r - a.r) * t, a.g + (b.g - a.g) * t, a.b + (b.b - a.b) * t);
      }

      function hexIsLight(hex) {
        var rgb = hexToRgb(hex);
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000 > 150;
      }

      function normHex(hex) {
        return '#' + String(hex || '').replace('#', '').toLowerCase();
      }

      function gearSkin(hex) {
        var light = hexIsLight(hex);
        return {
          case: mixHex(hex, '#000000', light ? 0.16 : 0.2),
          keys: mixHex(hex, '#ffffff', light ? 0.1 : 0.16),
          stroke: light ? mixHex(hex, '#000000', 0.42) : mixHex(hex, '#ffffff', 0.36),
          lid: mixHex(hex, '#ffffff', light ? 0.06 : 0.1)
        };
      }

      var gearSwatches = [
        { id: 'white', title: 'Arctic White', hex: '#e8e8e8' },
        { id: 'black', title: 'Storm Black', hex: '#1c1e20' }
      ];
      var kbSize = 'tkl';
      var kbColor = '#1c1e20';
      var restOn = false;
      var restMm = 65;
      var mouseType = 'm';
      var mouseColor = '#1c1e20';
      var mouseFlip = false;
      var mouseRgbOn = false;
      var mouseRgbColor = '#ef0e8a';
      var mouseRgbMode = 'static';
      var kbCableOn = false;
      var mouseCableOn = false;
      var kbAnchor = { x: 50, y: -9.5 };
      var mouseAnchor = { x: 78, y: -9.5 };
      var padMmW = 900;
      var padMmH = 400;
      var padGridOn = false;
      var padGridStep = 50;
      var padGridSvg = null;

      function svgNode(name, attrs) {
        var el = document.createElementNS('http://www.w3.org/2000/svg', name);
        var key;
        for (key in attrs) {
          if (Object.prototype.hasOwnProperty.call(attrs, key)) {
            el.setAttribute(key, attrs[key]);
          }
        }
        return el;
      }

      function mountPadGrid() {
        if (!padSlot || padGridSvg) return;
        var svg = svgNode('svg', {
          class: 'slydr-studio__grid',
          viewBox: '0 0 ' + padMmW + ' ' + padMmH,
          preserveAspectRatio: 'none',
          'aria-hidden': 'true'
        });
        svg.setAttribute('hidden', '');
        var gLines = svgNode('g', { class: 'slydr-studio__grid-lines' });
        var gLabels = svgNode('g', { class: 'slydr-studio__grid-labels' });
        var mm;
        var major;
        function addLine(x1, y1, x2, y2, isMajor) {
          gLines.appendChild(
            svgNode('line', {
              x1: String(x1),
              y1: String(y1),
              x2: String(x2),
              y2: String(y2),
              class: isMajor ? 'slydr-studio__grid-line slydr-studio__grid-line--major' : 'slydr-studio__grid-line'
            })
          );
        }
        for (mm = padGridStep; mm < padMmW; mm += padGridStep) {
          major = mm % 100 === 0;
          addLine(mm, 0, mm, padMmH, major);
          if (major) {
            gLabels.appendChild(
              svgNode('text', {
                x: String(mm),
                y: '22',
                'text-anchor': 'middle',
                class: 'slydr-studio__grid-label'
              })
            ).textContent = mm / 10 + '';
          }
        }
        for (mm = padGridStep; mm < padMmH; mm += padGridStep) {
          major = mm % 100 === 0;
          addLine(0, mm, padMmW, mm, major);
          if (major) {
            gLabels.appendChild(
              svgNode('text', {
                x: '14',
                y: String(mm + 5),
                'text-anchor': 'start',
                class: 'slydr-studio__grid-label'
              })
            ).textContent = mm / 10 + '';
          }
        }
        svg.appendChild(gLines);
        svg.appendChild(gLabels);
        padGridSvg = svg;
        var cables = padSlot.querySelector('[data-studio-cables]');
        if (cables) padSlot.insertBefore(svg, cables);
        else padSlot.appendChild(svg);
      }

      function setPadGrid(on) {
        if (typeof on === 'boolean') padGridOn = on;
        else padGridOn = !padGridOn;
        if (!padGridSvg) mountPadGrid();
        if (padGridSvg) {
          if (padGridOn) padGridSvg.removeAttribute('hidden');
          else padGridSvg.setAttribute('hidden', '');
        }
        if (padSlot) padSlot.classList.toggle('is-grid', padGridOn);
        root.querySelectorAll('[data-studio-grid-btn]').forEach(function (btn) {
          btn.classList.toggle('is-on', padGridOn);
          btn.setAttribute('aria-pressed', padGridOn ? 'true' : 'false');
        });
      }
      var keyTints = {
        f: '#3BA7FF',
        h: '#4caf63',
        c: '#e25a5a',
        n: '#8b9096',
        x: '#e8c547'
      };
      var keyTintsOn = true;
      var kbRgbOn = false;
      var kbRgbColor = '#ef0e8a';
      var kbRgbMode = 'static';
      var rgbSwatches = [
        { title: 'Nova Pink', hex: '#ef0e8a' },
        { title: 'Shock Blue', hex: '#3ba7ff' },
        { title: 'Red', hex: '#ff3b4a' },
        { title: 'Green', hex: '#32d74b' },
        { title: 'Purple', hex: '#bf5af2' },
        { title: 'Orange', hex: '#ff9f0a' },
        { title: 'White', hex: '#f4f4f4' }
      ];
      var kbPreset = {
        '40': { w: 232, d: 88 },
        '60': { w: 290, d: 107 },
        '65': { w: 309, d: 107 },
        '75': { w: 309, d: 137 },
        tkl: { w: 353, d: 137 },
        '1800': { w: 377, d: 137 },
        '100': { w: 435, d: 137 },
        '110': { w: 464, d: 158, extraW: 20 }
      };
      var mousePreset = {
        s: { w: 62, d: 105 },
        m: { w: 68, d: 117 },
        l: { w: 79, d: 130 }
      };
      var mouseCablePort = {
        s: { vw: 62, vh: 105, x: 30.7, y: 3.4 },
        m: { vw: 79.2, vh: 131.4, x: 44.4, y: 7.6 },
        l: { vw: 79, vh: 130, x: 48.74, y: 15.4 }
      };

      function rowHasType(row, type) {
        var i;
        var cell;
        var t;
        for (i = 0; i < row.length; i += 1) {
          cell = row[i];
          t = cell && typeof cell === 'object' ? cell.t : cell;
          if (t === type) return true;
        }
        return false;
      }

      function kbSvg(size, hex) {
        var skin = gearSkin(hex);
        var unit = 10;
        var gap = 1.4;
        var pad = 6;
        var rows = keyRows(size);
        var maxW = 0;
        var keys = '';
        var leds = '';
        var y = pad;
        var r;
        var col;
        var x;
        var cell;
        var fill;
        var keyW;
        var keyH;
        var keyY;
        var kh;
        var rx;
        var type;
        for (r = 0; r < rows.length; r += 1) {
          x = pad;
          for (col = 0; col < rows[r].length; col += 1) {
            cell = rows[r][col];
            if (typeof cell === 'number') {
              x += Math.abs(cell) * unit;
              continue;
            }
            keyW = 1;
            keyH = 1;
            if (cell && typeof cell === 'object') {
              type = cell.t;
              keyW = cell.w || 1;
              keyH = cell.h || 1;
              keyY = y + (cell.oy || 0) * unit;
            } else {
              type = cell;
              keyW = cell === 's' ? 2 : 1;
              keyY = y;
            }
            kh = keyH * unit - gap;
            rx = Math.min(1.2, kh * 0.35);
            if (type === 'd') {
              keys +=
                '<rect x="' +
                x +
                '" y="' +
                keyY +
                '" width="' +
                (keyW * unit - gap) +
                '" height="' +
                kh +
                '" rx="' +
                Math.min(2, kh * 0.22) +
                '" fill="' +
                mixHex(skin.case, '#000000', 0.38) +
                '" stroke="' +
                skin.stroke +
                '" stroke-width="0.4"/>' +
                '<rect x="' +
                (x + 1.3) +
                '" y="' +
                (keyY + 1.1) +
                '" width="' +
                (keyW * unit - gap - 2.6) +
                '" height="' +
                (kh - 2.2) +
                '" rx="0.8" fill="' +
                mixHex(skin.case, '#111418', 0.55) +
                '"/>';
              x += keyW * unit;
              continue;
            }
            if (keyTintsOn && keyTints[type]) fill = keyTints[type];
            else fill = skin.keys;
            // ISO Enter: single L-shaped path (one outline).
            if (type === 'e' && keyH >= 2) {
              var eW = keyW * unit - gap;
              var eH = 2 * unit - gap;
              var eX0 = x;
              var eY0 = keyY;
              var eX1 = x + eW;
              var eY1 = keyY + eH;
              // ISO Enter arm: eYMid = how far down the L-step sits (0–1 of one row).
              // eTopInset = how much the top-left is pulled in (larger = less left reach).
              var eYMid = keyY + unit * 0.85;
              var eTopInset = 0.02 * unit;
              var eStem = x + 0.25 * unit;
              var eTopX = eX0 + eTopInset;
              var eR = Math.min(1.2, (unit - gap) * 0.35);
              var ePath =
                'M' +
                (eTopX + eR).toFixed(2) +
                ',' +
                eY0.toFixed(2) +
                'H' +
                (eX1 - eR).toFixed(2) +
                'A' +
                eR +
                ',' +
                eR +
                ' 0 0 1 ' +
                eX1.toFixed(2) +
                ',' +
                (eY0 + eR).toFixed(2) +
                'V' +
                (eY1 - eR).toFixed(2) +
                'A' +
                eR +
                ',' +
                eR +
                ' 0 0 1 ' +
                (eX1 - eR).toFixed(2) +
                ',' +
                eY1.toFixed(2) +
                'H' +
                (eStem + eR).toFixed(2) +
                'A' +
                eR +
                ',' +
                eR +
                ' 0 0 1 ' +
                eStem.toFixed(2) +
                ',' +
                (eY1 - eR).toFixed(2) +
                'V' +
                eYMid.toFixed(2) +
                'H' +
                (eTopX + eR).toFixed(2) +
                'A' +
                eR +
                ',' +
                eR +
                ' 0 0 1 ' +
                eTopX.toFixed(2) +
                ',' +
                (eYMid - eR).toFixed(2) +
                'V' +
                (eY0 + eR).toFixed(2) +
                'A' +
                eR +
                ',' +
                eR +
                ' 0 0 1 ' +
                (eTopX + eR).toFixed(2) +
                ',' +
                eY0.toFixed(2) +
                'Z';
              keys +=
                '<path d="' +
                ePath +
                '" fill="' +
                fill +
                '" stroke="' +
                skin.stroke +
                '" stroke-width="0.4"/>';
              if (kbRgbOn) {
                var rgbXe = ((eTopX + eX1) * 0.5).toFixed(2);
                keys +=
                  '<path class="slydr-kb-led slydr-kb-led--face" style="--rgb-x:' +
                  rgbXe +
                  '" d="' +
                  ePath +
                  '" fill="' +
                  kbRgbColor +
                  '" opacity="0.2"/>';
                leds +=
                  '<rect class="slydr-kb-led slydr-kb-led--south" style="--rgb-x:' +
                  rgbXe +
                  '" x="' +
                  (eStem + 0.7).toFixed(2) +
                  '" y="' +
                  (eY1 - 1.55).toFixed(2) +
                  '" width="' +
                  Math.max(1.2, eX1 - eStem - 1.4).toFixed(2) +
                  '" height="1.2" rx="0.55" fill="' +
                  kbRgbColor +
                  '"/>';
              }
              x += keyW * unit;
              continue;
            }
            keys +=
              '<rect x="' +
              x +
              '" y="' +
              keyY +
              '" width="' +
              (keyW * unit - gap) +
              '" height="' +
              kh +
              '" rx="' +
              rx +
              '" fill="' +
              fill +
              '" stroke="' +
              skin.stroke +
              '" stroke-width="0.4"/>';
            if (kbRgbOn) {
              var rgbX = (x + (keyW * unit - gap) * 0.5).toFixed(2);
              keys +=
                '<rect class="slydr-kb-led slydr-kb-led--face" style="--rgb-x:' +
                rgbX +
                '" x="' +
                x +
                '" y="' +
                keyY +
                '" width="' +
                (keyW * unit - gap) +
                '" height="' +
                kh +
                '" rx="' +
                rx +
                '" fill="' +
                kbRgbColor +
                '" opacity="0.2"/>';
              leds +=
                '<rect class="slydr-kb-led slydr-kb-led--south" style="--rgb-x:' +
                rgbX +
                '" x="' +
                (x + 0.7) +
                '" y="' +
                (keyY + kh - 1.55) +
                '" width="' +
                Math.max(1.2, keyW * unit - gap - 1.4) +
                '" height="1.2" rx="0.55" fill="' +
                kbRgbColor +
                '"/>';
            }
            x += keyW * unit;
          }
          if (x > maxW) maxW = x;
          y += unit;
          if (rowHasType(rows[r], 'f') && !(rows[r + 1] && rowHasType(rows[r + 1], 'f'))) {
            y += unit * 0.5;
          }
        }
        var vw = maxW + pad - gap;
        var caseH = y + pad - gap;
        var rgbDefs = '';
        var rgbLeds = '';
        if (kbRgbOn && leds) {
          rgbDefs =
            '<defs><filter id="slydr-kb-rgb" x="-50%" y="-80%" width="200%" height="260%"><feGaussianBlur stdDeviation="1.05" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>';
          rgbLeds = '<g filter="url(#slydr-kb-rgb)" opacity="0.95">' + leds + '</g>';
        }
        return (
          '<svg viewBox="0 0 ' +
          vw +
          ' ' +
          caseH +
          '" style="--rgb-span:' +
          vw.toFixed(2) +
          '" aria-hidden="true" preserveAspectRatio="xMidYMid meet">' +
          rgbDefs +
          keys +
          rgbLeds +
          '</svg>'
        );
      }

      function mouseRgbLayer(type) {
        if (!mouseRgbOn) return '';
        var color = mouseRgbColor;
        var paths = {
          s: {
            l: 'M22.6 39.2C16.2 58 16.8 80 28.2 100.4',
            r: 'M39.4 38.8C45.8 58 45.2 80 33.8 100.4',
            join: 'round',
            wheel: { x: 27.6, y: 3.4, w: 6.2, h: 27.2, rx: 2.6 },
            vh: 105
          },
          m: {
            l: 'M20.2 67C21.2 84 21.5 102 24.6 116C26.8 121.5 31.4 125.2 36.6 127.2',
            r: 'M64.3 50.8C65 74 64.7 98 61.2 113.5C58.4 119.6 53.2 123.6 47.8 125.4',
            join: 'round',
            wheel: { x: 41.2, y: 7.6, w: 6.4, h: 18.8, rx: 2.7 },
            vh: 131.4
          },
          l: {
            l: 'M21 57.5C19.2 70 19.4 84 22.8 96C25.2 104 27.8 108.5 29.4 110.5',
            r: 'M71.8 60.5C75.2 74 76.4 90 73.6 103.5C71.6 110 67.2 114 63.2 115.5',
            join: 'round',
            wheel: { x: 46.91, y: 17.45, w: 3.67, h: 15.73, rx: 0.9 },
            vh: 130
          }
        };
        var p = paths[type] || paths.m;
        var joinAttr = ' stroke-linejoin="round"';
        var h = p.vh;
        function strip(d) {
          return (
            '<path class="slydr-mouse-led slydr-mouse-led--strip" fill="none" stroke="' +
            color +
            '" stroke-width="1.7" stroke-linecap="round"' +
            joinAttr +
            ' d="' +
            d +
            '"/>'
          );
        }
        var w = p.wheel;
        return (
          '<defs>' +
          '<linearGradient id="slydr-mouse-flow" gradientUnits="userSpaceOnUse" x1="0" y1="' +
          -h +
          '" x2="0" y2="' +
          h * 2 +
          '" spreadMethod="repeat">' +
          '<stop offset="0%" stop-color="hsl(0,92%,58%)"/>' +
          '<stop offset="25%" stop-color="hsl(90,92%,58%)"/>' +
          '<stop offset="50%" stop-color="hsl(180,92%,58%)"/>' +
          '<stop offset="75%" stop-color="hsl(270,92%,58%)"/>' +
          '<stop offset="100%" stop-color="hsl(360,92%,58%)"/>' +
          '<animateTransform attributeName="gradientTransform" type="translate" from="0 ' +
          -h +
          '" to="0 ' +
          h +
          '" dur="2.6s" repeatCount="indefinite"/>' +
          '</linearGradient>' +
          '<filter id="slydr-mouse-rgb" x="-140%" y="-50%" width="380%" height="200%">' +
          '<feGaussianBlur in="SourceGraphic" stdDeviation="2.8" result="b"/>' +
          '<feGaussianBlur in="SourceGraphic" stdDeviation="1.15" result="c"/>' +
          '<feMerge><feMergeNode in="b"/><feMergeNode in="b"/><feMergeNode in="c"/><feMergeNode in="SourceGraphic"/></feMerge>' +
          '</filter>' +
          '</defs>' +
          '<g class="slydr-mouse-rgb" filter="url(#slydr-mouse-rgb)" pointer-events="none">' +
          strip(p.l) +
          strip(p.r) +
          '<rect class="slydr-mouse-led slydr-mouse-led--wheel" x="' +
          w.x +
          '" y="' +
          w.y +
          '" width="' +
          w.w +
          '" height="' +
          w.h +
          '" rx="' +
          w.rx +
          '" fill="none" stroke="' +
          color +
          '" stroke-width="1.2"/>' +
          '</g>'
        );
      }

      function mouseSvg(hex, type) {
        var skin = gearSkin(hex);
        var shade = mixHex(hex, '#000000', 0.16);
        var face = mixHex(hex, '#ffffff', 0.08);
        var well = mixHex(hex, '#000000', 0.28);
        var sw = skin.stroke;
        function pan(d, fill, join) {
          var joinAttr =
            join === 'miter'
              ? ' stroke-linejoin="miter" stroke-miterlimit="2.6"'
              : ' stroke-linejoin="round"';
          return (
            '<path fill="' +
            fill +
            '" stroke="' +
            sw +
            '" stroke-width="1.1" stroke-linecap="round"' +
            joinAttr +
            ' d="' +
            d +
            '"/>'
          );
        }
        function wheel(x, y, w, h, ridges) {
          ridges = ridges || 5;
          var lines = '';
          var i;
          var gy;
          for (i = 1; i <= ridges; i += 1) {
            gy = y + 3.2 + i * ((h - 6.4) / (ridges + 1));
            lines += 'M' + (x + 1.6).toFixed(1) + ' ' + gy.toFixed(1) + 'h' + (w - 3.2).toFixed(1);
          }
          return (
            '<rect x="' +
            x +
            '" y="' +
            y +
            '" width="' +
            w +
            '" height="' +
            h +
            '" rx="' +
            (w * 0.42).toFixed(1) +
            '" fill="' +
            well +
            '" stroke="' +
            sw +
            '" stroke-width="1"/>' +
            '<rect x="' +
            (x + 1.15).toFixed(1) +
            '" y="' +
            (y + 1.4).toFixed(1) +
            '" width="' +
            (w - 2.3).toFixed(1) +
            '" height="' +
            (h - 2.8).toFixed(1) +
            '" rx="' +
            ((w - 2.3) * 0.42).toFixed(1) +
            '" fill="' +
            skin.keys +
            '"/>' +
            '<path fill="none" stroke="' +
            sw +
            '" stroke-width="0.5" opacity="0.7" d="' +
            lines +
            '"/>'
          );
        }
        if (type === 's') {
          return (
            '<svg viewBox="0 0 62 105" aria-hidden="true">' +
            pan(
              'M25.58 1.28L19.51 2.56 9.97 7.68 5.64 12.38 3.47 23.48 1.30 40.98 1.30 58.48 2.60 67.44 5.20 77.68 11.27 90.49 15.61 96.04 22.11 101.16 28.18 103.29 32.95 103.29 37.72 102.01 44.22 97.74 48.13 93.48 53.33 84.94 56.80 76.40 59.40 65.30 60.27 58.48 60.27 40.98 58.10 23.05 51.59 11.95 42.49 3.41 34.25 1.28Z',
              skin.case
            ) +
            pan(
              'M25.58 2.99L26.01 3.41 26.01 35.43 22.55 37.56 3.03 46.10 2.60 45.67 3.03 37.56 5.64 19.21 7.37 11.95 14.74 6.40 22.11 3.41Z',
              face
            ) +
            pan(
              'M35.99 3.41L37.72 3.41 42.06 5.12 50.73 13.66 55.50 21.34 56.36 23.48 58.10 34.15 58.97 42.68 58.53 46.10 38.15 37.13 35.55 35.43 35.55 3.84Z',
              face
            ) +
            pan(
              'M35.99 37.56L58.97 48.23 58.97 56.77 55.50 75.55 48.56 90.49 39.45 99.45 34.69 101.59 29.48 102.01 25.58 101.16 19.08 97.32 10.84 87.07 3.90 67.01 2.60 48.23 24.28 37.99 26.01 38.41 26.45 44.39 28.62 46.52 31.65 46.95 35.12 44.39Z',
              skin.lid
            ) +
            '<rect x="27.4" y="2.6" width="6.6" height="44.4" rx="3.3" fill="' +
            well +
            '" stroke="' +
            sw +
            '" stroke-width="1"/>' +
            wheel(27.6, 3.4, 6.2, 27.2, 6) +
            '<circle cx="30.7" cy="36.8" r="2.25" fill="' +
            face +
            '" stroke="' +
            sw +
            '" stroke-width="1"/>' +
            mouseRgbLayer('s') +
            '</svg>'
          );
        }
        if (type === 'l') {
          return (
            '<svg viewBox="0 0 79 130" aria-hidden="true">' +
            pan(
              'M47.52 0.68L38.81 3.25 32.09 5.99 25.82 9.75 23.53 12.66 20.78 22.41 18.18 42.08 13.91 46.53 7.79 50.63 5.81 53.37 4.13 57.82 1.68 71.67 0.61 91.00 2.60 97.16 6.88 102.97 26.89 120.25 33.31 124.53 39.42 127.43 45.08 128.97 49.97 129.14 52.72 128.63 56.54 126.92 63.57 121.11 69.83 113.92 73.80 106.57 75.18 100.92 77.47 79.71 78.24 67.05 78.24 54.22 77.32 40.37 75.94 29.76 74.11 20.53 72.12 14.54 68.61 10.61 57.61 4.96Z',
              skin.case
            ) +
            pan(
              'M47.52 1.37L35.15 5.30 29.19 8.21 26.13 10.43 23.84 20.18 21.55 33.87 20.17 47.72 19.86 60.89 39.73 53.88 41.41 52.51 41.87 51.32 40.80 15.39 41.72 13.34 43.24 12.14 47.83 11.80Z',
              face
            ) +
            pan(
              'M48.44 1.54L48.59 11.80 53.48 12.14 55.16 13.86 55.62 15.39 56.84 53.54 58.98 55.25 71.97 60.89 73.19 60.89 73.96 59.70 73.80 41.57 72.12 26.00 69.68 12.32 62.19 7.87Z',
              face
            ) +
            pan(
              'M20.02 61.92L13.91 46.53 7.79 50.63 5.81 53.37 4.13 57.82 1.68 71.67 0.61 91.00 2.60 97.16 6.88 102.97 26.89 120.25 33.31 124.53 39.42 127.43 45.08 128.97 49.97 129.14 52.72 128.63 56.54 126.92 63.57 121.11 69.83 113.92 73.80 106.57 75.18 100.92 77.47 79.71 78.24 67.05 78.24 54.22 74.72 60.04 72.74 61.92 57.15 55.25 56.08 52.51 42.17 52.51 39.88 54.74Z',
              skin.lid
            ) +
            pan(
              'M25.06 11.29L22.31 18.13 19.86 31.47 18.03 49.95 17.88 65.51 18.64 75.78 20.32 85.70 23.23 94.76 25.21 98.70 26.44 99.38 27.35 98.18 24.14 91.17 21.09 80.91 19.86 72.87 19.10 61.92 19.25 49.95 20.32 37.46 22.77 21.55Z',
              shade
            ) +
            '<rect x="43.85" y="15.39" width="9.78" height="20.02" rx="1.7" fill="' +
            well +
            '" stroke="' +
            sw +
            '" stroke-width="1"/>' +
            '<rect x="44.62" y="16.25" width="8.40" height="18.47" rx="1.3" fill="' +
            face +
            '" stroke="' +
            sw +
            '" stroke-width="0.85"/>' +
            '<rect x="46.91" y="17.45" width="3.67" height="15.73" rx="0.9" fill="' +
            skin.keys +
            '" stroke="' +
            sw +
            '" stroke-width="0.7"/>' +
            '<rect x="46.15" y="45.16" width="7.03" height="8.55" rx="1.85" fill="' +
            face +
            '" stroke="' +
            sw +
            '" stroke-width="1"/>' +
            '<rect x="46.76" y="46.01" width="5.80" height="6.85" rx="1.35" fill="' +
            well +
            '" stroke="' +
            sw +
            '" stroke-width="0.7"/>' +
            mouseRgbLayer('l') +
            '</svg>'
          );
        }
        return (
          '<svg viewBox="0 0 79.2 131.4" aria-hidden="true">' +
          pan(
            'M33.31 2.07L17.60 17.98 16.34 26.97 11.31 32.50 11.31 44.26 4.40 53.94 2.51 60.17 1.89 87.83 3.77 93.36 17.60 107.19 19.49 112.73 29.54 123.10 37.71 128.63 49.03 128.63 55.31 125.87 62.23 118.95 69.77 108.58 73.54 100.97 76.06 61.55 76.69 32.50 72.29 27.66 71.66 22.13 69.77 17.98 60.34 6.92 55.31 2.77 49.03 2.77 47.14 7.61 40.23 11.07 38.97 2.07Z',
            skin.case,
            'miter'
          ) +
          pan(
            'M37.71 3.46L33.94 3.46 28.91 7.61 20.74 15.91 18.23 21.44 18.23 24.90 17.60 25.59 17.60 42.88 18.23 43.57 18.23 55.33 18.86 56.02 18.86 63.63 19.49 64.32 19.49 72.62 20.11 74.00 28.29 67.77 38.34 61.55Z',
            face,
            'miter'
          ) +
          pan(
            'M54.69 4.15L50.29 4.15 49.66 5.53 49.66 45.64 49.03 46.34 49.03 54.63 50.91 53.94 54.69 50.49 64.74 43.57 66.63 41.49 68.51 40.80 71.03 37.35 69.77 20.75 65.37 15.21 65.37 14.52 59.09 7.61Z',
            face,
            'miter'
          ) +
          pan(
            'M64.11 51.87L21.37 80.22 21.37 89.91 22.00 90.60 23.26 110.65 24.51 113.42 37.71 123.79 47.14 124.48 53.43 122.41 59.71 115.49 64.74 107.89 64.74 52.56Z',
            skin.lid,
            'miter'
          ) +
          pan(
            'M10.69 47.72L8.80 51.18 5.66 54.63 4.40 58.09 4.40 62.24 3.77 62.93 3.77 71.23 3.14 71.92 3.14 85.76 3.77 86.45 3.77 89.91 5.03 92.67 15.09 103.05 15.71 103.05 15.09 101.66 15.09 96.13 14.46 95.44 14.46 89.91 13.83 89.21 13.83 82.99 13.20 82.30 13.20 75.38 12.57 74.69 12.57 67.08 11.94 66.39 11.94 58.78 11.31 58.09 11.31 49.79 10.69 49.10Z',
            shade,
            'miter'
          ) +
          pan(
            'M74.80 45.64L70.40 49.10 70.40 104.43 72.29 99.59 72.29 92.67 72.91 91.98 72.91 81.61 73.54 80.91 73.54 69.16 74.17 68.47Z',
            shade,
            'miter'
          ) +
          '<rect x="41.2" y="7.6" width="6.4" height="18.8" rx="2.7" fill="' +
          well +
          '" stroke="' +
          sw +
          '" stroke-width="1.05"/>' +
          '<rect x="42.5" y="9.2" width="3.8" height="15.6" rx="1.9" fill="' +
          skin.keys +
          '"/>' +
          '<path fill="none" stroke="' +
          sw +
          '" stroke-width="0.55" opacity="0.75" d="M43.1 11.6h2.6M43.1 14.2h2.6M43.1 16.8h2.6M43.1 19.4h2.6M43.1 22h2.6"/>' +
          mouseRgbLayer('m') +
          '</svg>'
        );
      }

      function showGear(el, on) {
        if (!el) return;
        if (el.classList.contains('slydr-studio__rgb')) {
          if (on) {
            el.classList.remove('is-off');
            el.removeAttribute('hidden');
            if (!animateHeight(el, true)) {
              scheduleKbHeight();
            }
          } else if (!animateHeight(el, false, function () {
            el.classList.add('is-off');
            el.setAttribute('hidden', '');
          })) {
            el.classList.add('is-off');
            el.setAttribute('hidden', '');
          }
          return;
        }
        el.classList.toggle('is-off', !on);
        if (on) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      }

      function tickKbHeight(doneRef) {
        function frame() {
          if (doneRef.done) return;
          scheduleKbHeight();
          window.requestAnimationFrame(frame);
        }
        window.requestAnimationFrame(frame);
      }

      function animateHeight(el, open, after) {
        if (!el) return false;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
        if (el.dataset.animating === '1') return true;
        el.dataset.animating = '1';
        var start = open ? 0 : el.scrollHeight;
        var end = open ? el.scrollHeight : 0;
        el.style.overflow = 'hidden';
        el.style.height = start + 'px';
        el.style.opacity = open ? '0' : '1';
        void el.offsetHeight;
        el.style.transition = 'height 0.32s ease, opacity 0.24s ease';
        el.style.height = end + 'px';
        el.style.opacity = open ? '1' : '0';
        var doneRef = { done: false };
        function finish(ev) {
          if (doneRef.done) return;
          if (ev && ev.propertyName && ev.propertyName !== 'height') return;
          doneRef.done = true;
          el.removeEventListener('transitionend', finish);
          el.style.height = '';
          el.style.opacity = '';
          el.style.overflow = '';
          el.style.transition = '';
          el.dataset.animating = '';
          if (after) after();
          scheduleKbHeight();
        }
        el.addEventListener('transitionend', finish);
        window.setTimeout(finish, 400);
        tickKbHeight(doneRef);
        return true;
      }

      function groupClosedHeight(details) {
        var summary = details.querySelector(':scope > .slydr-studio__label');
        var rem = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
        return Math.round((summary ? summary.offsetHeight : 0) + 0.5 * rem);
      }

      function alignedKbMin() {
        var kb = root.querySelector('.slydr-studio__group--kb');
        var desk = root.querySelector('.slydr-studio__group--desk');
        var pad = root.querySelector('.slydr-studio__group--pad');
        var mouse = root.querySelector('.slydr-studio__stack > .slydr-studio__group');
        var light = root.querySelector('.slydr-studio__group--light');
        var stack = root.querySelector('.slydr-studio__stack');
        if (!kb || !desk || !pad || !mouse || !light || !stack) return 0;
        var gap = parseFloat(window.getComputedStyle(stack).gap) || 0;
        var kbRgb = kb.querySelector('[data-studio-rgb]');
        var kbRgbOpen = kbRgb && !kbRgb.hidden && !kbRgb.classList.contains('is-off');
        var mouseH = kbRgbOpen ? mouse.offsetHeight : cardRestHeight(mouse, '[data-studio-mouse-rgb]');
        var lightH = kbRgbOpen ? light.offsetHeight : cardRestHeight(light, '[data-studio-desk-rgb]');
        return Math.max(0, mouseH + lightH + gap + pad.offsetHeight - desk.offsetHeight);
      }

      function animateGroup(details, open, after) {
        if (!details) return false;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
        if (details.dataset.animating === '1') return true;
        var body = details.querySelector(':scope > .slydr-studio__group-body');
        details.dataset.animating = '1';
        details.classList.add('is-animating');
        var start;
        var end;
        if (open) {
          start = details.offsetHeight;
          details.setAttribute('open', '');
          details.classList.remove('is-closing');
          end = details.scrollHeight;
          if (details.classList.contains('slydr-studio__group--kb')) {
            end = Math.max(end, alignedKbMin());
          }
          details.style.overflow = 'hidden';
          details.style.height = start + 'px';
        } else {
          start = details.offsetHeight;
          details.style.overflow = 'hidden';
          details.style.height = start + 'px';
          details.classList.add('is-closing');
          details.style.minHeight = '';
          end = groupClosedHeight(details);
        }
        if (body) body.style.opacity = open ? '0' : '1';
        void details.offsetHeight;
        details.style.transition = 'height 0.32s ease';
        details.style.height = end + 'px';
        if (body) {
          body.style.transition = 'opacity 0.22s ease';
          body.style.opacity = open ? '1' : '0';
        }
        var doneRef = { done: false };
        function finish(ev) {
          if (doneRef.done) return;
          if (ev && ev.propertyName && ev.propertyName !== 'height') return;
          doneRef.done = true;
          details.removeEventListener('transitionend', finish);
          details.style.height = '';
          details.style.overflow = '';
          details.style.transition = '';
          details.classList.remove('is-animating');
          details.dataset.animating = '';
          if (body) {
            body.style.opacity = '';
            body.style.transition = '';
          }
          if (!open) {
            details.removeAttribute('open');
            details.classList.remove('is-closing');
          }
          if (after) after();
          scheduleKbHeight();
        }
        details.addEventListener('transitionend', finish);
        window.setTimeout(finish, 400);
        tickKbHeight(doneRef);
        return true;
      }

      function readMm(input, fallback) {
        if (!input) return fallback;
        var n = parseFloat(input.value);
        if (isNaN(n) || n <= 0) return fallback;
        return n;
      }

      function fillMm(input, value) {
        if (!input) return;
        input.value = String(Math.round(value));
      }

      function gearOn(el) {
        return el && !el.classList.contains('is-off') && !el.hasAttribute('hidden');
      }

      function mouseCableStart(mouse) {
        var port = mouseCablePort[mouseType] || mouseCablePort.m;
        var scale = Math.min(mouse.w / port.vw, mouse.h / port.vh);
        var ox = (mouse.w - port.vw * scale) / 2;
        var oy = (mouse.h - port.vh * scale) / 2;
        var lx = ox + port.x * scale;
        if (mouseFlip) lx = mouse.w - lx;
        return {
          x: mouse.left + lx,
          y: mouse.top + oy + port.y * scale
        };
      }

      var slide = null;

      function gearPct(el) {
        if (slide && slide.kind === 'gear' && slide.el === el && slide.slotW && slide.slotH) {
          return {
            left: (slide.x / slide.slotW) * 100,
            top: (slide.y / slide.slotH) * 100,
            w: slide.wPct,
            h: slide.hPct
          };
        }
        var box = padSlot.getBoundingClientRect();
        if (!box.width || !box.height || !gearOn(el)) return null;
        var b = el.getBoundingClientRect();
        if (!b.width || !b.height) return null;
        return {
          left: ((b.left - box.left) / box.width) * 100,
          top: ((b.top - box.top) / box.height) * 100,
          w: (b.width / box.width) * 100,
          h: (b.height / box.height) * 100
        };
      }

      function clampSlideXY(next) {
        if (next.x < next.minX) next.x = next.minX;
        if (next.y < next.minY) next.y = next.minY;
        if (next.x > next.maxX) next.x = next.maxX;
        if (next.y > next.maxY) next.y = next.maxY;
      }

      function paintSlide() {
        if (!slide || !slide.el) return;
        if (slide.kind === 'gear') {
          var dx = slide.x - slide.originX;
          var dy = slide.y - slide.originY;
          var t = 'translate3d(' + dx.toFixed(2) + 'px,' + dy.toFixed(2) + 'px,0)';
          if (slide.flipped) t += ' scaleX(-1)';
          slide.el.style.transform = t;
          if (kbCableOn || mouseCableOn) drawCables();
          return;
        }
        slide.pos.x = (slide.x / slide.slotW) * 100;
        slide.pos.y = (slide.y / slide.slotH) * 100;
        drawCables();
      }

      function flushSlide() {
        if (slide) slide.raf = 0;
        paintSlide();
      }

      function queueSlide() {
        if (!slide || slide.raf) return;
        slide.raf = window.requestAnimationFrame(flushSlide);
      }

      function moveSlide(event) {
        if (!slide || !slide.el) return;
        if (slide.pointerId != null && event.pointerId !== slide.pointerId) return;
        slide.x = event.clientX - slide.slotLeft - slide.ox;
        slide.y = event.clientY - slide.slotTop - slide.oy;
        clampSlideXY(slide);
        queueSlide();
      }

      function stopSlide(event) {
        if (!slide || !slide.el) return;
        if (event && slide.pointerId != null && event.pointerId !== slide.pointerId) return;
        if (event && event.clientX != null) {
          slide.x = event.clientX - slide.slotLeft - slide.ox;
          slide.y = event.clientY - slide.slotTop - slide.oy;
          clampSlideXY(slide);
        }
        if (slide.raf) {
          window.cancelAnimationFrame(slide.raf);
          slide.raf = 0;
        }
        var el = slide.el;
        if (slide.kind === 'gear' && slide.slotW && slide.slotH) {
          if (Math.abs(slide.x - slide.originX) > 0.25 || Math.abs(slide.y - slide.originY) > 0.25) {
            el.style.left = (slide.x / slide.slotW) * 100 + '%';
            el.style.top = (slide.y / slide.slotH) * 100 + '%';
          }
          el.style.transform = '';
        } else if (slide.kind === 'anchor' && slide.pos && slide.slotW && slide.slotH) {
          slide.pos.x = (slide.x / slide.slotW) * 100;
          slide.pos.y = (slide.y / slide.slotH) * 100;
        }
        el.classList.remove('is-drag');
        slide = null;
        drawCables();
      }

      function clampGearToDesk(el) {
        if (!el || !gearOn(el) || !el.offsetWidth || !el.offsetHeight) return;
        var slot = padSlot.getBoundingClientRect();
        var desk = stage.getBoundingClientRect();
        if (!slot.width || !slot.height) return;
        var inset = 4;
        var minX = desk.left - slot.left + inset;
        var minY = desk.top - slot.top + inset;
        var maxX = desk.right - slot.left - el.offsetWidth - inset;
        var maxY = desk.bottom - slot.top - el.offsetHeight - inset;
        if (maxX < minX) maxX = minX;
        if (maxY < minY) maxY = minY;
        var x = (parseFloat(el.style.left) / 100) * slot.width;
        var y = (parseFloat(el.style.top) / 100) * slot.height;
        if (isNaN(x)) x = el.offsetLeft;
        if (isNaN(y)) y = el.offsetTop;
        if (x < minX) x = minX;
        if (y < minY) y = minY;
        if (x > maxX) x = maxX;
        if (y > maxY) y = maxY;
        el.style.left = (x / slot.width) * 100 + '%';
        el.style.top = (y / slot.height) * 100 + '%';
      }

      function cableD(x1, y1, x2, y2, pull) {
        pull = pull == null ? 14 : pull;
        var dx = x2 - x1;
        var c1x = x1 + dx * 0.08;
        var c1y = y1 - pull;
        var c2x = x2 - dx * 0.18;
        var c2y = y2 + (y1 >= y2 ? Math.min(12, Math.max(4, (y1 - y2) * 0.28)) : -Math.min(12, Math.max(4, (y2 - y1) * 0.28)));
        return (
          'M' +
          x1.toFixed(2) +
          ' ' +
          y1.toFixed(2) +
          ' C' +
          c1x.toFixed(2) +
          ' ' +
          c1y.toFixed(2) +
          ' ' +
          c2x.toFixed(2) +
          ' ' +
          c2y.toFixed(2) +
          ' ' +
          x2.toFixed(2) +
          ' ' +
          y2.toFixed(2)
        );
      }

      function setCablePath(kind, d, on) {
        if (!cablesSvg) return;
        ['sleeve', 'core'].forEach(function (part) {
          var path = cablesSvg.querySelector('[data-cable="' + kind + '-' + part + '"]');
          if (!path) return;
          if (on && d) {
            path.setAttribute('d', d);
            path.style.display = '';
          } else {
            path.removeAttribute('d');
            path.style.display = 'none';
          }
        });
      }

      function placeAnchor(el, pos, on) {
        if (!el) return;
        el.classList.toggle('is-off', !on);
        if (on) {
          el.removeAttribute('hidden');
          el.style.left = pos.x + '%';
          el.style.top = pos.y + '%';
        } else {
          el.setAttribute('hidden', '');
        }
      }

      function drawCables() {
        if (!cablesSvg) return;
        if (deskEl) {
          cablesSvg.setAttribute('data-desk-light', deskEl.getAttribute('data-desk-light') || '0');
        }
        var needKb = kbCableOn && gearOn(kbEl);
        var needMouse = mouseCableOn && gearOn(mouseEl);
        var kb = needKb ? gearPct(kbEl) : null;
        var mouse = needMouse ? gearPct(mouseEl) : null;
        if (kb) {
          setCablePath(
            'kb',
            cableD(kb.left + kb.w * 0.5, kb.top + 0.4, kbAnchor.x, kbAnchor.y, 16),
            true
          );
          placeAnchor(kbAnchorEl, kbAnchor, true);
        } else {
          setCablePath('kb', '', false);
          placeAnchor(kbAnchorEl, kbAnchor, false);
        }
        if (mouse) {
          var port = mouseCableStart(mouse);
          setCablePath(
            'mouse',
            cableD(port.x, port.y, mouseAnchor.x, mouseAnchor.y, 20),
            true
          );
          placeAnchor(mouseAnchorEl, mouseAnchor, true);
        } else {
          setCablePath('mouse', '', false);
          placeAnchor(mouseAnchorEl, mouseAnchor, false);
        }
      }

      function enableAnchorDrag(el, pos) {
        if (!el || !pos) return;
        el.addEventListener('pointerdown', function (event) {
          if (event.button && event.button !== 0) return;
          var box = padSlot.getBoundingClientRect();
          var stageBox = stage.getBoundingClientRect();
          if (!box.width || !box.height) return;
          var padPxX = box.width * 0.012;
          var padPxY = box.height * 0.012;
          slide = {
            el: el,
            kind: 'anchor',
            pos: pos,
            pointerId: event.pointerId,
            flipped: false,
            raf: 0,
            slotLeft: box.left,
            slotTop: box.top,
            slotW: box.width,
            slotH: box.height,
            ox: 0,
            oy: 0,
            originX: 0,
            originY: 0,
            minX: stageBox.left - box.left + padPxX,
            maxX: stageBox.right - box.left - padPxX,
            minY: stageBox.top - box.top + padPxY,
            maxY: stageBox.bottom - box.top - padPxY,
            x: event.clientX - box.left,
            y: event.clientY - box.top,
            wPct: 0,
            hPct: 0
          };
          clampSlideXY(slide);
          el.classList.add('is-drag');
          try {
            el.setPointerCapture(event.pointerId);
          } catch (err) {}
          event.preventDefault();
          event.stopPropagation();
          paintSlide();
        });
        el.addEventListener('pointermove', moveSlide);
        el.addEventListener('pointerup', stopSlide);
        el.addEventListener('pointercancel', stopSlide);
        el.addEventListener('lostpointercapture', stopSlide);
      }

      function setKbCable(on) {
        if (typeof on === 'boolean') kbCableOn = on;
        else kbCableOn = !kbCableOn;
        var btn = root.querySelector('[data-kb-cable]');
        if (btn) {
          btn.classList.toggle('is-on', kbCableOn);
          btn.setAttribute('aria-pressed', kbCableOn ? 'true' : 'false');
        }
        drawCables();
      }

      function setMouseCable(on) {
        if (typeof on === 'boolean') mouseCableOn = on;
        else mouseCableOn = !mouseCableOn;
        var btn = root.querySelector('[data-mouse-cable]');
        if (btn) {
          btn.classList.toggle('is-on', mouseCableOn);
          btn.setAttribute('aria-pressed', mouseCableOn ? 'true' : 'false');
        }
        drawCables();
      }

      function setMouseFlip(on) {
        if (typeof on === 'boolean') mouseFlip = on;
        else mouseFlip = !mouseFlip;
        var btn = root.querySelector('[data-mouse-flip]');
        if (btn) {
          btn.classList.toggle('is-on', mouseFlip);
          btn.setAttribute('aria-pressed', mouseFlip ? 'true' : 'false');
        }
        if (mouseEl) mouseEl.classList.toggle('is-flipped', mouseFlip);
        drawCables();
      }

      function markMouseRgbSwatch(hex) {
        var host = root.querySelector('[data-studio-mouse-rgb-colors]');
        if (!host) return;
        host.querySelectorAll('[data-mouse-rgb-color]').forEach(function (btn) {
          var on = sameHex(btn.getAttribute('data-mouse-rgb-color'), hex);
          btn.classList.toggle('is-on', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var pickInput = root.querySelector('[data-mouse-rgb-color-input]');
        var pick = pickInput && pickInput.closest('.slydr-studio__rgb-pick');
        if (pickInput) pickInput.value = hex;
        if (pick) {
          pick.style.setProperty('--swatch', hex);
          var matched = rgbSwatches.some(function (item) {
            return sameHex(item.hex, hex);
          });
          pick.classList.toggle('is-on', !matched);
        }
      }

      function setMouseRgbColor(hex) {
        mouseRgbColor = normHex(hex);
        if (mouseEl) mouseEl.style.setProperty('--mouse-rgb', mouseRgbColor);
        markMouseRgbSwatch(mouseRgbColor);
        if (mouseType !== 'off' && mouseRgbOn) setMouse();
      }

      function setMouseRgb(on) {
        if (typeof on === 'boolean') mouseRgbOn = on;
        else mouseRgbOn = !mouseRgbOn;
        var btn = root.querySelector('[data-mouse-rgb]');
        if (btn) {
          btn.classList.toggle('is-on', mouseRgbOn);
          btn.setAttribute('aria-pressed', mouseRgbOn ? 'true' : 'false');
        }
        var panel = root.querySelector('[data-studio-mouse-rgb]');
        if (panel) showGear(panel, mouseRgbOn);
        if (mouseEl) mouseEl.setAttribute('data-rgb-mode', mouseRgbOn ? mouseRgbMode : 'off');
        if (mouseType !== 'off') setMouse();
        scheduleKbHeight();
      }

      function setMouseRgbMode(mode) {
        if (mode) mouseRgbMode = mode;
        root.querySelectorAll('[data-studio-mouse-rgb-modes] [data-mouse-rgb-mode]').forEach(function (btn) {
          var on = btn.getAttribute('data-mouse-rgb-mode') === mouseRgbMode;
          btn.classList.toggle('is-on', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (mouseEl) mouseEl.setAttribute('data-rgb-mode', mouseRgbOn ? mouseRgbMode : 'off');
      }

      function applyKbDims() {
        var preset = kbPreset[kbSize] || kbPreset['75'];
        var w = Math.max(readMm(kbWInput, preset.w), preset.w);
        var caseD = Math.max(readMm(kbDInput, preset.d), preset.d);
        var totalD = caseD + (restOn ? restMm : 0);
        var wp = (w / padMmW) * 100;
        var hp = (totalD / padMmH) * 100;
        var oldWp = parseFloat(kbEl.style.width);
        var oldHp = parseFloat(kbEl.style.height);
        var left = parseFloat(kbEl.style.left);
        var top = parseFloat(kbEl.style.top);
        kbEl.style.width = wp + '%';
        kbEl.style.height = hp + '%';
        if (!isNaN(oldWp) && !isNaN(oldHp) && !isNaN(left) && !isNaN(top)) {
          kbEl.style.left = left + (oldWp - wp) / 2 + '%';
          kbEl.style.top = top + (oldHp - hp) / 2 + '%';
        }
        var skin = gearSkin(kbColor);
        kbEl.style.background = skin.case;
        kbEl.style.boxShadow = 'inset 0 0 0 1px ' + skin.stroke;
        var face = kbEl.querySelector('.slydr-studio__kb-face');
        var svg = kbEl.querySelector('svg');
        var restEl = kbEl.querySelector('.slydr-studio__kb-rest');
        if (face) {
          face.style.height = (caseD / totalD) * 100 + '%';
        }
        if (svg) {
          svg.style.width = (preset.w / w) * 100 + '%';
          svg.style.height = (preset.d / caseD) * 100 + '%';
        }
        if (restEl) {
          restEl.style.height = (restMm / totalD) * 100 + '%';
          restEl.style.background = mixHex(kbColor, '#000000', 0.1);
          restEl.style.boxShadow = 'inset 0 0 0 1px ' + skin.stroke;
        }
        clampGearToDesk(kbEl);
        drawCables();
      }

      function placeKb() {
        var preset = kbPreset[kbSize] || kbPreset['75'];
        var w = Math.max(readMm(kbWInput, preset.w), preset.w);
        var caseD = Math.max(readMm(kbDInput, preset.d), preset.d);
        var totalD = caseD + (restOn ? restMm : 0);
        kbEl.style.left = (100 - (w / padMmW) * 100) / 2 + '%';
        kbEl.style.top = (100 - (totalD / padMmH) * 100) / 2 + '%';
      }

      function applyMouseDims() {
        var preset = mousePreset[mouseType] || mousePreset.m;
        mouseEl.style.width = (preset.w / padMmW) * 100 + '%';
        mouseEl.style.height = (preset.d / padMmH) * 100 + '%';
        clampGearToDesk(mouseEl);
        drawCables();
      }

      function setMeasureDisabled(kbOff) {
        [kbWInput, kbDInput].forEach(function (el) {
          if (el) el.disabled = !!kbOff;
        });
      }

      function setKb(size) {
        if (size) kbSize = size;
        root.querySelectorAll('[data-kb]').forEach(function (btn) {
          var on = btn.getAttribute('data-kb') === kbSize;
          btn.classList.toggle('is-on', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (kbSize === 'off') {
          showGear(kbEl, false);
          setMeasureDisabled(true);
          drawCables();
          return;
        }
        if (size && kbPreset[kbSize]) {
          fillMm(kbWInput, kbPreset[kbSize].w + (kbPreset[kbSize].extraW || 0));
          fillMm(kbDInput, kbPreset[kbSize].d);
          if (kbWInput) kbWInput.min = String(kbPreset[kbSize].w);
          if (kbDInput) kbDInput.min = String(kbPreset[kbSize].d);
        }
        kbEl.setAttribute('data-size', kbSize);
        kbEl.setAttribute('data-rgb-mode', kbRgbOn ? kbRgbMode : 'off');
        kbEl.innerHTML =
          '<div class="slydr-studio__kb-face">' +
          kbSvg(kbSize, kbColor) +
          '</div>' +
          (restOn ? '<div class="slydr-studio__kb-rest"></div>' : '');
        kbEl.classList.toggle('has-rest', restOn);
        showGear(kbEl, true);
        applyKbDims();
        if (size) {
          placeKb();
          drawCables();
        }
        setMeasureDisabled(false);
      }

      function setRest(on) {
        if (typeof on === 'boolean') restOn = on;
        else restOn = !restOn;
        var btn = root.querySelector('[data-rest]');
        if (btn) {
          btn.classList.toggle('is-on', restOn);
          btn.setAttribute('aria-pressed', restOn ? 'true' : 'false');
        }
        if (kbSize !== 'off') setKb();
      }

      function sameHex(a, b) {
        return String(a || '').replace('#', '').toLowerCase() === String(b || '').replace('#', '').toLowerCase();
      }

      function markRgbSwatch(hex) {
        var host = root.querySelector('[data-studio-rgb-colors]');
        if (!host) return;
        host.querySelectorAll('[data-rgb-color]').forEach(function (btn) {
          var on = sameHex(btn.getAttribute('data-rgb-color'), hex);
          btn.classList.toggle('is-on', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var pickInput = root.querySelector('[data-kb-rgb-color]');
        var pick = pickInput && pickInput.closest('.slydr-studio__rgb-pick');
        if (pick) {
          pick.style.setProperty('--swatch', hex);
          var matched = rgbSwatches.some(function (item) {
            return sameHex(item.hex, hex);
          });
          pick.classList.toggle('is-on', !matched);
        }
      }

      function setRgbColor(hex) {
        kbRgbColor = normHex(hex);
        var input = root.querySelector('[data-kb-rgb-color]');
        if (input) input.value = kbRgbColor;
        markRgbSwatch(kbRgbColor);
        if (kbSize !== 'off' && kbRgbOn) setKb();
      }

      function setRgb(on) {
        if (typeof on === 'boolean') kbRgbOn = on;
        else kbRgbOn = !kbRgbOn;
        var btn = root.querySelector('[data-kb-rgb]');
        if (btn) {
          btn.classList.toggle('is-on', kbRgbOn);
          btn.setAttribute('aria-pressed', kbRgbOn ? 'true' : 'false');
        }
        var panel = root.querySelector('[data-studio-rgb]');
        if (panel) showGear(panel, kbRgbOn);
        if (kbEl) kbEl.setAttribute('data-rgb-mode', kbRgbOn ? kbRgbMode : 'off');
        if (kbSize !== 'off') setKb();
        scheduleKbHeight();
      }

      function setRgbMode(mode) {
        if (mode) kbRgbMode = mode;
        root.querySelectorAll('[data-studio-rgb-modes] [data-rgb-mode]').forEach(function (btn) {
          var on = btn.getAttribute('data-rgb-mode') === kbRgbMode;
          btn.classList.toggle('is-on', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (kbEl) kbEl.setAttribute('data-rgb-mode', kbRgbOn ? kbRgbMode : 'off');
      }

      function setMouse(type) {
        if (typeof type === 'string') mouseType = type;
        root.querySelectorAll('[data-mouse]').forEach(function (btn) {
          var active = btn.getAttribute('data-mouse') === mouseType;
          btn.classList.toggle('is-on', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (mouseType === 'off') {
          showGear(mouseEl, false);
          drawCables();
          return;
        }
        mouseEl.innerHTML = mouseSvg(mouseColor, mouseType);
        mouseEl.classList.toggle('is-flipped', mouseFlip);
        mouseEl.setAttribute('data-rgb-mode', mouseRgbOn ? mouseRgbMode : 'off');
        mouseEl.style.setProperty('--mouse-rgb', mouseRgbColor);
        showGear(mouseEl, true);
        applyMouseDims();
      }

      function markGearSwatch(host, hex) {
        host.querySelectorAll('[data-gear-color]').forEach(function (btn) {
          var on = sameHex(btn.getAttribute('data-gear-color'), hex);
          btn.classList.toggle('is-on', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      function mountGearSwatches(host, getHex, setHex) {
        if (!host) return;
        gearSwatches.forEach(function (item) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'slydr-studio__pill slydr-studio__swatch';
          if (item.id === 'white') btn.classList.add('slydr-studio__swatch--light');
          btn.setAttribute('data-gear-color', item.hex);
          btn.style.setProperty('--swatch', item.hex);
          btn.style.background = item.hex;
          btn.setAttribute('title', item.title);
          btn.setAttribute('aria-label', item.title);
          btn.addEventListener('click', function () {
            setHex(item.hex);
            markGearSwatch(host, item.hex);
          });
          host.appendChild(btn);
        });
        markGearSwatch(host, getHex());
      }

      function enableDrag(el) {
        el.addEventListener('pointerdown', function (event) {
          if (event.button && event.button !== 0) return;
          var slot = padSlot.getBoundingClientRect();
          var desk = stage.getBoundingClientRect();
          var box = el.getBoundingClientRect();
          if (!slot.width || !slot.height || !box.width || !box.height) return;
          var inset = 4;
          var originX = box.left - slot.left;
          var originY = box.top - slot.top;
          slide = {
            el: el,
            kind: 'gear',
            pos: null,
            pointerId: event.pointerId,
            flipped: el.classList.contains('is-flipped'),
            raf: 0,
            slotLeft: slot.left,
            slotTop: slot.top,
            slotW: slot.width,
            slotH: slot.height,
            ox: event.clientX - box.left,
            oy: event.clientY - box.top,
            originX: originX,
            originY: originY,
            minX: desk.left - slot.left + inset,
            maxX: desk.right - slot.left - box.width - inset,
            minY: desk.top - slot.top + inset,
            maxY: desk.bottom - slot.top - box.height - inset,
            x: originX,
            y: originY,
            wPct: (box.width / slot.width) * 100,
            hPct: (box.height / slot.height) * 100
          };
          if (slide.maxX < slide.minX) slide.maxX = slide.minX;
          if (slide.maxY < slide.minY) slide.maxY = slide.minY;
          el.classList.add('is-drag');
          try {
            el.setPointerCapture(event.pointerId);
          } catch (err) {}
          event.preventDefault();
        });
        el.addEventListener('pointermove', moveSlide);
        el.addEventListener('pointerup', stopSlide);
        el.addEventListener('pointercancel', stopSlide);
        el.addEventListener('lostpointercapture', stopSlide);
      }

      slydrPads.forEach(function (item) {
        var swatch = padSwatchHex(item.title + ' ' + item.handle);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'slydr-studio__pill slydr-studio__swatch';
        if (swatch === '#d6d6d6') btn.classList.add('slydr-studio__swatch--light');
        if (swatch === '#111111') btn.classList.add('slydr-studio__swatch--dark');
        btn.setAttribute('data-pad', item.handle);
        btn.style.setProperty('--swatch', swatch);
        btn.style.background = swatch;
        btn.setAttribute('title', item.title);
        btn.setAttribute('aria-label', item.title);
        btn.addEventListener('click', function () {
          setPad(item.handle);
        });
        /* Warm on intent — loading all colourways up front cost a request each on every page view. */
        function warmPad() {
          loadPad(item.handle).catch(function () {});
        }
        btn.addEventListener('pointerenter', warmPad);
        btn.addEventListener('pointerdown', warmPad);
        btn.addEventListener('focus', warmPad);
        padHost.appendChild(btn);
      });

      if (padTestOn) {
        var testInput = document.createElement('input');
        testInput.type = 'file';
        testInput.accept = 'image/jpeg,image/png,image/webp,image/gif';
        testInput.hidden = true;
        testInput.setAttribute('aria-hidden', 'true');
        root.appendChild(testInput);

        testBtn = document.createElement('button');
        testBtn.type = 'button';
        testBtn.className = 'slydr-studio__pill slydr-studio__pad-test';
        testBtn.textContent = slydrT('padTest');
        testBtn.setAttribute('title', slydrT('padTestTitle'));
        testBtn.setAttribute('aria-label', slydrT('padTestAria'));
        testBtn.setAttribute('aria-pressed', 'false');
        testBtn.addEventListener('click', function () {
          testInput.click();
        });
        padHost.appendChild(testBtn);

        function applyLocalPad(file) {
          if (!file || !file.type || file.type.indexOf('image/') !== 0) return;
          if (testPadUrl) URL.revokeObjectURL(testPadUrl);
          testPadUrl = URL.createObjectURL(file);
          showPadSrc(testPadUrl, file.name || slydrT('padTest'), true);
          padHost.querySelectorAll('[data-pad]').forEach(function (btn) {
            btn.classList.remove('is-on');
            btn.setAttribute('aria-pressed', 'false');
          });
          testBtn.classList.add('is-on');
          testBtn.setAttribute('aria-pressed', 'true');
        }

        testInput.addEventListener('change', function () {
          var file = testInput.files && testInput.files[0];
          applyLocalPad(file);
          testInput.value = '';
        });

        padSlot.setAttribute('data-pad-drop', slydrT('padTestDrop'));
        padSlot.addEventListener('dragenter', function (event) {
          if (!event.dataTransfer || !event.dataTransfer.types) return;
          if (Array.prototype.indexOf.call(event.dataTransfer.types, 'Files') === -1) return;
          event.preventDefault();
          padSlot.classList.add('is-drop');
        });
        padSlot.addEventListener('dragover', function (event) {
          if (!event.dataTransfer) return;
          event.preventDefault();
          event.dataTransfer.dropEffect = 'copy';
          padSlot.classList.add('is-drop');
        });
        padSlot.addEventListener('dragleave', function (event) {
          if (event.relatedTarget && padSlot.contains(event.relatedTarget)) return;
          padSlot.classList.remove('is-drop');
        });
        padSlot.addEventListener('drop', function (event) {
          padSlot.classList.remove('is-drop');
          var files = event.dataTransfer && event.dataTransfer.files;
          if (!files || !files.length) return;
          event.preventDefault();
          applyLocalPad(files[0]);
        });
      }

      var current = slydrPads.filter(function (item) {
        return isCurrent(item.handle);
      })[0] || slydrPads[0];
      setPad(current.handle);

      var desks = [
        { id: 'black', title: slydrT('deskBlack'), hex: '#121212' },
        { id: 'walnut', title: slydrT('deskWalnut'), hex: '#3a2418' },
        { id: 'oak', title: slydrT('deskOak'), hex: '#c9a06c' },
        { id: 'white', title: slydrT('deskWhite'), hex: '#ececec' }
      ];
      var deskId = 'black';
      var deskCustomHex = '';
      var deskSavedCustomHex = '#6f8c75';
      var deskGrainOn = true;
      var deskScreenOn = false;
      var deskLight = 'mid';
      var deskRgbOn = false;
      var deskRgbColor = '#ef0e8a';
      var deskRgbMode = 'static';
      var screenTimer = 0;
      var screenScene = 0;
      var screenCast = null;
      var screenPlayUntil = 0;

      function deskHexOf(id) {
        var i;
        for (i = 0; i < desks.length; i += 1) {
          if (desks[i].id === id) return desks[i].hex;
        }
        return '#121212';
      }

      function currentDeskHex() {
        return deskCustomHex || deskHexOf(deskId);
      }

      function mountDeskGrain() {
        if (!deskEl || deskEl.querySelector('.slydr-studio__desk-grain')) return;
        var seed = 21;
        function rnd() {
          seed = (seed * 16807) % 2147483647;
          return (seed - 1) / 2147483646;
        }
        var W = 1900;
        var H = 1000;
        var y = 6;
        var lines = '';
        while (y < H - 4) {
          var amp = 1.6 + rnd() * 3.8;
          var step = 36 + rnd() * 22;
          var drift = (rnd() - 0.5) * amp;
          var waveAmp = 1.6 + rnd() * 2.4;
          var waveLen = 620 + rnd() * 720;
          var phase = rnd() * Math.PI * 2;
          var x = -50;
          var d =
            'M' +
            x.toFixed(1) +
            ' ' +
            (y + drift + Math.sin((x / waveLen) * Math.PI * 2 + phase) * waveAmp).toFixed(1);
          while (x < W + 50) {
            x += step;
            drift += (rnd() - 0.5) * 1.4;
            if (drift > amp) drift = amp * 0.86;
            if (drift < -amp) drift = -amp * 0.86;
            d +=
              'L' +
              x.toFixed(1) +
              ' ' +
              (y + drift + Math.sin((x / waveLen) * Math.PI * 2 + phase) * waveAmp).toFixed(1);
          }
          lines +=
            '<path opacity="' +
            (0.5 + rnd() * 0.32).toFixed(2) +
            '" stroke-width="' +
            (1.05 + rnd() * 0.95).toFixed(2) +
            '" d="' +
            d +
            '"/>';
          y += 10 + rnd() * 8;
        }
        deskEl.insertAdjacentHTML(
          'beforeend',
          '<svg class="slydr-studio__desk-grain" viewBox="0 0 1900 1000" preserveAspectRatio="none" aria-hidden="true">' +
            '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">' +
            lines +
            '</g></svg>'
        );
      }

      function markDeskPick() {
        var input = root.querySelector('[data-desk-color]');
        var pick = input && input.closest('.slydr-studio__rgb-pick');
        if (input && deskSavedCustomHex) input.value = deskSavedCustomHex;
        if (!pick) return;
        if (deskSavedCustomHex) pick.style.setProperty('--swatch', deskSavedCustomHex);
        pick.classList.toggle('is-on', !!deskCustomHex);
      }

      function applyDeskLook() {
        if (!deskEl) return;
        var hex = currentDeskHex();
        var light = hexIsLight(hex);
        if (deskCustomHex) {
          deskEl.setAttribute('data-desk', 'custom');
          deskEl.style.setProperty('--desk-color', hex);
        } else {
          deskEl.setAttribute('data-desk', deskId);
          deskEl.style.removeProperty('--desk-color');
        }
        deskEl.setAttribute('data-grain', deskGrainOn ? 'on' : 'off');
        deskEl.setAttribute('data-desk-light', light ? '1' : '0');
        if (deskHost) {
          deskHost.querySelectorAll('[data-desk-id]').forEach(function (btn) {
            var on = !deskCustomHex && btn.getAttribute('data-desk-id') === deskId;
            btn.classList.toggle('is-on', on);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        }
        var grainBtn = root.querySelector('[data-desk-grain]');
        if (grainBtn) {
          grainBtn.classList.toggle('is-on', deskGrainOn);
          grainBtn.setAttribute('aria-pressed', deskGrainOn ? 'true' : 'false');
        }
        markDeskPick();
        drawCables();
      }

      function setDesk(id) {
        deskId = id;
        deskCustomHex = '';
        applyDeskLook();
      }

      function setDeskColor(hex) {
        hex = normHex(hex);
        deskSavedCustomHex = hex;
        deskCustomHex = hex;
        applyDeskLook();
      }

      function setDeskGrain(on) {
        if (typeof on === 'boolean') deskGrainOn = on;
        else deskGrainOn = !deskGrainOn;
        applyDeskLook();
      }

      function screenHsl(h, s, l) {
        h = ((h % 360) + 360) % 360;
        return 'hsl(' + Math.round(h) + ' ' + Math.round(s) + '% ' + Math.round(l) + '%)';
      }

      var screenLooks = [
        { h: 210, s: 14, l: 54 },
        { h: 204, s: 16, l: 48 },
        { h: 95, s: 12, l: 40 },
        { h: 38, s: 16, l: 46 },
        { h: 28, s: 18, l: 44 },
        { h: 0, s: 10, l: 38 },
        { h: 220, s: 13, l: 34 },
        { h: 150, s: 10, l: 36 }
      ];

      function rollScreenPlay() {
        var look = screenLooks[screenScene];
        var worldL = (Math.random() < 0.5 ? -1 : 1) * (26 + Math.random() * 20);
        var worldR = -worldL + (Math.random() - 0.5) * 14;
        if (Math.random() > 0.72) worldR = (Math.random() < 0.5 ? 1 : -1) * (68 + Math.random() * 36);
        screenCast = {
          hChar: look.h + (Math.random() - 0.5) * 6,
          sChar: Math.max(8, look.s + (Math.random() - 0.5) * 2),
          lChar: look.l + (Math.random() - 0.5) * 3,
          worldL: worldL,
          worldR: worldR,
          twoTone: Math.random() < 0.32,
          t0: Date.now(),
          panDir: Math.random() < 0.5 ? 1 : -1,
          panAmp: 5 + Math.random() * 7,
          worldWander: 7 + Math.random() * 11
        };
        screenPlayUntil = Date.now() + 2800 + Math.random() * 2400;
      }

      function pulseScreen() {
        if (!deskScreenOn || !screenEl) return;
        var now = Date.now();
        if (!screenCast || now >= screenPlayUntil) {
          var hadCast = !!screenCast;
          var next = Math.floor(Math.random() * screenLooks.length);
          if (hadCast && screenLooks.length > 1 && next === screenScene) {
            next = (screenScene + 1 + Math.floor(Math.random() * (screenLooks.length - 1))) % screenLooks.length;
          }
          screenScene = next;
          rollScreenPlay();
        }
        var c = screenCast;
        var life = Math.max(1, screenPlayUntil - c.t0);
        var elapsed = (now - c.t0) / life;
        var wander = Math.sin(elapsed * Math.PI * 1.15) * c.worldWander;
        var h2 = c.hChar + c.worldL + wander;
        var h3 = c.twoTone ? h2 + Math.sin(elapsed * Math.PI) * 5 : c.hChar + c.worldR + wander * 0.55;
        var roll = Math.random();
        var wait = 420 + Math.random() * 380;
        var bright = 0.23 + Math.sin(elapsed * Math.PI * 2.1) * 0.045;
        var flick = 0.96 + Math.sin(elapsed * Math.PI * 3.4) * 0.03;
        if (roll > 0.93) {
          bright = 0.36 + Math.random() * 0.08;
          flick = 1;
          wait = 140 + Math.random() * 150;
        }
        screenEl.style.setProperty('--sc1', screenHsl(c.hChar, Math.min(24, c.sChar + 4), c.lChar + 7));
        screenEl.style.setProperty('--sc2', screenHsl(h2, Math.max(6, c.sChar), c.lChar - 2));
        screenEl.style.setProperty('--sc3', screenHsl(h3, Math.max(6, c.sChar - 2), c.lChar - 8));
        screenEl.style.setProperty('--sb', String(bright));
        screenEl.style.setProperty('--sx', 50 + Math.sin(elapsed * Math.PI) * c.panAmp * c.panDir + '%');
        screenEl.style.setProperty('--flick', String(flick));
        screenTimer = window.setTimeout(pulseScreen, wait);
      }

      function setDeskScreen(on) {
        if (typeof on === 'boolean') deskScreenOn = on;
        else deskScreenOn = !deskScreenOn;
        var btn = root.querySelector('[data-desk-screen]');
        if (btn) {
          btn.classList.toggle('is-on', deskScreenOn);
          btn.setAttribute('aria-pressed', deskScreenOn ? 'true' : 'false');
        }
        if (stage) stage.classList.toggle('is-screen', deskScreenOn);
        if (screenEl) showGear(screenEl, deskScreenOn);
        window.clearTimeout(screenTimer);
        screenCast = null;
        screenPlayUntil = 0;
        if (deskScreenOn) pulseScreen();
      }

      function setDeskLight(level) {
        var order = ['off', 'mid', 'bright'];
        var labels = {
          off: slydrT('lightsOff'),
          mid: slydrT('lightsMid'),
          bright: slydrT('lightsBright')
        };
        if (level && labels[level]) deskLight = level;
        else deskLight = order[(order.indexOf(deskLight) + 1) % order.length];
        var btn = root.querySelector('[data-studio-light]');
        if (btn) {
          btn.setAttribute('data-light', deskLight);
          btn.setAttribute('title', labels[deskLight]);
          btn.setAttribute('aria-label', labels[deskLight]);
          btn.classList.toggle('is-on', deskLight === 'bright');
        }
        if (stage) stage.setAttribute('data-light', deskLight);
      }

      function cardRestHeight(group, rgbSel) {
        if (!group) return 0;
        var h = group.offsetHeight;
        var rgb = rgbSel ? group.querySelector(rgbSel) : null;
        if (!rgb || rgb.hidden || rgb.classList.contains('is-off')) return h;
        var body = group.querySelector('.slydr-studio__group-body');
        var gap = body ? parseFloat(window.getComputedStyle(body).gap) || 0 : 0;
        return Math.max(0, h - rgb.offsetHeight - gap);
      }

      function syncKbHeight() {
        var kb = root.querySelector('.slydr-studio__group--kb');
        var desk = root.querySelector('.slydr-studio__group--desk');
        var pad = root.querySelector('.slydr-studio__group--pad');
        var mouse = root.querySelector('.slydr-studio__stack > .slydr-studio__group');
        var light = root.querySelector('.slydr-studio__group--light');
        var stack = root.querySelector('.slydr-studio__stack');
        if (!kb) return;
        if (
          kb.dataset.animating === '1' ||
          kb.classList.contains('is-closing') ||
          !kb.open
        ) {
          if (kb.dataset.animating !== '1') kb.style.minHeight = '';
          return;
        }
        if (!desk || !pad || !mouse || !light || !stack) {
          kb.style.minHeight = '';
          return;
        }
        kb.style.minHeight = alignedKbMin() + 'px';
      }

      function scheduleKbHeight() {
        window.requestAnimationFrame(syncKbHeight);
      }

      function applyDeskRgb() {
        if (!roomEl) return;
        roomEl.style.setProperty('--room-rgb', deskRgbColor);
        roomEl.setAttribute('data-rgb-mode', deskRgbOn ? deskRgbMode : 'off');
        showGear(roomEl, deskRgbOn);
      }

      function markDeskRgbSwatch(hex) {
        var host = root.querySelector('[data-studio-desk-rgb-colors]');
        if (!host) return;
        host.querySelectorAll('[data-desk-rgb-color]').forEach(function (btn) {
          var on = sameHex(btn.getAttribute('data-desk-rgb-color'), hex);
          btn.classList.toggle('is-on', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var pickInput = root.querySelector('[data-desk-rgb-color-input]');
        var pick = pickInput && pickInput.closest('.slydr-studio__rgb-pick');
        if (pick) {
          pick.style.setProperty('--swatch', hex);
          var matched = rgbSwatches.some(function (item) {
            return sameHex(item.hex, hex);
          });
          pick.classList.toggle('is-on', !matched);
        }
      }

      function setDeskRgbColor(hex) {
        deskRgbColor = normHex(hex);
        var input = root.querySelector('[data-desk-rgb-color-input]');
        if (input) input.value = deskRgbColor;
        markDeskRgbSwatch(deskRgbColor);
        applyDeskRgb();
      }

      function setDeskRgb(on) {
        if (typeof on === 'boolean') deskRgbOn = on;
        else deskRgbOn = !deskRgbOn;
        var btn = root.querySelector('[data-desk-rgb]');
        if (btn) {
          btn.classList.toggle('is-on', deskRgbOn);
          btn.setAttribute('aria-pressed', deskRgbOn ? 'true' : 'false');
        }
        var panel = root.querySelector('[data-studio-desk-rgb]');
        if (panel) showGear(panel, deskRgbOn);
        applyDeskRgb();
        scheduleKbHeight();
      }

      function setDeskRgbMode(mode) {
        if (mode) deskRgbMode = mode;
        root.querySelectorAll('[data-studio-desk-rgb-modes] [data-desk-rgb-mode]').forEach(function (btn) {
          var on = btn.getAttribute('data-desk-rgb-mode') === deskRgbMode;
          btn.classList.toggle('is-on', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        applyDeskRgb();
      }

      if (deskHost) {
        desks.forEach(function (item) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'slydr-studio__pill slydr-studio__swatch';
          if (item.id === 'white' || item.id === 'oak') {
            btn.classList.add('slydr-studio__swatch--light');
          }
          btn.setAttribute('data-desk-id', item.id);
          btn.style.setProperty('--swatch', item.hex);
          btn.style.background = item.hex;
          btn.setAttribute('title', item.title);
          btn.setAttribute('aria-label', item.title);
          btn.addEventListener('click', function () {
            setDesk(item.id);
          });
          deskHost.appendChild(btn);
        });
        mountDeskGrain();
        setDesk('black');
      }

      var deskColorInput = root.querySelector('[data-desk-color]');
      if (deskColorInput) {
        function openDeskPicker() {
          if (typeof deskColorInput.showPicker === 'function') {
            try {
              deskColorInput.showPicker();
              return;
            } catch (err) {}
          }
          deskColorInput.style.pointerEvents = 'auto';
          deskColorInput.click();
          deskColorInput.style.pointerEvents = '';
        }
        deskColorInput.addEventListener('input', function () {
          setDeskColor(deskColorInput.value);
        });
        deskColorInput.addEventListener('change', function () {
          setDeskColor(deskColorInput.value);
        });
        var deskPick = deskColorInput.closest('.slydr-studio__rgb-pick');
        if (deskPick) {
          deskPick.addEventListener('click', function (event) {
            event.preventDefault();
            setDeskColor(deskSavedCustomHex || deskColorInput.value);
          });
          deskPick.addEventListener('dblclick', function (event) {
            event.preventDefault();
            openDeskPicker();
          });
        }
      }
      root.querySelectorAll('[data-desk-grain]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setDeskGrain();
        });
      });
      root.querySelectorAll('[data-desk-screen]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setDeskScreen();
        });
      });
      root.querySelectorAll('[data-studio-grid-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setPadGrid();
        });
      });
      root.querySelectorAll('[data-desk-rgb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setDeskRgb();
        });
      });
      root.querySelectorAll('[data-studio-light]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setDeskLight();
        });
      });
      root.querySelectorAll('[data-studio-desk-rgb-modes] [data-desk-rgb-mode]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setDeskRgbMode(btn.getAttribute('data-desk-rgb-mode'));
        });
      });

      root.querySelectorAll('[data-kb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var size = btn.getAttribute('data-kb');
          setKb(kbSize === size ? 'off' : size);
        });
      });
      root.querySelectorAll('[data-key-tints]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          keyTintsOn = !keyTintsOn;
          btn.classList.toggle('is-on', keyTintsOn);
          btn.setAttribute('aria-pressed', keyTintsOn ? 'true' : 'false');
          if (kbSize !== 'off') setKb();
        });
      });
      root.querySelectorAll('[data-kb-rgb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setRgb();
        });
      });
      root.querySelectorAll('[data-studio-rgb-modes] [data-rgb-mode]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setRgbMode(btn.getAttribute('data-rgb-mode'));
        });
      });
      root.querySelectorAll('[data-rest]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setRest();
        });
      });
      root.querySelectorAll('[data-kb-cable]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setKbCable();
        });
      });
      root.querySelectorAll('[data-mouse]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var type = btn.getAttribute('data-mouse');
          setMouse(mouseType === type ? 'off' : type);
        });
      });
      root.querySelectorAll('[data-mouse-cable]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setMouseCable();
        });
      });
      root.querySelectorAll('[data-mouse-flip]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setMouseFlip();
        });
      });
      root.querySelectorAll('[data-mouse-rgb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setMouseRgb();
        });
      });
      root.querySelectorAll('[data-studio-mouse-rgb-modes] [data-mouse-rgb-mode]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setMouseRgbMode(btn.getAttribute('data-mouse-rgb-mode'));
        });
      });

      mountGearSwatches(
        root.querySelector('[data-studio-kb-colors]'),
        function () {
          return kbColor;
        },
        function (hex) {
          kbColor = hex;
          if (kbSize !== 'off') setKb();
        }
      );
      mountGearSwatches(
        root.querySelector('[data-studio-mouse-colors]'),
        function () {
          return mouseColor;
        },
        function (hex) {
          mouseColor = hex;
          if (mouseType !== 'off') setMouse();
        }
      );

      (function mountRgbSwatches() {
        var host = root.querySelector('[data-studio-rgb-colors]');
        if (!host) return;
        rgbSwatches.forEach(function (item) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'slydr-studio__pill slydr-studio__swatch';
          if (item.title === 'White' || item.title === slydrT('colorWhite')) btn.classList.add('slydr-studio__swatch--light');
          btn.setAttribute('data-rgb-color', item.hex);
          btn.style.setProperty('--swatch', item.hex);
          btn.style.background = item.hex;
          btn.setAttribute('title', slydrSwatchTitle(item.title));
          btn.setAttribute('aria-label', slydrSwatchTitle(item.title));
          btn.addEventListener('click', function () {
            setRgbColor(item.hex);
          });
          host.appendChild(btn);
        });
        markRgbSwatch(kbRgbColor);
      })();

      (function mountDeskRgbSwatches() {
        var host = root.querySelector('[data-studio-desk-rgb-colors]');
        if (!host) return;
        rgbSwatches.forEach(function (item) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'slydr-studio__pill slydr-studio__swatch';
          if (item.title === 'White' || item.title === slydrT('colorWhite')) btn.classList.add('slydr-studio__swatch--light');
          btn.setAttribute('data-desk-rgb-color', item.hex);
          btn.style.setProperty('--swatch', item.hex);
          btn.style.background = item.hex;
          btn.setAttribute('title', slydrSwatchTitle(item.title));
          btn.setAttribute('aria-label', slydrSwatchTitle(item.title));
          btn.addEventListener('click', function () {
            setDeskRgbColor(item.hex);
          });
          host.appendChild(btn);
        });
        markDeskRgbSwatch(deskRgbColor);
      })();

      var deskRgbInput = root.querySelector('[data-desk-rgb-color-input]');
      if (deskRgbInput) {
        deskRgbInput.addEventListener('input', function () {
          setDeskRgbColor(deskRgbInput.value);
        });
        deskRgbInput.addEventListener('change', function () {
          setDeskRgbColor(deskRgbInput.value);
        });
      }

      (function mountMouseRgbSwatches() {
        var host = root.querySelector('[data-studio-mouse-rgb-colors]');
        if (!host) return;
        rgbSwatches.forEach(function (item) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'slydr-studio__pill slydr-studio__swatch';
          if (item.title === 'White' || item.title === slydrT('colorWhite')) btn.classList.add('slydr-studio__swatch--light');
          btn.setAttribute('data-mouse-rgb-color', item.hex);
          btn.style.setProperty('--swatch', item.hex);
          btn.style.background = item.hex;
          btn.setAttribute('title', slydrSwatchTitle(item.title));
          btn.setAttribute('aria-label', slydrSwatchTitle(item.title));
          btn.addEventListener('click', function () {
            setMouseRgbColor(item.hex);
          });
          host.appendChild(btn);
        });
        markMouseRgbSwatch(mouseRgbColor);
      })();

      var mouseRgbInput = root.querySelector('[data-mouse-rgb-color-input]');
      if (mouseRgbInput) {
        mouseRgbInput.addEventListener('input', function () {
          setMouseRgbColor(mouseRgbInput.value);
        });
        mouseRgbInput.addEventListener('change', function () {
          setMouseRgbColor(mouseRgbInput.value);
        });
      }
      var rgbInput = root.querySelector('[data-kb-rgb-color]');
      if (rgbInput) {
        rgbInput.addEventListener('input', function () {
          setRgbColor(rgbInput.value);
        });
        rgbInput.addEventListener('change', function () {
          setRgbColor(rgbInput.value);
        });
      }

      [kbWInput, kbDInput].forEach(function (el) {
        if (!el) return;
        el.addEventListener('input', applyKbDims);
        el.addEventListener('change', function () {
          var preset = kbPreset[kbSize] || kbPreset['75'];
          if (el === kbWInput) fillMm(el, Math.max(readMm(el, preset.w), preset.w));
          else fillMm(el, Math.max(readMm(el, preset.d), preset.d));
          applyKbDims();
        });
      });

      enableDrag(kbEl);
      enableDrag(mouseEl);
      enableAnchorDrag(kbAnchorEl, kbAnchor);
      enableAnchorDrag(mouseAnchorEl, mouseAnchor);
      setKb('tkl');
      setRest(false);
      setMouse('m');
      setKbCable(false);
      setMouseCable(false);
      setMouseFlip(false);
      setRgb(false);
      setRgbMode(kbRgbMode);
      setMouseRgb(false);
      setMouseRgbMode(mouseRgbMode);
      setDeskScreen(false);
      setPadGrid(false);
      setDeskRgb(false);
      setDeskRgbMode(deskRgbMode);
      setDeskLight('mid');
      root.querySelectorAll('.slydr-studio__group').forEach(function (details) {
        var summary = details.querySelector(':scope > .slydr-studio__label');
        var body = details.querySelector(':scope > .slydr-studio__group-body');
        if (!summary || !body) return;
        summary.addEventListener('click', function (event) {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          event.preventDefault();
          if (details.dataset.animating === '1') return;
          if (details.open) {
            if (!animateGroup(details, false)) {
              details.removeAttribute('open');
              details.classList.remove('is-closing');
            }
          } else if (!animateGroup(details, true)) {
            details.setAttribute('open', '');
            scheduleKbHeight();
          }
        });
      });
      root.querySelectorAll('.slydr-studio__group').forEach(function (el) {
        el.addEventListener('toggle', scheduleKbHeight);
      });
      window.slydrSyncKbHeight = scheduleKbHeight;
      if (!window.__slydrKbResizeBound) {
        window.__slydrKbResizeBound = true;
        window.addEventListener('resize', function () {
          if (typeof window.slydrSyncKbHeight === 'function') window.slydrSyncKbHeight();
        });
      }
      scheduleKbHeight();
      window.slydrDrawCables = drawCables;
      if (window.ResizeObserver) {
        new ResizeObserver(drawCables).observe(padSlot);
      } else if (!window.__slydrCableResizeBound) {
        window.__slydrCableResizeBound = true;
        window.addEventListener('resize', function () {
          if (typeof window.slydrDrawCables === 'function') window.slydrDrawCables();
        });
      }
    }
    initPadStudio();

    function initProductMediaGlow() {
      if (!document.body.classList.contains('template-product')) return;
      var root =
        document.querySelector('#MainContent media-gallery') ||
        document.querySelector('#MainContent .product-gallery') ||
        document.querySelector('#MainContent .product-media-container') ||
        document.querySelector('#MainContent .product-media');
      if (!root) return;
      var viewer =
        root.querySelector('.swiper-main') ||
        root.querySelector('swiper-component') ||
        root.querySelector('.swiper__container') ||
        root.querySelector('slideshow-component') ||
        root.querySelector('.product-gallery__viewer') ||
        root.querySelector('.product-media__main') ||
        root.querySelector('.media-gallery__viewer') ||
        root;
      viewer.classList.add('slydr-media-glow');

      function markPadCursor() {
        viewer
          .querySelectorAll('.product-media-container--slide')
          .forEach(function (slide) {
            if (slide.getAttribute('data-zoom-index') === '0') {
              slide.classList.add('slydr-pad-cursor');
            }
          });
      }
      markPadCursor();
      setTimeout(markPadCursor, 400);
    }
    initProductMediaGlow();

    function initTrophyTomPulse() {
      var root = document.querySelector('#MainContent');
      if (!root) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      /* Colorway swaps re-call this; never stack a second timer chain. */
      if (root.__slydrTrophyBound) return;
      root.__slydrTrophyBound = true;

      var marks = [];
      var trophyName = /^\s*trophy\s+tom\s*$/i;
      var trophyFind = /trophy\s+tom/gi;
      var pulseTimer = 0;
      var waitTimer = 0;

      root.querySelectorAll('strong, b').forEach(function (el) {
        if (el.classList.contains('slydr-trophy-tom')) {
          marks.push(el);
          return;
        }
        if (!trophyName.test(el.textContent || '')) return;
        el.classList.add('slydr-trophy-tom');
        marks.push(el);
      });

      if (!marks.length) {
        var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
        var texts = [];
        while (walker.nextNode()) {
          var node = walker.currentNode;
          if (!node.nodeValue || !trophyFind.test(node.nodeValue)) continue;
          trophyFind.lastIndex = 0;
          if (
            node.parentElement &&
            node.parentElement.closest('script, style, noscript, .slydr-trophy-tom')
          ) {
            continue;
          }
          texts.push(node);
        }
        texts.forEach(function (tn) {
          var text = tn.nodeValue;
          trophyFind.lastIndex = 0;
          if (!trophyFind.test(text)) return;
          trophyFind.lastIndex = 0;
          var frag = document.createDocumentFragment();
          var last = 0;
          var match;
          while ((match = trophyFind.exec(text))) {
            if (match.index > last) {
              frag.appendChild(document.createTextNode(text.slice(last, match.index)));
            }
            var span = document.createElement('span');
            span.className = 'slydr-trophy-tom';
            span.textContent = match[0];
            frag.appendChild(span);
            marks.push(span);
            last = match.index + match[0].length;
          }
          if (last < text.length) {
            frag.appendChild(document.createTextNode(text.slice(last)));
          }
          tn.parentNode.replaceChild(frag, tn);
        });
      }

      if (!marks.length) return;

      marks.forEach(function (el) {
        var cs = window.getComputedStyle(el);
        var ink = cs.color;
        var fill = cs.getPropertyValue('-webkit-text-fill-color');
        if (!fill || fill === 'transparent' || fill === 'rgba(0, 0, 0, 0)') {
          fill = ink;
        }
        el.style.setProperty('--slydr-trophy-ink', ink);
        el.style.setProperty('--slydr-trophy-fill', fill);
      });

      function pulse() {
        if (!marks.length || !marks[0].isConnected) return;
        if (document.visibilityState === 'hidden') {
          schedule();
          return;
        }
        marks.forEach(function (el) {
          el.classList.add('is-on');
        });
        pulseTimer = setTimeout(function () {
          pulseTimer = 0;
          marks.forEach(function (el) {
            el.classList.remove('is-on');
          });
          schedule();
        }, 5000);
      }

      function schedule() {
        if (!marks.length || !marks[0].isConnected) return;
        waitTimer = setTimeout(pulse, 10000 + Math.random() * 20000);
      }

      schedule();
    }
    initTrophyTomPulse();

    var logoHoverCard = null;
    var logoCardSel = '.product-card-wrapper, .card-wrapper, .card-product, product-card, .product-card';

    function logoFromCard(card) {
      var blob = (card.textContent || '') + ' ';
      var link = card.querySelector('a[href*="/products/"]');
      if (link) blob += link.getAttribute('href') || '';
      return colorFromText(blob);
    }

    document.addEventListener('mouseover', function (event) {
      var node = event.target;
      if (!node || !node.closest) return;
      var card = node.closest(logoCardSel);
      if (!card || card === logoHoverCard) return;
      logoHoverCard = card;
      setLogoR(logoFromCard(card));
    });

    document.addEventListener('mouseout', function (event) {
      if (!logoHoverCard) return;
      var next = event.relatedTarget;
      if (next && logoHoverCard.contains(next)) return;
      var nextCard = next && next.closest ? next.closest(logoCardSel) : null;
      if (nextCard) {
        logoHoverCard = nextCard;
        setLogoR(logoFromCard(nextCard));
        return;
      }
      logoHoverCard = null;
      setLogoR(colorFromText(pageText));
    });

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var hero = document.querySelector('[data-slydr-hero]');
    if (hero) {
      var mqHeroMobile = window.matchMedia('(max-width: 749px)');
      function isHeroMobile() {
        return mqHeroMobile.matches;
      }

      /*
       * Mobile only: JS/WebGL ticks at 60Hz. Time-based loops keep their
       * duration; extra 120Hz frames are skipped. Desktop stays uncapped.
       */
      function heroMobileFrameDue(now, stamp) {
        if (!isHeroMobile()) return true;
        var t = now || 0;
        if (stamp.t && t - stamp.t < 1000 / 60 - 1) return false;
        stamp.t = t;
        return true;
      }

      function heroSlideId() {
        return hero.getAttribute('data-hero-slide') || 'intro';
      }
      function heroIsShowcase() {
        return hero.classList.contains('slydr-hero--showcase');
      }
      function heroIsStormKeys() {
        return hero.classList.contains('slydr-hero--cold-keys');
      }

      function padRest(face) {
        if (face.closest('.slydr-hero__pad--1')) return 'rotate(-10deg)';
        if (face.closest('.slydr-hero__pad--2')) return 'rotate(-5deg)';
        if (face.closest('.slydr-hero__pad--3')) return 'rotate(2deg)';
        if (face.closest('.slydr-hero__pad--4')) {
          if (hero.classList.contains('slydr-hero--3d-ready')) {
            return (
              'translate(var(--slydr-pad-ox, 0px), var(--slydr-pad-oy, 0px)) scale(var(--slydr-pad-zoom, 1))'
            );
          }
          return 'scale(1.265)';
        }
        return '';
      }

      function bindPadHover(el) {
        var face = el.querySelector('.slydr-hero__pad-face');
        if (!face) return;
        el.addEventListener('mouseenter', function () {
          face.style.transition = 'none';
          face.style.transform = '';
          el.classList.add('slydr-pad-live');
        });
        el.addEventListener('mouseleave', function () {
          var now = window.getComputedStyle(face).transform;
          el.classList.remove('slydr-pad-live');
          face.style.transition = 'none';
          face.style.transform = now && now !== 'none' ? now : padRest(face);
          void face.offsetWidth;
          face.style.transition = 'transform 1.6s ease';
          face.style.transform = padRest(face);
        });
      }

      var keysWrap = hero.querySelector('.slydr-hero__keys');
      var sweepRaf = 0;
      var sweepTimer = 0;
      var twinkleRaf = 0;
      var sweeping = false;
      var pendingWave = false;
      var sweepFrame = null;
      var heroSweepHz = { t: 0 };
      var heroTwinkleHz = { t: 0 };
      var twinkles = [];
      var lastKeyW = 0;
      var lastKeyH = 0;
      var keysResizeTimer = 0;
      var holdMs = 0;
      var hiddenAt = 0;
      var heroRaf = 0;
      var heroOnScreen = true;

      function pageHidden() {
        return document.visibilityState === 'hidden';
      }

      /*
       * Twinkles, waves and the CSS loops all run forever otherwise. Scrolled
       * past the hero none of it is visible: --dormant freezes the CSS side and
       * no new key FX are started. Running ones are left to finish so the keys
       * never freeze mid-glow.
       */
      if (typeof IntersectionObserver !== 'undefined') {
        new IntersectionObserver(
          function (entries) {
            heroOnScreen = entries[entries.length - 1].isIntersecting;
            hero.classList.toggle('slydr-hero--dormant', !heroOnScreen);
          },
          { rootMargin: '200px 0px' }
        ).observe(hero);
      }

      function beat(now) {
        return now - holdMs;
      }

      function setGlow(el, value) {
        var next = value || 0;
        /* Quantize: 1% opacity steps are invisible, but every write on one of
           the ~300 key spans costs a style recalc + repaint. */
        next = next > 0.004 ? Math.round(next * 100) / 100 : 0;
        if (el._slydrGlow === next) return;
        el._slydrGlow = next;
        el.style.setProperty('--slydr-key-glow', next ? String(next) : '0');
      }

      function buildKeys() {
        if (!keysWrap) return;
        twinkles = [];
        keysWrap.innerHTML = '';
        var width = keysWrap.offsetWidth || hero.offsetWidth || 1200;
        var height = keysWrap.offsetHeight || hero.offsetHeight || 600;
        var step = 7 / Math.cos((35 * Math.PI) / 180);
        var extra = Math.ceil(height * Math.tan((35 * Math.PI) / 180)) + 80;
        var count = Math.ceil((width + extra * 2) / step);
        var frag = document.createDocumentFragment();
        for (var k = 0; k < count; k += 1) {
          var key = document.createElement('span');
          key.className = 'slydr-hero__key';
          key.style.left = k * step - extra + 'px';
          key._slydrGlow = 0;
          frag.appendChild(key);
        }
        keysWrap.appendChild(frag);
      }

      function clearKeys() {
        if (!keysWrap) return;
        var nodes = keysWrap.children;
        for (var c = 0; c < nodes.length; c += 1) {
          setGlow(nodes[c], 0);
        }
      }

      function pickIdleKey() {
        var keys = keysWrap.children;
        var n = keys.length;
        if (!n) return null;
        var attempt;
        for (attempt = 0; attempt < 16; attempt += 1) {
          var idx = Math.floor(Math.random() * n);
          var close = twinkles.some(function (item) {
            return Math.abs(item.index - idx) < 10;
          });
          if (!close) {
            return { el: keys[idx], index: idx };
          }
        }
        return null;
      }

      function spawnTwinkle() {
        if (pageHidden() || !heroOnScreen || sweeping || !keysWrap || twinkles.length >= 4) return;
        var pick = pickIdleKey();
        if (!pick) return;
        var storm = heroIsStormKeys();
        twinkles.push({
          el: pick.el,
          index: pick.index,
          start: beat(performance.now()),
          duration: storm ? 180 + Math.random() * 320 : 3600 + Math.random() * 2400,
          peak: storm ? 0.55 + Math.random() * 0.45 : 0.1 + Math.random() * 0.08
        });
        if (!twinkleRaf) {
          twinkleRaf = requestAnimationFrame(tickTwinkles);
        }
      }

      function tickTwinkles(now) {
        twinkleRaf = 0;
        if (sweeping || pageHidden()) return;
        if (!heroMobileFrameDue(now, heroTwinkleHz)) {
          twinkleRaf = requestAnimationFrame(tickTwinkles);
          return;
        }
        now = beat(now);
        for (var i = twinkles.length - 1; i >= 0; i -= 1) {
          var item = twinkles[i];
          var u = (now - item.start) / item.duration;
          if (u >= 1) {
            setGlow(item.el, 0);
            twinkles.splice(i, 1);
            continue;
          }
          setGlow(item.el, Math.sin(u * Math.PI) * item.peak);
        }
        if (twinkles.length) {
          twinkleRaf = requestAnimationFrame(tickTwinkles);
        }
      }

      function nextTwinkleWait() {
        var roll = Math.random();
        var live = twinkles.length;
        var storm = heroIsStormKeys();
        if (storm) {
          if (live === 0) return 400 + Math.random() * 1400;
          if (live < 4 && roll < 0.65) return 60 + Math.random() * 180;
          return 700 + Math.random() * 1600;
        }
        // Empty: often a quiet stretch, sometimes the start of a small cluster.
        if (live === 0) {
          if (roll < 0.38) return 4500 + Math.random() * 5500; // 4.5–10s nothing
          if (roll < 0.72) return 2000 + Math.random() * 3000;
          return 500 + Math.random() * 900; // cluster incoming
        }
        // Already lit: sometimes stack 2–4 quickly, sometimes leave them alone.
        if (live < 4 && roll < 0.5) {
          return 220 + Math.random() * 580;
        }
        if (live >= 3) return 3200 + Math.random() * 4800;
        return 1800 + Math.random() * 4200;
      }

      function scheduleTwinkle() {
        setTimeout(function () {
          spawnTwinkle();
          scheduleTwinkle();
        }, nextTwinkleWait());
      }

      function beginWave() {
        if (sweeping || pageHidden()) return false;
        if (!keysWrap || !keysWrap.children.length) {
          scheduleSweep();
          return false;
        }
        sweeping = true;
        if (twinkleRaf) {
          cancelAnimationFrame(twinkleRaf);
          twinkleRaf = 0;
        }
        return true;
      }

      function endWave() {
        twinkles = [];
        clearKeys();
        sweepRaf = 0;
        sweepFrame = null;
        sweeping = false;
        scheduleSweep();
      }

      function fadeTwinkles(now, start, fadeMs) {
        var fadeU = Math.min(1, (now - start) / fadeMs);
        var twinkleMul = 0.5 * (1 + Math.cos(Math.PI * fadeU));
        var extra = {};
        for (var ti = twinkles.length - 1; ti >= 0; ti -= 1) {
          var item = twinkles[ti];
          var u = (now - item.start) / item.duration;
          if (u >= 1 || fadeU >= 1) {
            twinkles.splice(ti, 1);
            continue;
          }
          extra[item.index] = Math.sin(u * Math.PI) * item.peak * twinkleMul;
        }
        return extra;
      }

      /*
       * Glow band width in key-index units. Mobile: narrower so fewer
       * box-shadows light at once. Desktop keeps the original wide wash.
       */
      var KEY_SWEEP_HALF = isHeroMobile() ? 20 : 56;
      var KEY_BURST_HALF_IDLE = isHeroMobile() ? 10 : 24;
      var KEY_BURST_HALF_FAST = isHeroMobile() ? 12 : 28;

      function runSweep() {
        if (!beginWave()) return;
        var keys = keysWrap.children;
        var n = keys.length;
        var half = KEY_SWEEP_HALF;
        var duration = 5000;
        var fadeMs = 900;
        var start = beat(performance.now());
        var span = n + half * 2;

        function frame(now) {
          if (pageHidden()) {
            sweepRaf = 0;
            return;
          }
          if (!heroMobileFrameDue(now, heroSweepHz)) {
            sweepRaf = requestAnimationFrame(frame);
            return;
          }
          now = beat(now);
          var t = (now - start) / duration;
          var extra = fadeTwinkles(now, start, fadeMs);
          if (t >= 1) {
            endWave();
            return;
          }
          var center = t * span - half;
          for (var i = 0; i < n; i += 1) {
            var d = Math.abs(i - center) / half;
            var o = d < 1 ? 0.5 * (1 + Math.cos(Math.PI * d)) : 0;
            if (extra[i] > o) o = extra[i];
            setGlow(keys[i], o);
          }
          sweepRaf = requestAnimationFrame(frame);
        }
        sweepFrame = frame;
        if (sweepRaf) cancelAnimationFrame(sweepRaf);
        sweepRaf = requestAnimationFrame(frame);
      }

      function buildLightningStrikes(n, startAt) {
        var strikes = [];
        var t = startAt || 0;
        var count = 3 + Math.floor(Math.random() * 4);
        var i;
        for (i = 0; i < count; i += 1) {
          if (i > 0) t += 70 + Math.random() * 280;
          else t += 40 + Math.random() * 80;
          strikes.push({
            at: t,
            center: Math.floor(Math.random() * n),
            width: 1 + Math.floor(Math.random() * 7),
            peak: 0.9 + Math.random() * 0.55,
            flickers: 2 + Math.floor(Math.random() * 3)
          });
        }
        if (n > 20 && Math.random() < 0.55) {
          var main = strikes[Math.floor(Math.random() * strikes.length)];
          strikes.push({
            at: main.at + 30 + Math.random() * 50,
            center: Math.max(0, Math.min(n - 1, main.center + (Math.random() < 0.5 ? -12 : 12))),
            width: 1 + Math.floor(Math.random() * 4),
            peak: main.peak * 0.75,
            flickers: 2
          });
        }
        return strikes;
      }

      function lightningLevel(strikes, n, elapsed, index) {
        var best = 0;
        for (var s = 0; s < strikes.length; s += 1) {
          var strike = strikes[s];
          var local = elapsed - strike.at;
          if (local < 0) continue;
          var windowMs = strike.flickers * 52;
          if (local > windowMs + 120) continue;
          var flickerOn = Math.floor(local / 42) % 2 === 0;
          var envelope =
            local <= windowMs ? (flickerOn ? 1 : 0.12) : Math.max(0, 1 - (local - windowMs) / 120);
          envelope *= envelope;
          var d = Math.abs(index - strike.center) / Math.max(1, strike.width);
          if (d >= 1) continue;
          var o = strike.peak * (1 - d) * (1 - d) * envelope;
          if (o > best) best = o;
        }
        return best;
      }

      function runBurst(opts) {
        if (!beginWave()) return;
        opts = opts || {};
        var fast = !!opts.fast;
        var withLightning = !!opts.withLightning;
        var keys = keysWrap.children;
        var n = keys.length;
        var mid = (n - 1) / 2;
        var halfMin = 2.15;
        var halfMax = fast ? KEY_BURST_HALF_FAST : KEY_BURST_HALF_IDLE;
        var duration = fast ? 1500 : 5000;
        var fadeInMs = fast ? 45 : 130;
        var spreadEnd = fast ? 0.16 : 0.075;
        var fadeMs = fast ? 260 : 900;
        var tailMs = fast ? 280 : 600;
        var start = beat(performance.now());
        var maxR = n / 2 + halfMax * 1.35;
        /* Lightning starts ~180ms into the transition burst */
        var strikes = withLightning ? buildLightningStrikes(n, 180 + Math.random() * 120) : [];
        if (withLightning && strikes.length) {
          /* keep burst alive until bolts finish */
          var lastBolt = 0;
          for (var b = 0; b < strikes.length; b += 1) {
            var end = strikes[b].at + strikes[b].flickers * 52 + 120;
            if (end > lastBolt) lastBolt = end;
          }
          duration = Math.max(duration, lastBolt + 200);
        }

        function frame(now) {
          if (pageHidden()) {
            sweepRaf = 0;
            return;
          }
          if (!heroMobileFrameDue(now, heroSweepHz)) {
            sweepRaf = requestAnimationFrame(frame);
            return;
          }
          now = beat(now);
          var elapsed = now - start;
          var t = elapsed / duration;
          var extra = fadeTwinkles(now, start, fadeMs);
          if (t >= 1) {
            endWave();
            return;
          }
          var fadeIn = Math.min(1, elapsed / fadeInMs);
          fadeIn *= fadeIn;
          /*
           * Ramp everything to 0 before the burst ends. Without this the keys
           * under the ring were still lit at t=1 and endWave dropped them all
           * in one task — ~50 blurred box-shadow repaints in a single frame.
           */
          var tail = Math.min(1, (duration - elapsed) / tailMs);
          if (tail < 0) tail = 0;
          tail = tail * tail * (3 - 2 * tail);
          var spreadU = Math.min(1, t / spreadEnd);
          spreadU = spreadU * spreadU * (3 - 2 * spreadU);
          var half = halfMin + (halfMax - halfMin) * spreadU;
          var ring = t * maxR;
          var flash = Math.max(0, 1 - t / (fast ? 0.1 : 0.06));
          flash = flash * flash * (fast ? 0.4 : 0.28) * fadeIn;
          for (var i = 0; i < n; i += 1) {
            var dist = Math.abs(i - mid);
            var d = Math.abs(dist - ring) / half;
            var o = d < 1 ? 0.62 * (1 + Math.cos(Math.PI * d)) : 0;
            if (dist < 2.2) o = Math.max(o, flash * (1 - dist / 2.2));
            if (!isHeroMobile() && ring > 1 && dist < ring) {
              o = Math.max(o, (1 - dist / ring) * 0.18 * (1 - t));
            }
            o *= fadeIn;
            if (withLightning) {
              o = Math.max(o, lightningLevel(strikes, n, elapsed, i));
            }
            if (extra[i] > o) o = extra[i];
            if (tail < 1) o *= tail;
            setGlow(keys[i], o);
          }
          sweepRaf = requestAnimationFrame(frame);
        }
        sweepFrame = frame;
        if (sweepRaf) cancelAnimationFrame(sweepRaf);
        sweepRaf = requestAnimationFrame(frame);
      }

      function runLightning() {
        if (!beginWave()) return;
        var keys = keysWrap.children;
        var n = keys.length;
        var start = beat(performance.now());
        var strikes = buildLightningStrikes(n, 0);
        var totalDur = 0;
        var i;
        for (i = 0; i < strikes.length; i += 1) {
          var end = strikes[i].at + strikes[i].flickers * 52 + 120;
          if (end > totalDur) totalDur = end;
        }
        totalDur += 80;

        function frame(now) {
          if (pageHidden()) {
            sweepRaf = 0;
            return;
          }
          if (!heroMobileFrameDue(now, heroSweepHz)) {
            sweepRaf = requestAnimationFrame(frame);
            return;
          }
          now = beat(now);
          var elapsed = now - start;
          if (elapsed >= totalDur) {
            endWave();
            return;
          }
          for (i = 0; i < n; i += 1) {
            setGlow(keys[i], lightningLevel(strikes, n, elapsed, i));
          }
          sweepRaf = requestAnimationFrame(frame);
        }
        sweepFrame = frame;
        if (sweepRaf) cancelAnimationFrame(sweepRaf);
        sweepRaf = requestAnimationFrame(frame);
      }

      function fxWaveOn() {
        return hero.getAttribute('data-fx-wave') !== '0';
      }

      function fxBurstOn() {
        return hero.getAttribute('data-fx-burst') !== '0';
      }

      function syncFxAttrs(cfg) {
        var fx = (cfg && cfg.fx) || {};
        var burstOn = !!(fx.burst && fx.burst !== 'off');
        var waveOn = fx.wave !== false;
        hero.setAttribute('data-fx-wave', waveOn ? '1' : '0');
        hero.setAttribute('data-fx-burst', burstOn ? '1' : '0');
      }

      function runWave() {
        if (pageHidden()) {
          pendingWave = true;
          return;
        }
        if (!heroOnScreen) {
          scheduleSweep();
          return;
        }
        pendingWave = false;
        if (heroIsStormKeys()) {
          runLightning();
          return;
        }
        var waveOn = fxWaveOn();
        var burstOn = fxBurstOn();
        if (waveOn && burstOn) {
          if (Math.random() < 0.5) runSweep();
          else runBurst();
          return;
        }
        if (waveOn) {
          runSweep();
          return;
        }
        if (burstOn) {
          runBurst();
          return;
        }
        scheduleSweep();
      }

      function scheduleSweep() {
        if (reduce) return;
        if (sweepTimer) window.clearTimeout(sweepTimer);
        var storm = heroIsStormKeys();
        var wait = storm ? 900 + Math.random() * 3200 : 20000 + Math.random() * 20000;
        sweepTimer = window.setTimeout(function () {
          sweepTimer = 0;
          if (!storm && !fxWaveOn() && !fxBurstOn()) {
            scheduleSweep();
            return;
          }
          runWave();
        }, wait);
      }

      function rememberKeySize() {
        lastKeyW = keysWrap ? keysWrap.offsetWidth || hero.offsetWidth : 0;
        lastKeyH = keysWrap ? keysWrap.offsetHeight || hero.offsetHeight : 0;
      }

      buildKeys();
      rememberKeySize();
      window.addEventListener('resize', function () {
        if (keysResizeTimer) window.clearTimeout(keysResizeTimer);
        keysResizeTimer = window.setTimeout(function () {
          keysResizeTimer = 0;
          var w = keysWrap ? keysWrap.offsetWidth || hero.offsetWidth : 0;
          var h = keysWrap ? keysWrap.offsetHeight || hero.offsetHeight : 0;
          if (Math.abs(w - lastKeyW) < 2 && Math.abs(h - lastKeyH) < 2) return;
          lastKeyW = w;
          lastKeyH = h;
          var wasSweeping = sweeping;
          if (sweepRaf) {
            cancelAnimationFrame(sweepRaf);
            sweepRaf = 0;
          }
          if (twinkleRaf) {
            cancelAnimationFrame(twinkleRaf);
            twinkleRaf = 0;
          }
          sweeping = false;
          sweepFrame = null;
          buildKeys();
          rememberKeySize();
          if (!reduce && wasSweeping) scheduleSweep();
        }, 140);
      });

      if (!reduce) {
        if (!isHeroMobile()) {
          hero
            .querySelectorAll(
              '.slydr-hero__pad--1, .slydr-hero__pad--2, .slydr-hero__pad--3, .slydr-hero__featured'
            )
            .forEach(bindPadHover);
        }
        scheduleSweep();
        scheduleTwinkle();
      }

      var padShift = new Map();
      var parallaxOn =
        hero.getAttribute('data-slydr-parallax') === '1' &&
        !reduce &&
        !isHeroMobile();
      var layers = hero.querySelectorAll('[data-slydr-depth]');
      var tx = 0;
      var ty = 0;
      var cx = 0;
      var cy = 0;

      function clampLeash(x, y, max) {
        var dist = Math.hypot(x, y);
        if (!max || dist <= max) return { x: x, y: y };
        return { x: (x * max) / dist, y: (y * max) / dist };
      }

      function dragMax(el) {
        var box = el.getBoundingClientRect();
        return Math.max(36, Math.min(72, Math.min(box.width, box.height) * 0.26));
      }

      function heroBusy() {
        if (pageHidden()) return false;
        if (parallaxOn && (Math.abs(tx) > 0.001 || Math.abs(ty) > 0.001 || Math.abs(cx) > 0.001 || Math.abs(cy) > 0.001)) {
          return true;
        }
        var live = false;
        padShift.forEach(function (state) {
          if (
            state.dragging ||
            state.returnAt ||
            Math.abs(state.x) > 0.02 ||
            Math.abs(state.y) > 0.02
          ) {
            live = true;
          }
        });
        return live;
      }

      function kickHeroTick() {
        if (heroRaf || reduce || pageHidden()) return;
        if (!parallaxOn && !padShift.size) return;
        heroRaf = requestAnimationFrame(heroTick);
      }

      function heroTick(now) {
        heroRaf = 0;
        if (pageHidden()) {
          hero.classList.remove('slydr-hero--live');
          return;
        }
        now = beat(now);
        if (parallaxOn) {
          cx += (tx - cx) * 0.08;
          cy += (ty - cy) * 0.08;
          if (Math.abs(cx) < 0.001) cx = 0;
          if (Math.abs(cy) < 0.001) cy = 0;
        }
        padShift.forEach(function (state) {
          if (state.dragging || !state.returnAt) return;
          var u = Math.min(1, (now - state.returnAt) / 620);
          var e = 1 - Math.pow(1 - u, 3);
          state.x = state.returnFromX * (1 - e);
          state.y = state.returnFromY * (1 - e);
          if (u >= 1) {
            state.x = 0;
            state.y = 0;
            state.returnAt = 0;
          }
        });
        for (var i = 0; i < layers.length; i += 1) {
          var layer = layers[i];
          if (
            (heroIsShowcase() || hero.classList.contains('slydr-hero--gallery-motion')) &&
            (layer.classList.contains('slydr-hero__pad--1') ||
              layer.classList.contains('slydr-hero__pad--2') ||
              layer.classList.contains('slydr-hero__pad--3') ||
              layer.classList.contains('slydr-hero__type'))
          ) {
            continue;
          }
          var depth = parseFloat(layer.getAttribute('data-slydr-depth')) || 0;
          var shift = padShift.get(layer) || { x: 0, y: 0 };
          var px = parallaxOn ? cx * depth : 0;
          var py = parallaxOn ? cy * depth : 0;
          layer.style.transform =
            'translate3d(' + (px + shift.x) + 'px,' + (py + shift.y) + 'px,0)';
        }
        var live = heroBusy();
        hero.classList.toggle('slydr-hero--live', live);
        if (live) heroRaf = requestAnimationFrame(heroTick);
      }

      function bindPadDrag(el) {
        if (!el || padShift.has(el)) return;
        var state = {
          x: 0,
          y: 0,
          dragging: false,
          moved: false,
          pointerId: null,
          startX: 0,
          startY: 0,
          originX: 0,
          originY: 0,
          max: 48,
          returnFromX: 0,
          returnFromY: 0,
          returnAt: 0
        };
        padShift.set(el, state);

        el.setAttribute('draggable', 'false');
        el.addEventListener('dragstart', function (event) {
          event.preventDefault();
        });
        el.querySelectorAll('a, img').forEach(function (node) {
          node.setAttribute('draggable', 'false');
          node.addEventListener('dragstart', function (event) {
            event.preventDefault();
          });
        });

        function onMove(event) {
          if (!state.dragging) return;
          if (state.pointerId != null && event.pointerId !== state.pointerId) return;
          var dx = event.clientX - state.startX;
          var dy = event.clientY - state.startY;
          if (!state.moved && dx * dx + dy * dy < 25) return;
          state.moved = true;
          event.preventDefault();
          var next = clampLeash(state.originX + dx, state.originY + dy, state.max);
          state.x = next.x;
          state.y = next.y;
          kickHeroTick();
        }

        function finishDrag(event, allowClick) {
          if (!state.dragging) return;
          if (state.pointerId != null && event.pointerId !== state.pointerId) return;
          window.removeEventListener('pointermove', onMove, true);
          window.removeEventListener('pointerup', onUp, true);
          window.removeEventListener('pointercancel', onCancel, true);
          var openHref = '';
          if (allowClick && !state.moved) {
            openHref = resolveHeroOpenHref(el);
          }
          state.dragging = false;
          state.pointerId = null;
          el.classList.remove('is-dragging');
          try {
            el.releasePointerCapture(event.pointerId);
          } catch (err) {}
          if (state.x || state.y) {
            state.returnFromX = state.x;
            state.returnFromY = state.y;
            state.returnAt = beat(performance.now());
          }
          kickHeroTick();
          if (openHref && openHref !== '#') window.location.href = openHref;
        }

        function onUp(event) {
          finishDrag(event, true);
        }

        function onCancel(event) {
          finishDrag(event, false);
        }

        el.addEventListener(
          'pointerdown',
          function (event) {
            if (event.button) return;
            if (isHeroMobile()) return;
            if (
              el.hasAttribute('data-slydr-hero-slide-title') &&
              el.getAttribute('data-slydr-hero-slide-title') !== heroSlideId()
            ) {
              return;
            }
            event.preventDefault();
            state.dragging = true;
            state.moved = false;
            state.pointerId = event.pointerId;
            state.startX = event.clientX;
            state.startY = event.clientY;
            state.originX = state.x;
            state.originY = state.y;
            state.returnAt = 0;
            state.max = dragMax(el);
            el.classList.add('is-dragging');
            try {
              el.setPointerCapture(event.pointerId);
            } catch (err) {}
            window.addEventListener('pointermove', onMove, { capture: true, passive: false });
            window.addEventListener('pointerup', onUp, true);
            window.addEventListener('pointercancel', onCancel, true);
            kickHeroTick();
          },
          true
        );

        el.addEventListener(
          'click',
          function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (state.moved) return;
            var href = resolveHeroOpenHref(el);
            if (href && href !== '#') window.location.href = href;
          },
          true
        );
      }

      function resolveHeroOpenHref(el) {
        /* Featured pad + active slide font: always current slide JSON href */
        var isFeatured =
          el.classList.contains('slydr-hero__featured') ||
          el.classList.contains('slydr-hero__pad--4');
        var isSlideTitle = el.hasAttribute('data-slydr-hero-slide-title');
        if (isFeatured || isSlideTitle) {
          var fromSlide = (hero.getAttribute('data-hero-href') || '').trim();
          if (fromSlide && fromSlide !== '#') return fromSlide;
        }
        if (el.tagName === 'A') return el.getAttribute('href') || el.href || '';
        var link = el.querySelector('a[href]');
        return link ? link.getAttribute('href') || link.href || '' : '';
      }

      if (!reduce && !isHeroMobile()) {
        hero
          .querySelectorAll(
            '.slydr-hero__pad--1, .slydr-hero__pad--2, .slydr-hero__pad--3, .slydr-hero__featured, .slydr-hero__type, [data-slydr-hero-slide-title]'
          )
          .forEach(bindPadDrag);
      }

      if (!reduce && (parallaxOn || padShift.size)) {
        if (parallaxOn) {
          hero.addEventListener('mousemove', function (event) {
            var box = hero.getBoundingClientRect();
            tx = ((event.clientX - box.left) / box.width - 0.5) * 2;
            ty = ((event.clientY - box.top) / box.height - 0.5) * 2;
            kickHeroTick();
          });
          hero.addEventListener('mouseleave', function () {
            tx = 0;
            ty = 0;
            kickHeroTick();
          });
        }
      }

      document.addEventListener('visibilitychange', function () {
        if (pageHidden()) {
          hiddenAt = performance.now();
          if (sweepRaf) {
            cancelAnimationFrame(sweepRaf);
            sweepRaf = 0;
          }
          if (twinkleRaf) {
            cancelAnimationFrame(twinkleRaf);
            twinkleRaf = 0;
          }
          if (heroRaf) {
            cancelAnimationFrame(heroRaf);
            heroRaf = 0;
          }
          hero.classList.remove('slydr-hero--live');
          return;
        }
        if (hiddenAt) {
          holdMs += performance.now() - hiddenAt;
          hiddenAt = 0;
        }
        if (sweeping && sweepFrame) {
          sweepRaf = requestAnimationFrame(sweepFrame);
        } else if (pendingWave) {
          runWave();
        }
        if (twinkles.length && !twinkleRaf) {
          twinkleRaf = requestAnimationFrame(tickTwinkles);
        }
        kickHeroTick();
      });

      /* —— Hero 3D gallery (config from Liquid blocks) —— */
      (function initHeroGallery3d() {
        var gallery = hero.querySelector('[data-slydr-hero-gallery]');
        var host = hero.querySelector('[data-slydr-hero-3d]');
        var enabled3d = !!hero.getAttribute('data-slydr-hero-3d-enabled');
        /* Same 3D gallery on every viewport — CSS % keeps the 3.2:1 composition. */

        /*
         * Adaptive lite path (web.dev / Device Memory). Missing APIs → full
         * experience. No mid-switch DPR dip (that caused a soft→sharp cut);
         * lite uses a lower *stable* cap. Viewport split is desktop vs mobile.
         */
        function detectHeroLiteGpu() {
          try {
            var conn =
              navigator.connection ||
              navigator.mozConnection ||
              navigator.webkitConnection;
            if (conn && conn.saveData) return true;
            var mem = navigator.deviceMemory;
            if (typeof mem !== 'number' || !(mem > 0)) return false;
            if (mem <= 2) return true;
            if (
              mem <= 4 &&
              typeof navigator.hardwareConcurrency === 'number' &&
              navigator.hardwareConcurrency <= 4
            ) {
              return true;
            }
          } catch (err) {}
          return false;
        }

        var heroLiteGpu = detectHeroLiteGpu();
        if (heroLiteGpu) hero.setAttribute('data-slydr-hero-gpu', 'lite');
        else hero.setAttribute('data-slydr-hero-gpu', 'full');

        function parseSlides() {
          var el = hero.querySelector('[data-slydr-hero-slides]');
          if (!el) return null;
          try {
            var data = JSON.parse(el.textContent || '[]');
            return Array.isArray(data) && data.length ? data : null;
          } catch (err) {
            console.warn('[SLYDR hero slides]', err);
            return null;
          }
        }

        var SLIDES = parseSlides() || [
          { id: 'intro', kind: 'home', fx: { burst: 'fast' } }
        ];

        /*
         * Editor geometry reference: every px value from the theme editor is
         * authored against a 1920×600 hero (3.2:1) whose 3D host is 1100×420.
         * Sizes and offsets are handed to CSS as a percentage twin as well, so
         * a narrower desktop scales the whole composition by the same ratio
         * instead of keeping absolute px in a smaller box.
         */
        var REF_HERO_W = 1920;
        var REF_HERO_H = 600;
        var REF_HOST_W = 1100;
        var REF_HOST_H = 420;

        function pct(px, ref) {
          return ((px / ref) * 100).toFixed(4) + '%';
        }

        function clothUrl(cfg) {
          if (!cfg) return '';
          if (isHeroMobile() && cfg.clothPhone) return String(cfg.clothPhone).trim();
          return (cfg.cloth || '').trim();
        }

        function hexToRgb(hex) {
          hex = String(hex || '').trim();
          var rgbMatch = hex.match(
            /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i
          );
          if (rgbMatch) {
            return {
              r: parseInt(rgbMatch[1], 10),
              g: parseInt(rgbMatch[2], 10),
              b: parseInt(rgbMatch[3], 10)
            };
          }
          hex = hex.replace('#', '');
          if (hex.length === 3) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
          }
          if (hex.length !== 6) return null;
          var n = parseInt(hex, 16);
          if (isNaN(n)) return null;
          return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
        }

        function softAccent(hex) {
          var rgb = hexToRgb(hex);
          if (!rgb) return hex || '#d4d4d4';
          var r = Math.round(rgb.r + (255 - rgb.r) * 0.35);
          var g = Math.round(rgb.g + (255 - rgb.g) * 0.35);
          var b = Math.round(rgb.b + (255 - rgb.b) * 0.35);
          return (
            '#' +
            ((1 << 24) + (r << 16) + (g << 8) + b)
              .toString(16)
              .slice(1)
          );
        }

        function setHeroBg(color) {
          if (color) hero.style.setProperty('--slydr-hero-bg', color);
          else hero.style.removeProperty('--slydr-hero-bg');
        }

        var featuredEl = hero.querySelector('.slydr-hero__featured');

        function applyAccent(cfg, opts) {
          opts = opts || {};
          var accent = (cfg && cfg.accent) || '';
          var accentHi = (cfg && cfg.accentHi) || '';
          var logoR = (cfg && cfg.logoR) || accent || '';
          if (!accent) {
            hero.style.removeProperty('--slydr-hero-accent');
            hero.style.removeProperty('--slydr-hero-accent-hi');
            hero.style.removeProperty('--slydr-hero-accent-soft');
            hero.style.removeProperty('--slydr-hero-accent-rgb');
            hero.style.removeProperty('--slydr-hero-accent-hi-rgb');
          } else {
            var hi = accentHi || accent;
            var soft = softAccent(accent);
            var a = hexToRgb(accent);
            var h = hexToRgb(hi);
            hero.style.setProperty('--slydr-hero-accent', accent);
            hero.style.setProperty('--slydr-hero-accent-hi', hi);
            hero.style.setProperty('--slydr-hero-accent-soft', soft);
            if (a) {
              hero.style.setProperty(
                '--slydr-hero-accent-rgb',
                a.r + ', ' + a.g + ', ' + a.b
              );
            }
            if (h) {
              hero.style.setProperty(
                '--slydr-hero-accent-hi-rgb',
                h.r + ', ' + h.g + ', ' + h.b
              );
            }
          }

          if (!opts.skipLogo) {
            if (logoR) setLogoR(logoR);
            else setLogoR(colorFromText(pageText));
          }

          var padGlow = (cfg && cfg.padGlow) || accent || '';
          if (!padGlow) {
            hero.style.removeProperty('--slydr-hero-pad-glow-rgb');
          } else {
            var pg = hexToRgb(padGlow);
            if (pg) {
              hero.style.setProperty(
                '--slydr-hero-pad-glow-rgb',
                pg.r + ', ' + pg.g + ', ' + pg.b
              );
            }
          }

          if (!opts.skipBg) {
            var flash = (cfg && cfg.bgFlash) || '';
            var bg = (cfg && cfg.bg) || '';
            if (opts.bgPhase === 'flash' && flash) setHeroBg(flash);
            else setHeroBg(bg);
          }

          var fw = cfg && cfg.frameW != null ? Number(cfg.frameW) : NaN;
          var fh = cfg && cfg.frameH != null ? Number(cfg.frameH) : NaN;
          if (isNaN(fw) || fw <= 0) fw = cfg && cfg.kind === 'showcase' ? 640 : 1100;
          if (isNaN(fh) || fh <= 0) fh = 420;
          hero.style.setProperty('--slydr-hero-frame-w', fw + 'px');
          hero.style.setProperty('--slydr-hero-frame-h', fh + 'px');
          hero.style.setProperty('--slydr-hero-frame-w-pct', pct(fw, REF_HERO_W));
          hero.style.setProperty('--slydr-hero-frame-h-pct', pct(fh, REF_HERO_H));

          var mesh = (cfg && cfg.mesh) || {};
          var ox = mesh.ox != null ? Number(mesh.ox) : 0;
          var oy = mesh.oy != null ? Number(mesh.oy) : 0;
          var zoom = mesh.zoom != null ? Number(mesh.zoom) : 100;
          if (isNaN(ox)) ox = 0;
          if (isNaN(oy)) oy = 0;
          if (isNaN(zoom) || zoom <= 0) zoom = 100;
          /* Scoped to the featured slot: a custom prop on .slydr-hero would
             invalidate every key span in the background too. */
          var padHost = featuredEl || hero;
          /* Percentages in translate() resolve against the pad face, which is
             the 3D host — so the offset shrinks with it instead of staying
             absolute and pushing the pad out of a smaller hero. */
          padHost.style.setProperty('--slydr-pad-ox', pct(ox, REF_HOST_W));
          padHost.style.setProperty('--slydr-pad-oy', pct(oy, REF_HOST_H));
          padHost.style.setProperty('--slydr-pad-zoom', String(zoom / 100));
        }

        var bgFlashTimer = 0;

        function applyBadge(cfg) {
          var el = hero.querySelector('[data-slydr-hero-badge]');
          if (!el) return;
          var text = cfg && cfg.badge != null ? String(cfg.badge).trim() : '';
          if (text) {
            el.textContent = text;
            el.hidden = false;
            el.removeAttribute('hidden');
            el.classList.add('is-on');
          } else {
            el.textContent = '';
            el.hidden = true;
            el.setAttribute('hidden', '');
            el.classList.remove('is-on');
          }
        }

        function applyThemeLite(cfg, opts) {
          if (!cfg) return;
          hero.setAttribute('data-hero-slide', cfg.id || 'intro');
          hero.classList.toggle('slydr-hero--showcase', cfg.kind === 'showcase');
          hero.classList.toggle(
            'slydr-hero--cold-keys',
            !!(cfg.fx && cfg.fx.coldKeys)
          );
          hero.classList.toggle(
            'slydr-hero--frame-bolts',
            !!(cfg.fx && cfg.fx.frameBolts)
          );
          hero.classList.toggle(
            'slydr-hero--snow',
            !!(cfg.fx && cfg.fx.snow)
          );
          hero.classList.toggle(
            'slydr-hero--frame-nova',
            !!(cfg.fx && cfg.fx.frameNova)
          );
          applyAccent(cfg, opts);
          applyBadge(cfg);
          syncFxAttrs(cfg);
        }

        /* Always apply intro theme from Liquid JSON — no GLB required. */
        applyThemeLite(SLIDES[0]);

        if (!enabled3d || !host || !gallery) return;

        var glbSrc = host.getAttribute('data-src');
        if (!glbSrc) return;

        var prevBtn = gallery.querySelector('[data-slydr-hero-prev]');
        var nextBtn = gallery.querySelector('[data-slydr-hero-next]');
        var dots = Array.prototype.slice.call(
          gallery.querySelectorAll('[data-slydr-hero-slide]')
        );
        var slideTitles = Array.prototype.slice.call(
          hero.querySelectorAll('[data-slydr-hero-slide-title]')
        );

        function meshPoseFromCfg(cfg) {
          var mesh = (cfg && cfg.mesh) || {};
          var deg = Math.PI / 180;
          /* Editor 0° X = default look (was absolute 18°) */
          var ROT_X_BASE = 18;
          var isShowcase = cfg && cfg.kind === 'showcase';
          var rotX = (mesh.rotX != null ? Number(mesh.rotX) : 0) + ROT_X_BASE;
          var rotY = mesh.rotY != null ? Number(mesh.rotY) : 0;
          var rotZ =
            mesh.rotZ != null ? Number(mesh.rotZ) : isShowcase ? -30 : 30;
          if (isNaN(rotX)) rotX = ROT_X_BASE;
          if (isNaN(rotY)) rotY = 0;
          if (isNaN(rotZ)) rotZ = isShowcase ? -30 : 30;
          return { x: rotX * deg, y: rotY * deg, z: rotZ * deg };
        }

        function meshScaleFromCfg(cfg) {
          var mesh = (cfg && cfg.mesh) || {};
          var s = mesh.scale != null ? Number(mesh.scale) : 1;
          if (isNaN(s) || s <= 0) s = 1;
          return s;
        }

        var slideIndex = 0;
        var transitioning = false;
        var viewer = null;
        var loadPromise = null;
        var mobileGallery = isHeroMobile();
        var lastSwipeDir = 1;

        function prefetchNeighborCloth(v, dir) {
          if (!v || !v.prefetchCloth) return;
          var step = dir < 0 ? -1 : 1;
          var s = SLIDES[wrapIndex(slideIndex + step)];
          if (s) v.prefetchCloth(clothUrl(s));
        }

        function slideById(id) {
          for (var i = 0; i < SLIDES.length; i += 1) {
            if (SLIDES[i].id === id) return SLIDES[i];
          }
          return null;
        }

        function slideIndexOf(id) {
          for (var i = 0; i < SLIDES.length; i += 1) {
            if (SLIDES[i].id === id) return i;
          }
          return -1;
        }

        /* Gallery wraps in both directions */
        function wrapIndex(i) {
          var n = SLIDES.length;
          if (!n) return -1;
          return ((i % n) + n) % n;
        }

        function hydrateSlideWordmark(el) {
          if (!el) return;
          var img = el.querySelector('.slydr-hero__slide-wordmark');
          if (!img || img.getAttribute('src')) return;
          var srcset = img.getAttribute('data-srcset');
          var src = img.getAttribute('data-src');
          if (srcset) img.setAttribute('srcset', srcset);
          if (src) img.setAttribute('src', src);
        }

        function hydrateSlideWordmarkById(id) {
          var i;
          for (i = 0; i < slideTitles.length; i += 1) {
            if (slideTitles[i].getAttribute('data-slydr-hero-slide-title') === id) {
              hydrateSlideWordmark(slideTitles[i]);
              return;
            }
          }
        }

        function prefetchNeighborWordmarks() {
          var hops = [slideIndex + 1, slideIndex - 1];
          var i;
          for (i = 0; i < hops.length; i += 1) {
            var s = SLIDES[wrapIndex(hops[i])];
            if (s) hydrateSlideWordmarkById(s.id);
          }
        }

        function prefetchAllWordmarks() {
          var i;
          for (i = 0; i < SLIDES.length; i += 1) {
            hydrateSlideWordmarkById(SLIDES[i].id);
          }
        }

        function uniqueClothUrls() {
          var seen = Object.create(null);
          var urls = [];
          var i;
          var n = SLIDES.length;
          for (i = 0; i < n; i += 1) {
            var s = SLIDES[wrapIndex(slideIndex + i)];
            var url = clothUrl(s);
            if (!url || seen[url]) continue;
            seen[url] = 1;
            urls.push(url);
          }
          return urls;
        }

        function prefetchAllCloths(v) {
          if (!v || !v.prefetchCloth) return;
          var urls = uniqueClothUrls();
          var i = 0;
          function next() {
            if (i >= urls.length) return;
            var url = urls[i];
            i += 1;
            var done = v.prefetchCloth(url);
            var pause = heroLiteGpu ? 140 : 0;
            function kick() {
              if ('requestIdleCallback' in window) {
                requestIdleCallback(next, { timeout: 500 });
              } else {
                window.setTimeout(next, heroLiteGpu ? 80 : 32);
              }
            }
            function after() {
              if (pause) window.setTimeout(kick, pause);
              else kick();
            }
            if (done && typeof done.then === 'function') done.then(after, after);
            else after();
          }
          next();
        }

        function wordmarkIsReady(img) {
          return !!(img && img.getAttribute('src') && img.complete && img.naturalWidth);
        }

        function revealTitleWhenReady(el, slideId) {
          var img = el.querySelector('.slydr-hero__slide-wordmark');
          function show() {
            if (hero.getAttribute('data-hero-slide') !== slideId) return;
            el.classList.add('is-active');
            el.setAttribute('aria-hidden', 'false');
          }
          if (!img) {
            show();
            return;
          }
          hydrateSlideWordmark(el);
          if (wordmarkIsReady(img)) {
            show();
            return;
          }
          img.addEventListener('load', show, { once: true });
          img.addEventListener('error', show, { once: true });
        }

        function applyTheme(cfg, opts) {
          applyThemeLite(cfg, opts);
          var href = (cfg.href || '').trim();
          slideTitles.forEach(function (el) {
            var on = el.getAttribute('data-slydr-hero-slide-title') === cfg.id;
            if (on) {
              revealTitleWhenReady(el, cfg.id);
              if (href && el.tagName === 'A') el.setAttribute('href', href);
            } else {
              el.classList.remove('is-active');
              el.setAttribute('aria-hidden', 'true');
            }
          });
          var featuredLink = hero.querySelector('.slydr-hero__featured a.slydr-hero__pad');
          if (featuredLink) {
            if (href) {
              featuredLink.setAttribute('href', href);
              featuredLink.removeAttribute('aria-disabled');
            } else {
              featuredLink.setAttribute('href', '#');
              featuredLink.setAttribute('aria-disabled', 'true');
            }
          }
          if (href) hero.setAttribute('data-hero-href', href);
          else hero.removeAttribute('data-hero-href');
        }

        function setControls(activeIdx) {
          var idx = activeIdx == null ? slideIndex : activeIdx;
          var slide = SLIDES[idx];
          var stuck = SLIDES.length < 2 || transitioning;
          if (prevBtn) prevBtn.disabled = stuck;
          if (nextBtn) nextBtn.disabled = stuck;
          if (!slide) return;
          dots.forEach(function (dot) {
            var on = dot.getAttribute('data-slydr-hero-slide') === slide.id;
            dot.classList.toggle('is-on', on);
            dot.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        }

        function loadViewer() {
          if (loadPromise) return loadPromise;

          var glbUrl = (glbSrc || '').trim();
          if (!glbUrl) {
            hero.classList.add('slydr-hero--3d-failed');
            return Promise.resolve(null);
          }

          function loadBundle() {
            if (window.SlydrHero3D && window.SlydrHero3D.THREE) {
              return Promise.resolve(window.SlydrHero3D);
            }
            var src = hero.getAttribute('data-hero3d-js');
            if (!src) {
              return Promise.reject(
                new Error('Missing data-hero3d-js (upload slydr-hero-3d.js to theme Assets)')
              );
            }
            return new Promise(function (resolve, reject) {
              var existing = document.querySelector('script[data-slydr-hero-3d-bundle]');
              if (existing) {
                existing.addEventListener('load', function () {
                  if (window.SlydrHero3D) resolve(window.SlydrHero3D);
                  else reject(new Error('SlydrHero3D missing after script load'));
                });
                existing.addEventListener('error', function () {
                  reject(new Error('Failed loading slydr-hero-3d.js'));
                });
                return;
              }
              var s = document.createElement('script');
              s.src = src;
              s.async = true;
              s.setAttribute('data-slydr-hero-3d-bundle', '1');
              s.onload = function () {
                if (window.SlydrHero3D && window.SlydrHero3D.THREE) resolve(window.SlydrHero3D);
                else reject(new Error('SlydrHero3D global not set'));
              };
              s.onerror = function () {
                reject(new Error('Failed loading slydr-hero-3d.js from Assets'));
              };
              document.head.appendChild(s);
            });
          }

          loadPromise = loadBundle()
            .then(function (api) {
              var THREE = api.THREE;
              var GLTFLoader = api.GLTFLoader;
              if (!THREE || !GLTFLoader) {
                throw new Error('Three.js bundle incomplete');
              }

              var canvas = document.createElement('canvas');
              host.appendChild(canvas);

              var mobile3d = mobileGallery;
              /*
               * One stable pixel ratio (no mid-switch buffer rebuild / soft→sharp cut).
               * Lite devices: lower permanent cap. Full: sharp as before.
               */
              var dpr = window.devicePixelRatio || 1;
              var basePixelRatio = Math.min(
                dpr,
                heroLiteGpu ? 1.5 : mobile3d ? 2.5 : 2
              );
              var motionPixelRatio = basePixelRatio;
              var curPixelRatio = basePixelRatio;
              var clothAniso = heroLiteGpu ? 4 : 8;
              var renderer = new THREE.WebGLRenderer({
                canvas: canvas,
                antialias: !(heroLiteGpu || (mobile3d && dpr >= 2)),
                alpha: true,
                stencil: false,
                powerPreference: heroLiteGpu ? 'low-power' : 'high-performance'
              });
              renderer.setClearColor(0x000000, 0);
              renderer.setPixelRatio(basePixelRatio);
              if (THREE.SRGBColorSpace) renderer.outputColorSpace = THREE.SRGBColorSpace;

              var scene = new THREE.Scene();
              var camera = new THREE.PerspectiveCamera(28, 1, 0.01, 50);
              camera.position.set(0, 1.1, 0.35);
              camera.up.set(0, 1, 0);

              /*
               * No OrbitControls: the camera is driven entirely by the editor
               * values. It only ever sat here disabled while keeping a
               * non-passive wheel listener on the canvas and a document-wide
               * keydown hook — both of which taxed plain scrolling.
               */
              var loader = new GLTFLoader();
              var root = null;
              var raf = 0;
              var pendingFrame = false;
              var onScreen = true;
              var drawHz = { t: 0 };
              var fitCam = null;
              var fitBaseSpan = 0;
              var spinRaf = 0;
              var poseNow = { x: (18 * Math.PI) / 180, y: 0, z: (30 * Math.PI) / 180 };
              var clothMats = [];
              var defaultClothMaps = [];
              var clothCache = Object.create(null);
              var clothLoaders = Object.create(null);
              var currentClothUrl = '';
              var FIT_ZOOM = 1.18;

              function harden(obj) {
                clothMats = [];
                defaultClothMaps = [];
                obj.traverse(function (node) {
                  if (!node.isMesh || !node.material) return;
                  var mats = Array.isArray(node.material) ? node.material : [node.material];
                  var next = mats.map(function (m) {
                    var name = (m.name || '').toLowerCase();
                    var isCloth = name === 'cloth' || name.indexOf('cloth') !== -1;
                    if (m.map) {
                      if (THREE.SRGBColorSpace) m.map.colorSpace = THREE.SRGBColorSpace;
                      m.map.anisotropy = Math.min(
                        clothAniso,
                        renderer.capabilities.getMaxAnisotropy()
                      );
                      m.map.needsUpdate = true;
                    }
                    var mat = new THREE.MeshBasicMaterial({
                      map: m.map || null,
                      color: m.map ? 0xffffff : 0x171717,
                      side: THREE.DoubleSide
                    });
                    if (isCloth) {
                      clothMats.push(mat);
                      defaultClothMaps.push(m.map || null);
                    }
                    return mat;
                  });
                  node.material = Array.isArray(node.material) ? next : next[0];
                  node.frustumCulled = false;
                });
                /* Fallback: first material on first mesh if names missing */
                if (!clothMats.length) {
                  obj.traverse(function (node) {
                    if (clothMats.length || !node.isMesh || !node.material) return;
                    var mat = Array.isArray(node.material) ? node.material[0] : node.material;
                    if (!mat) return;
                    clothMats.push(mat);
                    defaultClothMaps.push(mat.map || null);
                  });
                }
              }

              function applyClothMap(map) {
                for (var i = 0; i < clothMats.length; i += 1) {
                  clothMats[i].map = map;
                  clothMats[i].color.setHex(map ? 0xffffff : 0x171717);
                  clothMats[i].needsUpdate = true;
                }
                invalidate();
              }

              /*
               * Bind cloth on the next frame so decode/GPU upload + material swap
               * do not land on the same task as setMotion + pose + CSS switch.
               * Look is unchanged — only the hitch peak moves off the first frame.
               */
              var clothApplyRaf = 0;
              var clothApplyUrl = null;
              var clothApplyMap = null;

              function flushClothApply() {
                clothApplyRaf = 0;
                var url = clothApplyUrl;
                var map = clothApplyMap;
                clothApplyUrl = null;
                clothApplyMap = null;
                if (url !== currentClothUrl) return;
                applyClothMap(map);
              }

              function scheduleClothApply(map, url) {
                clothApplyUrl = url;
                clothApplyMap = map;
                if (clothApplyRaf) return;
                clothApplyRaf = requestAnimationFrame(flushClothApply);
              }

              function fitClothImage(image) {
                /* Intro pad freistellers / letterboxed flats → crop content, stretch to pad UV (2.25:1). */
                var PAD_ASPECT = 900 / 400;
                var w = image.naturalWidth || image.width;
                var h = image.naturalHeight || image.height;
                if (!w || !h) return image;

                var src = document.createElement('canvas');
                src.width = w;
                src.height = h;
                var sctx = src.getContext('2d', { willReadFrequently: true });
                if (!sctx) return image;
                sctx.drawImage(image, 0, 0);
                var data;
                try {
                  data = sctx.getImageData(0, 0, w, h).data;
                } catch (err) {
                  return image;
                }

                var minX = w;
                var minY = h;
                var maxX = 0;
                var maxY = 0;
                var lumMin = 22;
                for (var y = 0; y < h; y += 2) {
                  for (var x = 0; x < w; x += 2) {
                    var i = (y * w + x) * 4;
                    if (data[i + 3] < 24) continue;
                    var lum = (data[i] + data[i + 1] + data[i + 2]) / 3;
                    if (lum < lumMin) continue;
                    if (x < minX) minX = x;
                    if (y < minY) minY = y;
                    if (x > maxX) maxX = x;
                    if (y > maxY) maxY = y;
                  }
                }

                var bw = maxX - minX + 1;
                var bh = maxY - minY + 1;
                var found = maxX > minX && maxY > minY && bw * bh > w * h * 0.06;
                if (!found) {
                  minX = 0;
                  minY = 0;
                  bw = w;
                  bh = h;
                } else {
                  var inset = Math.round(Math.min(bw, bh) * 0.012);
                  minX = Math.max(0, minX - inset);
                  minY = Math.max(0, minY - inset);
                  bw = Math.min(w - minX, bw + inset * 2);
                  bh = Math.min(h - minY, bh + inset * 2);
                }

                /* Desktop keeps 2048 (featured pad ~1000 CSS × 2× DPR).
                 * Mobile pad is ~380 CSS × 2.5 — 1024 is already past the pixel grid. */
                var outW = mobile3d ? 1024 : 2048;
                var outH = Math.max(1, Math.round(outW / PAD_ASPECT));

                /* Skip work when the crop is already nearly full-bleed and
                 * not larger than the target (otherwise still downsample). */
                if (bw >= w * 0.92 && bh >= h * 0.92 && w <= outW) {
                  var imgAspect = w / h;
                  if (Math.abs(imgAspect - PAD_ASPECT) < 0.08) return image;
                }
                var out = document.createElement('canvas');
                out.width = outW;
                out.height = outH;
                var octx = out.getContext('2d');
                if (!octx) return image;
                octx.fillStyle = '#0a0a0a';
                octx.fillRect(0, 0, outW, outH);
                octx.drawImage(src, minX, minY, bw, bh, 0, 0, outW, outH);
                return out;
              }

              function loadClothTexture(url) {
                if (!url) {
                  return Promise.resolve(null);
                }
                if (clothCache[url]) return Promise.resolve(clothCache[url]);
                if (clothLoaders[url]) return clothLoaders[url];
                clothLoaders[url] = new Promise(function (resolve, reject) {
                  var img = new Image();
                  img.crossOrigin = 'anonymous';
                  img.onload = function () {
                    try {
                      var fitted = fitClothImage(img);
                      var tex;
                      if (fitted instanceof HTMLCanvasElement) {
                        tex = new THREE.CanvasTexture(fitted);
                      } else {
                        tex = new THREE.Texture(fitted);
                        tex.needsUpdate = true;
                      }
                      /* GLTF materials use flipY=false; TextureLoader defaults to true */
                      tex.flipY = false;
                      tex.wrapS = THREE.ClampToEdgeWrapping;
                      tex.wrapT = THREE.ClampToEdgeWrapping;
                      if (THREE.SRGBColorSpace) tex.colorSpace = THREE.SRGBColorSpace;
                      tex.anisotropy = Math.min(
                        clothAniso,
                        renderer.capabilities.getMaxAnisotropy()
                      );
                      tex.needsUpdate = true;
                      /* Upload to the GPU now — doing it on first render mid-switch hitches */
                      if (renderer.initTexture) {
                        try {
                          renderer.initTexture(tex);
                        } catch (upErr) {}
                      }
                      clothCache[url] = tex;
                      delete clothLoaders[url];
                      resolve(tex);
                    } catch (err) {
                      delete clothLoaders[url];
                      reject(err);
                    }
                  };
                  img.onerror = function () {
                    delete clothLoaders[url];
                    reject(new Error('cloth image failed: ' + url));
                  };
                  img.src = url;
                });
                return clothLoaders[url];
              }

              function setCloth(url) {
                url = (url || '').trim();
                if (url === currentClothUrl) return Promise.resolve(clothCache[url] || null);
                currentClothUrl = url;
                if (!url) {
                  scheduleClothApply(defaultClothMaps[0] || null, '');
                  return Promise.resolve(null);
                }
                /* Cache hit: still defer the bind so pose/CSS own the first frame */
                if (clothCache[url]) {
                  scheduleClothApply(clothCache[url], url);
                  return Promise.resolve(clothCache[url]);
                }
                return loadClothTexture(url)
                  .then(function (tex) {
                    if (currentClothUrl !== url) return;
                    scheduleClothApply(tex, url);
                    return tex;
                  })
                  .catch(function (err) {
                    console.warn('[SLYDR hero cloth]', url, err);
                  });
              }

              function prefetchCloth(url) {
                url = (url || '').trim();
                if (!url) return Promise.resolve(null);
                if (clothCache[url]) return Promise.resolve(clothCache[url]);
                if (clothLoaders[url]) return clothLoaders[url];
                /* Warm decode + GPU upload off the switch path */
                return loadClothTexture(url).catch(function () {
                  return null;
                });
              }

              function centerRoot(obj) {
                obj.updateMatrixWorld(true);
                var box = new THREE.Box3().setFromObject(obj);
                var center = box.getCenter(new THREE.Vector3());
                obj.position.x -= center.x;
                obj.position.y -= center.y;
                obj.position.z -= center.z;
                obj.updateMatrixWorld(true);
              }

              function captureFitBase() {
                if (!root) return;
                var sx = root.scale.x;
                var sy = root.scale.y;
                var sz = root.scale.z;
                var rx = root.rotation.x;
                var ry = root.rotation.y;
                var rz = root.rotation.z;
                root.scale.set(1, 1, 1);
                root.rotation.set(0, 0, 0);
                root.updateMatrixWorld(true);
                var box = new THREE.Box3().setFromObject(root);
                var size = box.getSize(new THREE.Vector3());
                var span = Math.sqrt(size.x * size.x + size.y * size.y + size.z * size.z);
                fitBaseSpan = Math.max(span, 0.01);
                root.scale.set(sx, sy, sz);
                root.rotation.set(rx, ry, rz, 'XYZ');
                root.updateMatrixWorld(true);
              }

              function applyPoseVals(p, scale) {
                if (!root || !p) return;
                poseNow.x = p.x;
                poseNow.y = p.y;
                poseNow.z = p.z;
                root.rotation.set(p.x, p.y, p.z, 'XYZ');
                var s = scale != null ? scale : 1;
                if (isNaN(s) || s <= 0) s = 1;
                root.scale.set(s, s, s);
                invalidate();
              }

              function storeFitCam(scaleOverride) {
                if (!root) return;
                var s =
                  scaleOverride != null ? scaleOverride : root.scale.x || 1;
                if (isNaN(s) || s <= 0) s = 1;
                if (!fitBaseSpan) captureFitBase();
                /* Diagonal at rest × scale — skip Box3 on every pose (rotation-safe) */
                var span = fitBaseSpan * s;
                var w = Math.max(host.clientWidth || 0, 2);
                var h = Math.max(host.clientHeight || 0, 2);
                var aspect = w / h;
                var vFov = (camera.fov * Math.PI) / 180;
                var dist = (span * 0.62) / (Math.tan(vFov / 2) * Math.min(aspect, 1.35));
                dist *= FIT_ZOOM;
                fitCam = {
                  pos: new THREE.Vector3(0, dist * 0.92, dist * 0.28),
                  target: new THREE.Vector3(0, 0, 0)
                };
              }

              function applyFitCam() {
                if (!fitCam) return;
                camera.position.copy(fitCam.pos);
                camera.lookAt(fitCam.target);
                invalidate();
              }

              function reframe(scaleOverride) {
                if (!root) return;
                storeFitCam(scaleOverride);
                applyFitCam();
              }

              function animatePose(toPose, animate, scale) {
                if (spinRaf) {
                  cancelAnimationFrame(spinRaf);
                  spinRaf = 0;
                }
                if (!root || !toPose) return;
                var targetScale = scale != null ? scale : 1;
                if (isNaN(targetScale) || targetScale <= 0) targetScale = 1;
                var from = { x: poseNow.x, y: poseNow.y, z: poseNow.z };
                var fromScale = root.scale.x || 1;
                var poseDelta =
                  Math.abs(from.x - toPose.x) +
                  Math.abs(from.y - toPose.y) +
                  Math.abs(from.z - toPose.z);
                var scaleDelta = Math.abs(fromScale - targetScale);
                if (poseDelta < 0.0008 && scaleDelta < 0.002) {
                  applyPoseVals(toPose, targetScale);
                  return;
                }
                if (!animate || reduce) {
                  applyPoseVals(toPose, targetScale);
                  if (scaleDelta >= 0.002) reframe(targetScale);
                  return;
                }
                var t0 = performance.now();
                var dur = 900;
                function step(now) {
                  var t = Math.min(1, (now - t0) / dur);
                  var e = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
                  applyPoseVals(
                    {
                      x: from.x + (toPose.x - from.x) * e,
                      y: from.y + (toPose.y - from.y) * e,
                      z: from.z + (toPose.z - from.z) * e
                    },
                    fromScale + (targetScale - fromScale) * e
                  );
                  if (t < 1) spinRaf = requestAnimationFrame(step);
                  else {
                    spinRaf = 0;
                    /* Reframe only when mesh scale changed — rotation uses cached span */
                    if (scaleDelta >= 0.002) reframe(targetScale);
                  }
                }
                spinRaf = requestAnimationFrame(step);
              }

              var lastW = 0;
              var lastH = 0;
              var lastFullW = 0;
              var lastFullH = 0;
              var lastVX = 0;
              var lastVY = 0;
              var projScratch = new THREE.Vector3();
              var boxScratch = new THREE.Box3();

              function snapshotViewOffset() {
                var v = camera.view;
                if (!v || !v.enabled) return null;
                return {
                  fullWidth: v.fullWidth,
                  fullHeight: v.fullHeight,
                  offsetX: v.offsetX,
                  offsetY: v.offsetY,
                  width: v.width,
                  height: v.height
                };
              }

              function restoreViewOffset(snap) {
                if (snap && camera.setViewOffset) {
                  camera.setViewOffset(
                    snap.fullWidth,
                    snap.fullHeight,
                    snap.offsetX,
                    snap.offsetY,
                    snap.width,
                    snap.height
                  );
                  return;
                }
                if (camera.clearViewOffset) camera.clearViewOffset();
                camera.updateProjectionMatrix();
              }

              function projectMeshToHost(fullW, fullH) {
                root.updateMatrixWorld(true);
                camera.updateMatrixWorld();
                boxScratch.setFromObject(root);
                var min = boxScratch.min;
                var max = boxScratch.max;
                var minX = Infinity;
                var minY = Infinity;
                var maxX = -Infinity;
                var maxY = -Infinity;
                var ix;
                var iy;
                var iz;
                for (ix = 0; ix < 2; ix += 1) {
                  for (iy = 0; iy < 2; iy += 1) {
                    for (iz = 0; iz < 2; iz += 1) {
                      projScratch
                        .set(
                          ix ? max.x : min.x,
                          iy ? max.y : min.y,
                          iz ? max.z : min.z
                        )
                        .project(camera);
                      var px = (projScratch.x * 0.5 + 0.5) * fullW;
                      var py = (-projScratch.y * 0.5 + 0.5) * fullH;
                      if (px < minX) minX = px;
                      if (py < minY) minY = py;
                      if (px > maxX) maxX = px;
                      if (py > maxY) maxY = py;
                    }
                  }
                }
                if (!isFinite(minX)) return { x: 0, y: 0, w: fullW, h: fullH };
                return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
              }

              /*
               * Pad = camera frustum on the full 3D host (look / rotation unchanged).
               * Canvas = union of the mesh on every slide, not the hero box.
               * Cropping to the hero is what sliced the pad last time.
               *
               * Projection for the bounds must be the *full* frustum. We have to
               * clear viewOffset for that — and put it back before returning.
               * Otherwise the next no-op resize (ResizeObserver) leaves a small
               * canvas drawing the whole view: pad looks smaller and squashed.
               */
              function meshCropRect(fullW, fullH) {
                if (!root || !camera.setViewOffset) {
                  return { x: 0, y: 0, w: fullW, h: fullH };
                }
                var savedRot = {
                  x: root.rotation.x,
                  y: root.rotation.y,
                  z: root.rotation.z
                };
                var savedScale = root.scale.x;
                var savedPose = { x: poseNow.x, y: poseNow.y, z: poseNow.z };
                var savedView = snapshotViewOffset();
                if (camera.clearViewOffset) camera.clearViewOffset();
                camera.aspect = fullW / fullH;
                camera.updateProjectionMatrix();

                var u = { x: fullW, y: fullH, r: 0, b: 0 };
                var i;
                try {
                  for (i = 0; i < SLIDES.length; i += 1) {
                    var pose = meshPoseFromCfg(SLIDES[i]);
                    var sc = meshScaleFromCfg(SLIDES[i]);
                    root.rotation.set(pose.x, pose.y, pose.z, 'XYZ');
                    root.scale.set(sc, sc, sc);
                    storeFitCam(sc);
                    if (fitCam) {
                      camera.position.copy(fitCam.pos);
                      camera.lookAt(fitCam.target);
                    }
                    var r = projectMeshToHost(fullW, fullH);
                    if (r.x < u.x) u.x = r.x;
                    if (r.y < u.y) u.y = r.y;
                    if (r.x + r.w > u.r) u.r = r.x + r.w;
                    if (r.y + r.h > u.b) u.b = r.y + r.h;
                  }
                } finally {
                  root.rotation.set(savedRot.x, savedRot.y, savedRot.z, 'XYZ');
                  root.scale.set(savedScale, savedScale, savedScale);
                  poseNow.x = savedPose.x;
                  poseNow.y = savedPose.y;
                  poseNow.z = savedPose.z;
                  storeFitCam(savedScale);
                  if (fitCam) {
                    camera.position.copy(fitCam.pos);
                    camera.lookAt(fitCam.target);
                  }
                  restoreViewOffset(savedView);
                }

                var pad = Math.max(48, Math.round(Math.min(fullW, fullH) * 0.14));
                var x0 = Math.max(0, Math.floor(u.x) - pad);
                var y0 = Math.max(0, Math.floor(u.y) - pad);
                var x1 = Math.min(fullW, Math.ceil(u.r) + pad);
                var y1 = Math.min(fullH, Math.ceil(u.b) + pad);
                var visW = x1 - x0;
                var visH = y1 - y0;
                if (visW < 2 || visH < 2 || visW * visH > fullW * fullH * 0.9) {
                  return { x: 0, y: 0, w: fullW, h: fullH };
                }
                return { x: x0, y: y0, w: visW, h: visH };
              }

              function applyCanvasView(fullW, fullH, vis) {
                canvas.style.position = 'absolute';
                var full =
                  vis.x <= 0 &&
                  vis.y <= 0 &&
                  vis.w >= fullW - 1 &&
                  vis.h >= fullH - 1;
                if (full || !camera.setViewOffset || !camera.clearViewOffset) {
                  camera.clearViewOffset();
                  canvas.style.left = '0';
                  canvas.style.top = '0';
                  canvas.style.width = '100%';
                  canvas.style.height = '100%';
                  renderer.setSize(fullW, fullH, false);
                  return;
                }
                camera.setViewOffset(fullW, fullH, vis.x, vis.y, vis.w, vis.h);
                canvas.style.left = vis.x + 'px';
                canvas.style.top = vis.y + 'px';
                canvas.style.width = vis.w + 'px';
                canvas.style.height = vis.h + 'px';
                renderer.setSize(vis.w, vis.h, false);
              }

              function resizeCanvas() {
                var w = Math.max(host.clientWidth || 0, 2);
                var h = Math.max(host.clientHeight || 0, 2);
                var vis = meshCropRect(w, h);
                if (
                  w === lastFullW &&
                  h === lastFullH &&
                  vis.w === lastW &&
                  vis.h === lastH &&
                  vis.x === lastVX &&
                  vis.y === lastVY
                ) {
                  /* Crop math temporarily clears viewOffset. Put it back
                   * without setSize — resetting canvas.width wipes the buffer. */
                  camera.aspect = w / h;
                  if (
                    vis.x <= 0 &&
                    vis.y <= 0 &&
                    vis.w >= w - 1 &&
                    vis.h >= h - 1
                  ) {
                    if (camera.clearViewOffset) camera.clearViewOffset();
                  } else if (camera.setViewOffset) {
                    camera.setViewOffset(w, h, vis.x, vis.y, vis.w, vis.h);
                  }
                  camera.updateProjectionMatrix();
                  return false;
                }
                lastFullW = w;
                lastFullH = h;
                lastW = vis.w;
                lastH = vis.h;
                lastVX = vis.x;
                lastVY = vis.y;
                camera.aspect = w / h;
                applyCanvasView(w, h, vis);
                camera.updateProjectionMatrix();
                invalidate();
                return true;
              }

              /*
               * setMotion used to drop pixel ratio during gallery switches.
               * That buffer rebuild caused a clear soft→sharp pop — disabled.
               * Hook kept so call sites stay valid; it's a no-op while ratios match.
               */
              function setMotion(on) {
                var pr = on ? motionPixelRatio : basePixelRatio;
                if (pr === curPixelRatio) return;
                curPixelRatio = pr;
                renderer.setPixelRatio(pr);
                if (lastW > 2 && lastH > 2) {
                  renderer.setSize(lastW, lastH, false);
                }
                invalidate();
              }

              function resize() {
                resizeCanvas();
                reframe();
              }

              /*
               * On-demand rendering. This used to be an unconditional 60fps loop
               * that kept drawing an unchanged mesh for the whole life of the
               * page — including while the hero was scrolled far out of view.
               * Now anything that changes the picture asks for exactly one frame,
               * and leaving the viewport shuts the pipeline down completely.
               */
              function drawFrame(now) {
                raf = 0;
                pendingFrame = false;
                if (!onScreen) return;
                if (!heroMobileFrameDue(now, drawHz)) {
                  pendingFrame = true;
                  raf = requestAnimationFrame(drawFrame);
                  return;
                }
                renderer.render(scene, camera);
              }

              function invalidate() {
                if (pendingFrame || !onScreen) return;
                pendingFrame = true;
                raf = requestAnimationFrame(drawFrame);
              }

              function setOnScreen(next) {
                if (next === onScreen) return;
                onScreen = next;
                if (next) {
                  invalidate();
                  return;
                }
                if (raf) cancelAnimationFrame(raf);
                raf = 0;
                pendingFrame = false;
              }

              var io = null;
              if (typeof IntersectionObserver !== 'undefined') {
                io = new IntersectionObserver(
                  function (entries) {
                    var vis = false;
                    for (var i = 0; i < entries.length; i += 1) {
                      if (entries[i].isIntersecting) vis = true;
                    }
                    setOnScreen(vis);
                  },
                  /* Margin so it is already drawn when it scrolls back in */
                  { rootMargin: '160px 0px' }
                );
                io.observe(hero);
              }

              var ro = null;
              var roRaf = 0;
              if (typeof ResizeObserver !== 'undefined') {
                ro = new ResizeObserver(function () {
                  if (roRaf) return;
                  roRaf = requestAnimationFrame(function () {
                    roRaf = 0;
                    resizeCanvas();
                  });
                });
              }

              return loader.loadAsync(glbUrl).then(function (gltf) {
                root = gltf.scene;
                harden(root);
                centerRoot(root);
                captureFitBase();
                var boot = SLIDES[slideIndex] || SLIDES[0];
                applyPoseVals(meshPoseFromCfg(boot), meshScaleFromCfg(boot));
                scene.add(root);
                resize();
                if (ro) ro.observe(host);
                requestAnimationFrame(function () {
                  resize();
                });
                window.addEventListener('resize', resize);
                invalidate();
                hero.classList.add('slydr-hero--3d-ready');
                hero.classList.remove('slydr-hero--3d-failed');
                hero.removeAttribute('data-slydr-3d-error');
                viewer = {
                  setPose: function (poseOrId, animate, scale) {
                    var pose;
                    var sc = scale;
                    if (typeof poseOrId === 'string') {
                      var cfg = slideById(poseOrId) || SLIDES[slideIndex] || SLIDES[0];
                      pose = meshPoseFromCfg(cfg);
                      if (sc == null) sc = meshScaleFromCfg(cfg);
                    } else {
                      pose = poseOrId || meshPoseFromCfg(SLIDES[slideIndex] || SLIDES[0]);
                    }
                    animatePose(pose, animate !== false, sc);
                  },
                  setCloth: setCloth,
                  prefetchCloth: prefetchCloth,
                  whenCloth: loadClothTexture,
                  setMotion: setMotion,
                  dispose: function () {
                    cancelAnimationFrame(raf);
                    raf = 0;
                    pendingFrame = false;
                    onScreen = false;
                    if (clothApplyRaf) {
                      cancelAnimationFrame(clothApplyRaf);
                      clothApplyRaf = 0;
                    }
                    clothApplyUrl = null;
                    clothApplyMap = null;
                    if (spinRaf) cancelAnimationFrame(spinRaf);
                    window.removeEventListener('resize', resize);
                    if (ro) {
                      ro.disconnect();
                      ro = null;
                    }
                    if (io) {
                      io.disconnect();
                      io = null;
                    }
                    renderer.dispose();
                  }
                };
                return viewer;
              });
            })
            .catch(function (err) {
              console.warn('[SLYDR hero 3D]', err);
              hero.classList.add('slydr-hero--3d-failed');
              hero.setAttribute(
                'data-slydr-3d-error',
                err && err.message ? err.message : String(err)
              );
              loadPromise = null;
              return null;
            });
          return loadPromise;
        }

        function clearPadInlineTransforms(opts) {
          opts = opts || {};
          hero
            .querySelectorAll(
              '.slydr-hero__pad--1, .slydr-hero__pad--2, .slydr-hero__pad--3, .slydr-hero__type'
            )
            .forEach(function (el) {
              var st = padShift.get(el);
              if (st) {
                st.x = 0;
                st.y = 0;
                st.returnAt = 0;
                st.dragging = false;
              }
              el.style.transform = '';
            });
          var featured = hero.querySelector('.slydr-hero__featured');
          if (featured) featured.classList.remove('slydr-pad-live');
          /* Clearing face transform mid-switch snaps the CSS morph — only on settle */
          if (!opts.keepFace) {
            var face4 = hero.querySelector('.slydr-hero__pad--4 .slydr-hero__pad-face');
            if (face4) {
              face4.style.transition = '';
              face4.style.transform = '';
            }
          }
        }

        function runSlideFx(cfg) {
          if (sweepRaf) {
            cancelAnimationFrame(sweepRaf);
            sweepRaf = 0;
          }
          sweeping = false;
          sweepFrame = null;
          var fx = cfg.fx || {};
          var burst = fx.burst;
          /* Lite: keep burst (Slydr feel), drop lightning bolts on top */
          var wantLightning = !heroLiteGpu && !!fx.lightning;
          if (burst && burst !== 'off') {
            runBurst({
              fast: burst === 'fast',
              withLightning: wantLightning
            });
          } else if (wantLightning) {
            runLightning();
          }
        }

        function go(nextId) {
          var nextIdx = typeof nextId === 'number' ? wrapIndex(nextId) : slideIndexOf(nextId);
          if (transitioning || nextIdx < 0 || nextIdx === slideIndex) return;
          var next = SLIDES[nextIdx];
          if (!next) return;
          /* Infer browse direction for post-switch cloth warm (incl. dots) */
          var n = SLIDES.length;
          var forward = (nextIdx - slideIndex + n) % n;
          var backward = (slideIndex - nextIdx + n) % n;
          lastSwipeDir = forward <= backward ? 1 : -1;
          transitioning = true;
          /* Dots follow intent immediately — not the 1.5s pose settle. */
          setControls(nextIdx);
          hydrateSlideWordmarkById(next.id);

          var finish = function () {
            slideIndex = nextIdx;
            transitioning = false;
            hero.classList.remove('slydr-hero--gallery-motion');
            hero.classList.remove('slydr-hero--bg-flash');
            if (bgFlashTimer) {
              window.clearTimeout(bgFlashTimer);
              bgFlashTimer = 0;
            }
            setHeroBg((next && next.bg) || '');
            clearPadInlineTransforms();
            setControls();
            setLogoR((next && (next.logoR || next.accent)) || colorFromText(pageText));

            /*
             * Settle work (breathe restart, optional cloth warm) is deferred so
             * it does not pile into the last motion frame.
             */
            var idle = function (fn, ms) {
              if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: ms * 3 });
              else window.setTimeout(fn, ms);
            };
            idle(function () {
              if (viewer && viewer.setMotion) viewer.setMotion(false);
              prefetchNeighborWordmarks();
              /* Warm next cloth after settle — skip entirely on lite GPUs */
              if (!heroLiteGpu && viewer) {
                prefetchNeighborCloth(viewer, lastSwipeDir);
              }
              idle(function () {
                hero.classList.remove('slydr-hero--gpu-lite');
                kickHeroTick();
              }, 120);
            }, 120);
          };

          var needsViewer = next.kind === 'showcase' || SLIDES[slideIndex].kind === 'showcase';

          function play() {
            clearPadInlineTransforms({ keepFace: true });
            if (bgFlashTimer) {
              window.clearTimeout(bgFlashTimer);
              bgFlashTimer = 0;
            }

            if (reduce) {
              hero.classList.remove('slydr-hero--bg-flash');
              applyTheme(next, { skipLogo: true });
              if (viewer) {
                viewer.setPose(meshPoseFromCfg(next), true, meshScaleFromCfg(next));
                viewer.setCloth(clothUrl(next));
              }
              finish();
              return;
            }

            /*
             * Staged over frames instead of one task: enabling the transitions,
             * changing the values and starting the key FX each get their own
             * frame. Doing it together (plus a forced reflow) dropped frames.
             */
            hero.classList.add('slydr-hero--gallery-motion');
            hero.classList.add('slydr-hero--gpu-lite');

            requestAnimationFrame(function () {
              var hasFlash = !!(next.bgFlash && String(next.bgFlash).trim());
              if (hasFlash) {
                hero.classList.add('slydr-hero--bg-flash');
                applyTheme(next, { bgPhase: 'flash', skipLogo: true });
                bgFlashTimer = window.setTimeout(function () {
                  bgFlashTimer = 0;
                  hero.classList.remove('slydr-hero--bg-flash');
                  setHeroBg(next.bg || '');
                }, 160);
              } else {
                hero.classList.remove('slydr-hero--bg-flash');
                applyTheme(next, { skipLogo: true });
              }

              if (viewer) {
                if (viewer.setMotion) viewer.setMotion(true);
                viewer.setPose(meshPoseFromCfg(next), true, meshScaleFromCfg(next));
                viewer.setCloth(clothUrl(next));
              }

              requestAnimationFrame(function () {
                runSlideFx(next);
              });
            });

            window.setTimeout(finish, 1500);
          }

          function whenTimeout(ms) {
            return new Promise(function (resolve) {
              window.setTimeout(resolve, ms);
            });
          }

          function whenDestClothReady(v) {
            var url = clothUrl(next);
            if (!v || !url || !v.whenCloth) return Promise.resolve();
            return v.whenCloth(url).catch(function () {});
          }

          /* Play only after 3D + dest cloth are warm (or 2s). Avoids first-pass hitch. */
          if (needsViewer) {
            loadViewer().then(function (v) {
              if (!v) {
                play();
                return;
              }
              Promise.race([whenDestClothReady(v), whenTimeout(2000)]).then(play);
            });
          } else {
            play();
          }
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            go(slideIndex - 1);
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            go(slideIndex + 1);
          });
        }
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            go(dot.getAttribute('data-slydr-hero-slide'));
          });
        });

        /* Mobile: swipe horizontally to change slots (buttons are CSS-hidden). */
        (function bindGallerySwipe() {
          if (!mobileGallery) return;
          var startX = 0;
          var startY = 0;
          var tracking = false;
          var axis = '';
          var pid = 0;
          var didSwipe = false;
          var captured = false;
          var MIN = 48;

          hero.addEventListener(
            'pointerdown',
            function (event) {
              if (event.pointerType === 'mouse' && event.button !== 0) return;
              if (event.target && event.target.closest && event.target.closest('.slydr-hero__gallery')) {
                return;
              }
              tracking = true;
              didSwipe = false;
              captured = false;
              axis = '';
              pid = event.pointerId;
              startX = event.clientX;
              startY = event.clientY;
            },
            { capture: true, passive: true }
          );

          hero.addEventListener(
            'pointermove',
            function (event) {
              if (!tracking || event.pointerId !== pid || axis === 'y') return;
              var dx = event.clientX - startX;
              var dy = event.clientY - startY;
              if (!axis) {
                if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
                axis = Math.abs(dx) > Math.abs(dy) * 1.15 ? 'x' : 'y';
                /* Capture only after horizontal intent — vertical page scroll stays free */
                if (axis === 'x' && !captured) {
                  captured = true;
                  try {
                    hero.setPointerCapture(event.pointerId);
                  } catch (err) {}
                }
              }
              if (axis === 'x' && event.cancelable) event.preventDefault();
            },
            { capture: true, passive: false }
          );

          function endSwipe(event) {
            if (!tracking || (event && event.pointerId !== pid)) return;
            tracking = false;
            if (axis !== 'x' || transitioning || SLIDES.length < 2) {
              axis = '';
              return;
            }
            var dx = (event && event.clientX != null ? event.clientX : startX) - startX;
            axis = '';
            if (Math.abs(dx) < MIN) return;
            didSwipe = true;
            lastSwipeDir = dx < 0 ? 1 : -1;
            if (dx < 0) go(slideIndex + 1);
            else go(slideIndex - 1);
          }

          hero.addEventListener('pointerup', endSwipe, true);
          hero.addEventListener(
            'pointercancel',
            function (event) {
              if (event.pointerId !== pid) return;
              tracking = false;
              axis = '';
              captured = false;
            },
            true
          );

          /* Swallow the click that follows a successful swipe */
          hero.addEventListener(
            'click',
            function (event) {
              if (!didSwipe) return;
              didSwipe = false;
              event.preventDefault();
              event.stopPropagation();
            },
            true
          );
        })();

        applyTheme(SLIDES[0]);
        setControls();

        function scheduleAfterLoad(fn, idleMs) {
          var start = function () {
            if ('requestIdleCallback' in window) {
              requestIdleCallback(fn, { timeout: idleMs });
            } else {
              window.setTimeout(fn, 200);
            }
          };
          if (document.readyState === 'complete') {
            start();
            return;
          }
          window.addEventListener('load', start, { once: true });
        }

        /* Wordmarks after first paint — same look, not on the LCP path. */
        scheduleAfterLoad(prefetchAllWordmarks, 1200);

        /*
         * 3D after window.load + idle: same 2D→mesh swap, not gated on swipe.
         * Starting in the first idle window competed with LCP (Three.js parse).
         * go() still calls loadViewer if the user swipes before boot finishes.
         */
        function bootViewer() {
          loadViewer().then(function (v) {
            if (!v) return;
            prefetchAllCloths(v);
          });
        }

        scheduleAfterLoad(bootViewer, 1500);
      })();
    }

    if (reduce) return;

    var sliderCard = 'slideshow-component, swiper-container, .swiper, .flickity-enabled, [class*="recently-viewed"]';

    /*
     * One shared tilt path for the whole grid. Per-card mousemove +
     * getBoundingClientRect used to force a layout read on every pointer
     * pixel; the rect is now cached on enter and writes are rAF-throttled.
     */
    (function bindCardTilt() {
      var active = null;
      var box = null;
      var raf = 0;
      var nextX = 0;
      var nextY = 0;
      var pending = false;

      function isTiltCard(el) {
        if (!el || !el.closest) return null;
        var card = el.closest('.product-card-wrapper, .card-wrapper');
        if (!card || card.closest(sliderCard)) return null;
        return card;
      }

      function flush() {
        raf = 0;
        if (!pending || !active) return;
        pending = false;
        active.style.transform =
          'rotateX(' + nextY * -6 + 'deg) rotateY(' + nextX * 8 + 'deg)';
      }

      document.addEventListener(
        'pointermove',
        function (event) {
          if (!active || !box || !box.width || !box.height) return;
          nextX = (event.clientX - box.left) / box.width - 0.5;
          nextY = (event.clientY - box.top) / box.height - 0.5;
          pending = true;
          if (!raf) raf = requestAnimationFrame(flush);
        },
        { passive: true }
      );

      document.addEventListener(
        'pointerover',
        function (event) {
          var card = isTiltCard(event.target);
          if (!card || card === active) return;
          if (active) active.style.transform = '';
          active = card;
          box = card.getBoundingClientRect();
        },
        true
      );

      document.addEventListener(
        'pointerout',
        function (event) {
          if (!active) return;
          var next = event.relatedTarget;
          if (next && active.contains(next)) return;
          active.style.transform = '';
          active = null;
          box = null;
          pending = false;
        },
        true
      );
    })();

    var floatImgs = [];
    cards.forEach(function (card, index) {
      if (card.closest(sliderCard)) return;
      var media = card.querySelector('.card-media, .card__media, .media') || card;
      var img = media.querySelector('img');
      if (!img) return;
      img.classList.add('slydr-card-float');
      img.style.setProperty('--slydr-float-delay', -(index * 0.9) / 1.15 + 's');
      floatImgs.push(img);
    });

    /* Pause floats that are off-screen so a 24-card grid does not keep 24 transforms alive. */
    if (floatImgs.length && typeof IntersectionObserver !== 'undefined') {
      var floatIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
          });
        },
        { rootMargin: '80px 0px' }
      );
      floatImgs.forEach(function (img) {
        img.classList.add('is-offscreen');
        floatIo.observe(img);
      });
    }

    /* Neon frame + product content pulses: same off-screen freeze. */
    if (typeof IntersectionObserver !== 'undefined') {
      var pulseIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle('slydr-fx-dormant', !entry.isIntersecting);
          });
        },
        { rootMargin: '120px 0px' }
      );
      document
        .querySelectorAll(
          '.slydr-neon-frame, body.template-product #MainContent > .shopify-section:not([id*="__main"]) animate-image, body.template-product #MainContent > .shopify-section:not([id*="__main"]) .image-block, body.template-product #MainContent > .shopify-section:not([id*="__main"]) deferred-media, body.template-product #MainContent > .shopify-section.slide-wrapper .slideshow'
        )
        .forEach(function (el) {
          pulseIo.observe(el);
        });
    }
  }

  start();
})();
